/*
================================================================ 
     Copyright (c) 2018-2021 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import { TableContainer, useMediaQuery, useTheme } from "@mui/material";

import actionTypes from "../../../store/actions";
import classes from "./createPackage.module.css";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";

//table
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";

//materail UI components
import Chip from "@mui/material/Chip";
import { Divider, Toolbar } from "@mui/material";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Input from "../../../component/inputpm";
import Button from "../../../component/button";
import PackageTemplate from "./packageTemplate";
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import jp from "jsonpath";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import ComponentVariants from "./componentVariants";
import Switch from "@mui/material/Switch";
import {
  RangeIcon,
  ExactIcon,
  PlusIcon,
  UpIcon,
  DownIcon,
  ViewIcon,
  ViewIconNew,
  EnterArrow,
} from "../../../component/icons/icons";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import UnsavedChangesWarning from "../../../helper/unsavedChangesWarning";
import AssemblyInstructions from "../component/assemblyInstructions";
import { LooksOneOutlined, FilterNoneOutlined } from "@mui/icons-material";
import ComponentDialog from "../component/componentDialog";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import currencyFormatter from "../../../helper/currencyFormatter";
import PreQualificationModule from "./preQualificationModule";
import EnrichmentConfig from "../component/enrichmentConfig";
import { Collapse } from "@mui/material";
import CustomAttributes from "../component/customAttributes";
import UnsavedDependencyWarning from "../../../helper/unsavedDependencyWarning";
import ComponentBOM from "./componentBOM";
import Draggable from "react-draggable";
import ViewProductDetails from "./viewProductDetails";
import CloseIcon from "@mui/icons-material/Close";
import ManageCustomersHierarchy from "../../sales/manageCustomers/manageCustomersHierarchy";
// import TextEditor from "../../../component/richTextEditor";
import TiptapEditor from "../../../component/richTextEditor/TiptapEditor.js";
import classes1 from "../../sales/manageCustomers/customers.module.css";
import Card from "@mui/material/Card";
import moment from "moment";
import Box from "@mui/material/Box";
//icons
import {
  DeleteIconNew,
  EditIconNew,
  ClipboardWithGear,
} from "../../../component/icons/icons.js";
//popper
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import { Menu, MenuItem } from "@mui/material";
import { ListItemText, List, ListItem, ListItemButton } from "@mui/material";
import TextField from "@mui/material/TextField";
// import { makeStyles } from '@mui/styles';

import Drawer from "@mui/material/Drawer";
import { ChevronLeft } from "@mui/icons-material";
import { alpha, styled } from "@mui/material/styles";
import ComponentComments from "../component/componentComments";
import Split from 'react-split';
// removed legacy makeStyles usage for MUI v7 compatibility

import OfferingProductSpecCharacteristicsDialog from "../component/specification/offeringProductSpecCharacteristicsDialog.js";
import OfferingProductSpecCharacteristicsExistingDialog from "../component/specification/offeringProductSpecCharacteristicsExistingDialog.js";

const AssociatedBucket = (props) => {
  const t = props.t;
  const [dialogErrorMsg, setDialogErrorMsg] = useState("");
  const today = moment(new Date()).format("yyyy-MM-DD");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [stateChangeDialog, setStateChangeDialog] = useState(false);
  const [stateChangeDialogAction, setStateChangeDialogAction] = useState(false);
  const [stateChangeRadioResponse, setStateChangeRadioResponse] = useState();
  const [selectedCharacteristics, setSelectedCharacteristics] = useState();
  const [dependencyError, setDependencyError] = useState({});

  const StyledNavListItem = styled(ListItem, {
    shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'themeColor',
  })(({ theme, isSelected, themeColor }) => ({
    borderRadius: isSelected ? '0px 6px 6px 0px' : theme.shape.borderRadius,
    borderLeft: `2px solid ${isSelected ? themeColor : 'transparent'}`,
    fontWeight: isSelected ? 'bold' : 'normal',
    color: isSelected ? themeColor : 'inherit',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: alpha(themeColor, 0.12),
      color: themeColor,
    },
  }));
  const handleClick = (event, row) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setOpenPopper(!openPopper);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setOpenPopper(false);
    setAnchorEl(null);
  };

  const [componentDataCopy, setComponentDataCopy] = useState({
    add: false,
    chipData: [],
    dependsOn: [],
    relationShips: {},

    //fields
    id: "",
    name: "",
    localisedName: [],
    price: "",
    quantity: "",
    priceType: "",
    featureCode: "",
    description: "",
    componentType: "",
    displaySequence: "",
    originalProviderId: "",
    inventoryItemAndDetail: [],

    depender: "",
    dependerProviderType: "",

    //attributes
    mandatory: false,
    customerViewable: false,
    physical: false,
    quantityModifiable: false,

    //variants
    variants: [],
    expandVariants: false,
    // dependency data
    tempDependency: {
      dependerBucketName: "",
      depender: "",
      dependerProviderType: "",
      dependerName: "",
      cardinality: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      quantity: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      dependencyType: "Mandatory",
    },
    selectedBucketComponents: [],
    tempQuantityValue: false,
    hasVariant: false,
    expandEnrichment: false,
    characteristics: [],
    productSpec: {},
  });

  const [componentData, setComponentData] = useState({
    add: false,
    chipData: [],
    dependsOn: [],
    relationShips: {},

    //fields
    id: "",
    name: "",
    price: "",
    quantity: "",
    priceType: "",
    featureCode: "",
    description: "",
    componentType: "",
    displaySequence: "",
    originalProviderId: "",
    inventoryItemAndDetail: [],
    depender: "",
    dependerProviderType: "",

    //attributes
    mandatory: false,
    customerViewable: false,
    physical: false,
    quantityModifiable: false,

    //variants
    variants: [],
    expandVariants: false,
    // dependency data
    tempDependency: {
      dependerBucketName: "",
      depender: "",
      dependerProviderType: "",
      dependerName: "",
      cardinality: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      quantity: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      dependencyType: "Mandatory",
    },
    selectedBucketComponents: [],
    tempQuantityValue: false,
    hasVariant: false,
    language: "en_US",
    allOtherPricesList: [
      {
        name: "DEPOSIT_PRICE",
        value: "DEPOSIT",
        disabled: false,
      },
      {
        name: "CANCELLATION_PRICE",
        value: "CANCELLATION_PRICE",
        disabled: false,
      },
      {
        name: "SHIFT_PRICE",
        value: "SHIFT_PRICE",
        disabled: false,
      },
      {
        name: "SUSPENSION_PRICE",
        value: "SUSPENSION_PRICE",
        disabled: false,
      },
      {
        name: "REACTIVATION_PRICE",
        value: "REACTIVATION_PRICE",
        disabled: false,
      },
      {
        name: "USAGE_CHARGE",
        value: "USAGE_CHARGE",
        disabled: false,
      },
    ],
    priceOptions: [],
    characteristics: [],
    productSpec: {},
  });

  const [isAuxiliary, setIsAuxiliary] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showAddItem, setShowAddItem] = useState(false);
  const [language, setLanguage] = useState("en_US");
  const [showEditComponentDialog, toggleEditComponentDialog] = useState(false);
  const [initialMargin, updateInitialMargin] = useState(0);
  const [salesMargin, updateSalesMargin] = useState(0);
  const [initialMinimumMargin, updateMinimumMargin] = useState(0);
  const [isMarginChanged, setMarginChanged] = useState(false);
  const [markupWarning, setMarkupWarning] = useState(false);
  const [tempMarginValues, setTempMarginValues] = useState({});

  const [saveAsOfferingDialog, setSaveAsOfferingDialog] = useState(false);

  const [openTreeDialog, setOpenTreeDialog] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState(null);
  // Open tree dialog
  const handleOpenTreeDialog = (row, index) => {
    row.language = "en_US";
    setTempEditRow(row);
    setSelectedProductId(row.id);
    setSelectedProductName(row.name);
    setComponentFormDetails(row, "editExisting");
    setOpenTreeDialog(true);
  };
  // Close tree dialog
  const handleCloseTreeDialog = () => {
    setOpenTreeDialog(false);
    setSelectedProductId(null);
    setSelectedProductName(null);
  };

  const updateMargin = (val, type) => {
    var p =
      val.indexOf(".") >= 0
        ? val.substr(0, val.indexOf(".")) + val.substr(val.indexOf("."), 3)
        : val;
    if (type === "min") {
      updateMinimumMargin(p);
    } else if (type === "rec") {
      updateInitialMargin(p);
    } else {
      updateSalesMargin(p);
    }
    setMarginChanged(true);
  };

  const applyMargin = () => {
    setMarginChanged(false);
    var data = { ...componentData };
    console.log("check 1", data);
    if (props.tenantRoles.includes("CHILD_PROVIDER")) {
      if (
        props.tenantRoles.includes("CHILD_PROVIDER") &&
        props.tenantInfo.tenantId === componentData.originalProviderId
      ) {
        if (Number(initialMargin) < Number(initialMinimumMargin)) {
          const err = {};
          err.initialMargin = t("RECOMMENDED_MARKUP_ERROR");
          setErrorr(err);
          return;
        }
      }
      if (Number(salesMargin) >= Number(initialMinimumMargin)) {
      } else {
        const err = {};
        err.salesMargin = t("SALES_MARKUP_ERROR");
        setErrorr(err);
        return;
      }

      var mr =
        (Number(
          componentData.originalPrice
            ? componentData.originalPrice
            : componentData.partnerPrice,
        ) *
          Number(salesMargin)) /
        100;
      var newPrice =
        Math.round(
          (Number(
            componentData.originalPrice
              ? componentData.originalPrice
              : componentData.partnerPrice,
          ) +
            mr) *
          (1 + Number.EPSILON) *
          100,
        ) / 100;
      data.price = "" + newPrice.toFixed(2);
      if (componentData.otherPrices && componentData.otherPrices.length > 0) {
        for (var p = 0; p < componentData.otherPrices.length; p++) {
          var pmr =
            (Number(componentData.otherPrices[p].originalPrice) *
              Number(salesMargin)) /
            100;
          var newOtherPrice =
            Math.round(
              (Number(componentData.otherPrices[p].originalPrice) + pmr) *
              (1 + Number.EPSILON) *
              100,
            ) / 100;
          componentData.otherPrices[p].price = "" + newOtherPrice.toFixed(2);

          if (props.tenantInfo.tenantId === componentData.originalProviderId) {
            if (initialMinimumMargin && initialMinimumMargin >= 0) {
              var pmrm =
                (Number(componentData.otherPrices[p].originalPrice) *
                  Number(initialMinimumMargin)) /
                100;
              // var newOtherPricem = (Number(componentData.otherPrices[p].originalPrice) + pmrm).toFixed(2);
              var newOtherPricem =
                Math.round(
                  (Number(componentData.otherPrices[p].originalPrice) + pmrm) *
                  (1 + Number.EPSILON) *
                  100,
                ) / 100;
              componentData.otherPrices[p].minimumPrice =
                "" + newOtherPricem.toFixed(2);
            }
            if (initialMargin && initialMargin >= 0) {
              var pmrmg =
                (Number(componentData.otherPrices[p].originalPrice) *
                  Number(initialMargin)) /
                100;
              // var newOtherPricemg = (Number(componentData.otherPrices[p].originalPrice) + pmrmg).toFixed(2);
              var newOtherPricemg =
                Math.round(
                  (Number(componentData.otherPrices[p].originalPrice) + pmrmg) *
                  (1 + Number.EPSILON) *
                  100,
                ) / 100;
              componentData.otherPrices[p].groupPrice =
                "" + newOtherPricemg.toFixed(2);
            }
            if (salesMargin && salesMargin >= 0) {
              var pmrmg =
                (Number(componentData.otherPrices[p].originalPrice) *
                  Number(salesMargin)) /
                100;
              // var newOtherPricemg = (Number(componentData.otherPrices[p].originalPrice) + pmrmg).toFixed(2);
              var newOtherPricemg =
                Math.round(
                  (Number(componentData.otherPrices[p].originalPrice) + pmrmg) *
                  (1 + Number.EPSILON) *
                  100,
                ) / 100;
              componentData.otherPrices[p].price =
                "" + newOtherPricemg.toFixed(2);
            }
          }
        }
      }

      // variants markup calc
      // variant prices
      if (data.variants && data.variants.length > 0) {
        for (var v = 0; v < data.variants.length; v++) {
          if (salesMargin >= 0) {
            var vmr =
              (Number(
                data.variants[v].originalPrice
                  ? data.variants[v].originalPrice
                  : data.variants[v].partnerPrice,
              ) *
                Number(salesMargin)) /
              100;
            // var newVPrice = (Number(data.variants[v].originalPrice ? data.variants[v].originalPrice : data.variants[v].partnerPrice) + vmr).toFixed(2);
            var newVPrice =
              Math.round(
                (Number(
                  data.variants[v].originalPrice
                    ? data.variants[v].originalPrice
                    : data.variants[v].partnerPrice,
                ) +
                  vmr) *
                (1 + Number.EPSILON) *
                100,
              ) / 100;
            data.variants[v].price = "" + newVPrice.toFixed(2);
          }
          if (props.tenantInfo.tenantId === componentData.originalProviderId) {
            if (initialMinimumMargin && initialMinimumMargin >= 0) {
              var vmrm =
                (Number(data.variants[v].originalPrice) *
                  Number(initialMinimumMargin)) /
                100;
              // var newVPricem = (Number(data.variants[v].originalPrice) + vmrm).toFixed(2);
              var newVPricem =
                Math.round(
                  (Number(data.variants[v].originalPrice) + vmrm) *
                  (1 + Number.EPSILON) *
                  100,
                ) / 100;
              data.variants[v].minimumPrice = "" + newVPricem.toFixed(2);
            }
            if (initialMargin && initialMargin >= 0) {
              var vpmrmg =
                (Number(data.variants[v].originalPrice) *
                  Number(initialMargin)) /
                100;
              // var vnewOtherPricemg = (Number(data.variants[v].originalPrice) + vpmrmg).toFixed(2);
              var vnewOtherPricemg =
                Math.round(
                  (Number(data.variants[v].originalPrice) + vpmrmg) *
                  (1 + Number.EPSILON) *
                  100,
                ) / 100;
              data.variants[v].groupPrice = "" + vnewOtherPricemg.toFixed(2);
            }
          }
          if (
            data.variants[v].otherPrices &&
            data.variants[v].otherPrices.length > 0
          ) {
            for (var op = 0; op < data.variants[v].otherPrices.length; op++) {
              if (salesMargin >= 0) {
                var ovmr =
                  (Number(
                    data.variants[v].otherPrices[op].originalPrice
                      ? data.variants[v].otherPrices[op].originalPrice
                      : data.variants[v].otherPrices[op].partnerPrice,
                  ) *
                    Number(salesMargin)) /
                  100;
                // var newOVPrice = (Number(data.variants[v].otherPrices[op].originalPrice ? data.variants[v].otherPrices[op].originalPrice : data.variants[v].otherPrices[op].partnerPrice) + ovmr).toFixed(2);
                var newOVPrice =
                  Math.round(
                    (Number(
                      data.variants[v].otherPrices[op].originalPrice
                        ? data.variants[v].otherPrices[op].originalPrice
                        : data.variants[v].otherPrices[op].partnerPrice,
                    ) +
                      ovmr) *
                    (1 + Number.EPSILON) *
                    100,
                  ) / 100;
                data.variants[v].otherPrices[op].price =
                  "" + newOVPrice.toFixed(2);
              }
              if (
                props.tenantInfo.tenantId === componentData.originalProviderId
              ) {
                if (initialMinimumMargin && initialMinimumMargin >= 0) {
                  var ovmrm =
                    (Number(
                      data.variants[v].otherPrices[op].originalPrice
                        ? data.variants[v].otherPrices[op].originalPrice
                        : data.variants[v].otherPrices[op].partnerPrice,
                    ) *
                      Number(initialMinimumMargin)) /
                    100;
                  // var newOVPricem = (Number(data.variants[v].otherPrices[op].originalPrice ? data.variants[v].otherPrices[op].originalPrice : data.variants[v].otherPrices[op].partnerPrice) + ovmrm).toFixed(2);
                  var newOVPricem =
                    Math.round(
                      (Number(
                        data.variants[v].otherPrices[op].originalPrice
                          ? data.variants[v].otherPrices[op].originalPrice
                          : data.variants[v].otherPrices[op].partnerPrice,
                      ) +
                        ovmrm) *
                      (1 + Number.EPSILON) *
                      100,
                    ) / 100;
                  data.variants[v].otherPrices[op].minimumPrice =
                    "" + newOVPricem.toFixed(2);
                }
                if (initialMargin && initialMargin >= 0) {
                  var ovpmrmg =
                    (Number(data.variants[v].otherPrices[op].originalPrice) *
                      Number(initialMargin)) /
                    100;
                  // var ovnewOtherPricemg = (Number(data.variants[v].otherPrices[op].originalPrice) + ovpmrmg).toFixed(2);
                  var ovnewOtherPricemg =
                    Math.round(
                      (Number(data.variants[v].otherPrices[op].originalPrice) +
                        ovpmrmg) *
                      (1 + Number.EPSILON) *
                      100,
                    ) / 100;
                  data.variants[v].otherPrices[op].groupPrice =
                    "" + ovnewOtherPricemg.toFixed(2);
                }
              }
            }
          }
        }
      }

      if (props.tenantInfo.tenantId === componentData.originalProviderId) {
        var newPriceMargin =
          (Number(
            componentData.originalPrice
              ? componentData.originalPrice
              : componentData.partnerPrice,
          ) *
            Number(salesMargin)) /
          100;
        // var newPriceVal = (Number(componentData.originalPrice ? componentData.originalPrice : componentData.partnerPrice) + newPriceMargin).toFixed(2);
        var newPriceVal =
          Math.round(
            (Number(
              componentData.originalPrice
                ? componentData.originalPrice
                : componentData.partnerPrice,
            ) +
              newPriceMargin) *
            (1 + Number.EPSILON) *
            100,
          ) / 100;
        data.price = "" + newPriceVal.toFixed(2);

        var mGr =
          (Number(
            componentData.originalPrice
              ? componentData.originalPrice
              : componentData.partnerPrice,
          ) *
            Number(initialMargin)) /
          100;
        // var newGroupPrice = (Number(componentData.originalPrice ? componentData.originalPrice : componentData.partnerPrice) + mGr).toFixed(2);
        var newGroupPrice =
          Math.round(
            (Number(
              componentData.originalPrice
                ? componentData.originalPrice
                : componentData.partnerPrice,
            ) +
              mGr) *
            (1 + Number.EPSILON) *
            100,
          ) / 100;
        data.groupPrice = "" + newGroupPrice.toFixed(2);

        if (initialMinimumMargin && initialMinimumMargin >= 0) {
          var mrm =
            (Number(componentData.originalPrice) *
              Number(initialMinimumMargin)) /
            100;
          // var newPricem = (Number(componentData.originalPrice) + mrm).toFixed(2);
          var newPricem =
            Math.round(
              (Number(componentData.originalPrice) + mrm) *
              (1 + Number.EPSILON) *
              100,
            ) / 100;
          data.minimumPrice = "" + newPricem.toFixed(2);
        }
      }

      setComponentData(data);
    } else {
      if (Number(initialMargin) < Number(initialMinimumMargin)) {
        // const err = {};
        // err.initialMargin = t('RECOMMENDED_MARKUP_ERROR');
        // setErrorr(err);
        // return;
        setErrorr((prevErr) => ({
          ...prevErr, // Keep the existing properties
          initialMargin: t("RECOMMENDED_MARKUP_ERROR"), // Update only initialMargin
        }));
        return;
      }
      if (initialMargin >= 0) {
        if (componentData.otherPrices && componentData.otherPrices.length > 0) {
          for (var p = 0; p < componentData.otherPrices.length; p++) {
            var pmr =
              (Number(
                componentData.otherPrices[p].originalPrice
                  ? componentData.otherPrices[p].originalPrice
                  : componentData.otherPrices[p].partnerPrice,
              ) *
                Number(initialMargin)) /
              100;
            // var newOtherPrice = (Number(componentData.otherPrices[p].originalPrice ? componentData.otherPrices[p].originalPrice : componentData.otherPrices[p].partnerPrice) + pmr).toFixed(2);
            var newOtherPrice =
              Math.round(
                (Number(
                  componentData.otherPrices[p].originalPrice
                    ? componentData.otherPrices[p].originalPrice
                    : componentData.otherPrices[p].partnerPrice,
                ) +
                  pmr) *
                (1 + Number.EPSILON) *
                100,
              ) / 100;
            componentData.otherPrices[p].price = "" + newOtherPrice.toFixed(2);
            if (props.tenantRoles.includes("CHILD_PROVIDER")) {
            } else {
              if (initialMinimumMargin && initialMinimumMargin >= 0) {
                // var pmrm = Number(componentData.otherPrices[p].partnerPrice) * Number(initialMinimumMargin) / 100;
                var pmrm =
                  (Number(componentData.otherPrices[p].originalPrice) *
                    Number(initialMinimumMargin)) /
                  100;
                // var newOtherPricem = (Number(componentData.otherPrices[p].partnerPrice) + pmrm).toFixed(2);
                // var newOtherPricem = (Number(componentData.otherPrices[p].originalPrice) + pmrm).toFixed(2);
                var newOtherPricem =
                  Math.round(
                    (Number(componentData.otherPrices[p].originalPrice) +
                      pmrm) *
                    (1 + Number.EPSILON) *
                    100,
                  ) / 100;
                componentData.otherPrices[p].minimumPrice =
                  "" + newOtherPricem.toFixed(2);
              }
            }
          }
        }
        var mr =
          (Number(
            componentData.originalPrice
              ? componentData.originalPrice
              : componentData.partnerPrice,
          ) *
            Number(initialMargin)) /
          100;
        var newPrice = (
          Number(
            componentData.originalPrice
              ? componentData.originalPrice
              : componentData.partnerPrice,
          ) + mr
        ).toFixed(2);
        data.price = "" + newPrice;
        if (props.tenantRoles.includes("CHILD_PROVIDER")) {
        } else {
          if (initialMinimumMargin && initialMinimumMargin >= 0) {
            // var mrm = Number(componentData.partnerPrice) * Number(initialMinimumMargin) / 100;
            var mrm =
              (Number(componentData.originalPrice) *
                Number(initialMinimumMargin)) /
              100;
            // var newPricem = (Number(componentData.partnerPrice) + mrm).toFixed(2);
            // var newPricem = (Number(componentData.originalPrice) + mrm).toFixed(2);
            var newPricem =
              Math.round(
                (Number(componentData.originalPrice) + mrm) *
                (1 + Number.EPSILON) *
                100,
              ) / 100;
            data.minimumPrice = "" + newPricem.toFixed(2);
          }
        }

        setComponentData(data);
      }
      if (props.tenantRoles.includes("CHILD_PROVIDER")) {
      } else {
        if (initialMinimumMargin && initialMinimumMargin >= 0) {
          if (
            componentData.otherPrices &&
            componentData.otherPrices.length > 0
          ) {
            for (var p = 0; p < componentData.otherPrices.length; p++) {
              if (initialMinimumMargin && initialMinimumMargin >= 0) {
                // var pmrm = Number(componentData.otherPrices[p].partnerPrice) * Number(initialMinimumMargin) / 100;
                var pmrm =
                  (Number(componentData.otherPrices[p].originalPrice) *
                    Number(initialMinimumMargin)) /
                  100;
                // var newOtherPricem = (Number(componentData.otherPrices[p].partnerPrice) + pmrm).toFixed(2);
                // var newOtherPricem = (Number(componentData.otherPrices[p].originalPrice) + pmrm).toFixed(2);
                var newOtherPricem =
                  Math.round(
                    (Number(componentData.otherPrices[p].originalPrice) +
                      pmrm) *
                    (1 + Number.EPSILON) *
                    100,
                  ) / 100;
                componentData.otherPrices[p].minimumPrice =
                  "" + newOtherPricem.toFixed(2);
              }
            }
          }
          if (initialMinimumMargin && initialMinimumMargin >= 0) {
            // var mrm = Number(componentData.partnerPrice) * Number(initialMinimumMargin) / 100;
            var mrm =
              (Number(componentData.originalPrice) *
                Number(initialMinimumMargin)) /
              100;
            // var newPricem = (Number(componentData.partnerPrice) + mrm).toFixed(2);
            // var newPricem = (Number(componentData.originalPrice) + mrm).toFixed(2);
            var newPricem =
              Math.round(
                (Number(componentData.originalPrice) + mrm) *
                (1 + Number.EPSILON) *
                100,
              ) / 100;
            data.minimumPrice = "" + newPricem.toFixed(2);
          }
          setComponentData(data);
        } else {
          if (
            componentData.otherPrices &&
            componentData.otherPrices.length > 0
          ) {
            for (var p = 0; p < componentData.otherPrices.length; p++) {
              // componentData.otherPrices[p].minimumPrice = "";
              componentData.otherPrices[p].minimumPrice = componentData
                .otherPrices[p].originalPrice
                ? componentData.otherPrices[p].originalPrice
                : "";
            }
          }
          // data.minimumPrice = "";
          setComponentData(data);
        }
      }

      // variants markup calc
      // variant prices
      if (data.variants && data.variants.length > 0) {
        for (var v = 0; v < data.variants.length; v++) {
          if (initialMargin >= 0) {
            var vmr =
              (Number(
                data.variants[v].originalPrice
                  ? data.variants[v].originalPrice
                  : data.variants[v].partnerPrice,
              ) *
                Number(initialMargin)) /
              100;
            // var newVPrice = (Number(data.variants[v].originalPrice ? data.variants[v].originalPrice : data.variants[v].partnerPrice) + vmr).toFixed(2);
            var newVPrice =
              Math.round(
                (Number(
                  data.variants[v].originalPrice
                    ? data.variants[v].originalPrice
                    : data.variants[v].partnerPrice,
                ) +
                  vmr) *
                (1 + Number.EPSILON) *
                100,
              ) / 100;
            data.variants[v].price = "" + newVPrice.toFixed(2);
          }

          if (props.tenantRoles.includes("CHILD_PROVIDER")) {
          } else {
            if (initialMinimumMargin && initialMinimumMargin >= 0) {
              var vmrm =
                (Number(data.variants[v].originalPrice) *
                  Number(initialMinimumMargin)) /
                100;
              // var newVPricem = (Number(data.variants[v].originalPrice) + vmrm).toFixed(2);
              var newVPricem =
                Math.round(
                  (Number(data.variants[v].originalPrice) + vmrm) *
                  (1 + Number.EPSILON) *
                  100,
                ) / 100;
              data.variants[v].minimumPrice = "" + newVPricem.toFixed(2);
            }
          }
          if (
            data.variants[v].otherPrices &&
            data.variants[v].otherPrices.length > 0
          ) {
            for (var op = 0; op < data.variants[v].otherPrices.length; op++) {
              if (initialMargin >= 0) {
                var ovmr =
                  (Number(
                    data.variants[v].otherPrices[op].originalPrice
                      ? data.variants[v].otherPrices[op].originalPrice
                      : data.variants[v].otherPrices[op].partnerPrice,
                  ) *
                    Number(initialMargin)) /
                  100;
                // var newOVPrice = (Number(data.variants[v].otherPrices[op].originalPrice ? data.variants[v].otherPrices[op].originalPrice : data.variants[v].otherPrices[op].partnerPrice) + ovmr).toFixed(2);
                var newOVPrice =
                  Math.round(
                    (Number(
                      data.variants[v].otherPrices[op].originalPrice
                        ? data.variants[v].otherPrices[op].originalPrice
                        : data.variants[v].otherPrices[op].partnerPrice,
                    ) +
                      ovmr) *
                    (1 + Number.EPSILON) *
                    100,
                  ) / 100;
                data.variants[v].otherPrices[op].price =
                  "" + newOVPrice.toFixed(2);
              }
              if (props.tenantRoles.includes("CHILD_PROVIDER")) {
              } else {
                if (initialMinimumMargin && initialMinimumMargin >= 0) {
                  var ovmrm =
                    (Number(
                      data.variants[v].otherPrices[op].originalPrice
                        ? data.variants[v].otherPrices[op].originalPrice
                        : data.variants[v].otherPrices[op].partnerPrice,
                    ) *
                      Number(initialMinimumMargin)) /
                    100;
                  // var newOVPricem = (Number(data.variants[v].otherPrices[op].originalPrice ? data.variants[v].otherPrices[op].originalPrice : data.variants[v].otherPrices[op].partnerPrice) + ovmrm).toFixed(2);
                  var newOVPricem =
                    Math.round(
                      (Number(
                        data.variants[v].otherPrices[op].originalPrice
                          ? data.variants[v].otherPrices[op].originalPrice
                          : data.variants[v].otherPrices[op].partnerPrice,
                      ) +
                        ovmrm) *
                      (1 + Number.EPSILON) *
                      100,
                    ) / 100;
                  data.variants[v].otherPrices[op].minimumPrice =
                    "" + newOVPricem.toFixed(2);
                }
              }
            }
          }
        }
      }
    }
  };

  const closeMarkupWarning = (val) => {
    if (val) {
      console.log("check values", tempMarginValues);
      if (props.tenantRoles.includes("CHILD_PROVIDER")) {
        if (tempMarginValues && tempMarginValues.groupMarginValue) {
          updateInitialMargin(tempMarginValues.groupMarginValue);
        } else {
          updateInitialMargin("0");
        }
        if (tempMarginValues && tempMarginValues.marginValue) {
          updateSalesMargin(tempMarginValues.marginValue);
        } else {
          updateSalesMargin("0");
        }
      } else {
        if (tempMarginValues && tempMarginValues.marginValue) {
          updateInitialMargin(tempMarginValues.marginValue);
        } else {
          updateInitialMargin("0");
        }
      }
      if (tempMarginValues && tempMarginValues.minimumMarginValue) {
        updateMinimumMargin(tempMarginValues.minimumMarginValue);
      } else {
        updateMinimumMargin("0");
      }
      setComponentData({
        ...componentData,
        margin: tempMarginValues,
      });
      setTempMarginValues({});
      setMarginChanged(false);
      setMarkupWarning(false);
      // if (isEdit) {
      // 	updateBucketItem();
      // } else {
      // 	addBucketItem();
      // }
    } else {
      setMarkupWarning(false);
    }
  };

  const mandatoryMessageSecond = {
    color: "#f44336",
    fontSize: "12px",
  };
  const [showAssemblyInstructions, setAssemblyInstructions] = useState(false);
  useEffect(() => {
    // for (var i = 0; i < props.components.length; i++) {
    // 	if (props.components[i].physical) {
    // 		setAssemblyInstructions(true);
    // 		break;
    // 	}
    // }
    if (props.providerType !== "SALES_CHNL_PROVIDER") {
      changeTab(showAssemblyInstructions ? 1 : 2);
    }
    getResources("ACTIVATION");
    getResources("PROVISIONING");
    getResources("SUBSCRIPTION_SUSPEND");
    getResources("SUBSCRIPTION_RESUME");
    // getResources("QUALIFICATION");
    filterCustomAttributes();

    //check if bucket is AUX
    const isAuxiliary = props.globalProducts.some((product) => {
      if (product.id === props.selectedBucketId) {
        return true;
      }
      return false;
    });
    setIsAuxiliary(isAuxiliary);
  }, []);

  //method called for all input fileds
  const onChange = (e) => {
    if (e.target.name === "name" && e.target.value.length > 100) {
      props.setErrorMessage(t("MAX_100_CHARACTER_ERROR"), false);
    } else {
      if (e.target.name == "name" || e.target.name == "description") {
        setInputTextBasedOnLocale(e, e.target.name);
      }
      props.setErrorMessage("", false);
      if (e.target.name === "price" || e.target.name === "minimumPrice") {
        // if (e.target.value >= 0) {
        // 	setComponentData({
        // 		...componentData,
        // 		[e.target.name]: e.target.value,
        // 	});
        // }
        if (e.target.value >= 0) {
          let t = e.target.value;
          let tPrice =
            t.indexOf(".") >= 0
              ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
              : t;
          setComponentData({
            ...componentData,
            [e.target.name]: tPrice,
          });
        } else {
          setComponentData({
            ...componentData,
            [e.target.name]: 0,
          });
        }
      } else {
        setComponentData({
          ...componentData,
          [e.target.name]:
            e.target.name === "mandatory" ||
              e.target.name === "quantityModifiable" ||
              e.target.name === "customerViewable" ||
              e.target.name === "physical"
              ? e.target.checked
              : e.target.value,
        });
      }
    }
  };

  const onLanguageChange = (e) => {
    setLanguage(e.target.value);
    let data = { ...componentData };
    if (data.localisedName) {
      var index = data.localisedName.findIndex(
        (x) => x.locale === e.target.value,
      );
      if (index > -1) {
        data.name = data.localisedName[index].text;
      } else {
        data.name = "";
      }
    }
    if (data.localisedDesc) {
      var index = data.localisedDesc.findIndex(
        (x) => x.locale === e.target.value,
      );
      if (index > -1) {
        data.description = data.localisedDesc[index].text;
      } else {
        data.description = "";
      }
    }
    setComponentData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const setInputTextBasedOnLocale = (e, targetName) => {
    let value = {};
    let tempData = { ...componentData };
    if (e.target.name === "name") {
      targetName = "localisedName";
    } else if (e.target.name === "description") {
      targetName = "localisedDesc";
    }

    const hasLocale = tempData[targetName].some((obj) => {
      if (obj.locale === language) {
        return true;
      }
    });
    if (!hasLocale) {
      value = {
        locale: language,
        text: e.target.value,
      };
      tempData[targetName].push(value);
    } else {
      var index = tempData[targetName].findIndex((x) => x.locale === language);
      tempData[targetName][index].text = e.target.value;
    }
  };
  //dialog to open package template
  const [packageTemplateDialog, openPackageTemplateDialog] = useState(false);
  const openTemplateDialog = () => {
    openPackageTemplateDialog(true);
  };

  const setComponentFormDetails = (item, action) => {
    if (item) {
      if (item.otherPrices && item.otherPrices.length > 0) {
        for (var o = 0; o < item.otherPrices.length; o++) {
          // item.otherPrices[o].price = "" + Number(item.otherPrices[o].price).toFixed(2);
          if (item.otherPrices[o].partnerPrice) {
            // item.otherPrices[o].partnerPrice = '' + Number(item.otherPrices[o].partnerPrice).toFixed(2);
            item.otherPrices[o].partnerPrice =
              Math.round(
                Number(item.otherPrices[o].partnerPrice) *
                (1 + Number.EPSILON) *
                100,
              ) / 100;
          } else {
            // item.otherPrices[o].partnerPrice = "" + Number(item.otherPrices[o].price).toFixed(2);
            item.otherPrices[o].partnerPrice =
              Math.round(
                Number(item.otherPrices[o].price) * (1 + Number.EPSILON) * 100,
              ) / 100;
          }
          if (item.otherPrices[o].originalPrice) {
            item.otherPrices[o].originalPrice =
              item.otherPrices[o].originalPrice;
          } else {
            item.otherPrices[o].originalPrice = item.otherPrices[o].price;
          }
          if (item.otherPrices[o].minimumPrice) {
            // item.otherPrices[o].minimumPrice = "" + Number(item.otherPrices[o].minimumPrice).toFixed(2);
            item.otherPrices[o].minimumPrice =
              (Math.round(
                Number(item.otherPrices[o].minimumPrice) *
                (1 + Number.EPSILON) *
                100,
              ) / 100).toFixed(2);
          } else {
            // item.otherPrices[o].minimumPrice = "" + Number(item.otherPrices[o].price).toFixed(2);
            item.otherPrices[o].minimumPrice =
              (Math.round(
                Number(item.otherPrices[o].price) * (1 + Number.EPSILON) * 100,
              ) / 100).toFixed(2);
          }
          // item.otherPrices[o].price = "" + Number(item.otherPrices[o].price).toFixed(2);
          // item.otherPrices[o].price = (Math.round((Number(item.otherPrices[o].price) * (1 + Number.EPSILON)) * 100) / 100).toFixed(2);
          // if (item.otherPrices[o].originalMinimumPrice) { } else {
          // 	if (item.otherPrices[o].minimumPrice) {
          // 		item.otherPrices[o].originalMinimumPrice = "" + item.otherPrices[o].minimumPrice;
          // 	} else {
          // 		item.otherPrices[o].originalMinimumPrice = "";
          // 	}
          // }
          // if (item.otherPrices[o].minimumPrice) { } else {
          // 	// item.otherPrices[o].minimumPrice = "";
          // 	item.otherPrices[o].minimumPrice = item.otherPrices[o].originalMinimumPrice ? item.otherPrices[o].originalMinimumPrice : '';
          // }
          item.otherPrices[o].price = Number(item.otherPrices[o].price).toFixed(2);
          // item.otherPrices[o].price =
          //   Math.round(
          //     Number(item.otherPrices[o].price) * (1 + Number.EPSILON) * 100,
          //   ) / 100;
        }
      }
      var providerInfo = {};
      if (props.addToCatalog === "true") {
        providerInfo = {
          originalProviderId: item.originalProviderId,
          originalProviderName: item.originalProviderName,
          originalProviderType: item.originalProviderType,
        };
      }
      if (item.priceType === "NTC") {
        setComponentData({
          ...componentData,
          componentTypeName: item?.componentTypeName,
          statusDisplayName: props.state.statusDisplayName,
          status: props.state.status,

          add: item.add ? item.add : false,
          id: item.id,
          name: item.name,
          price: Number(item.price).toFixed(2) + "",
          partnerPrice: item.partnerPrice
            ? Number(item.partnerPrice).toFixed(2) + ""
            : Number(item.price).toFixed(2) + "",
          minimumPrice: item.minimumPrice
            ? Number(item.minimumPrice).toFixed(2) + ""
            : "",
          originalMinimumPrice: item.originalMinimumPrice
            ? Number(item.originalMinimumPrice).toFixed(2) + ""
            : "",
          quantity: item.quantity,
          priceType: item.priceType,
          description: item.description,
          featureCode: item.featureCode,
          componentType: item.componentType,
          displaySequence: item.displaySequence,
          componentProviderType:
            action === "editExisting"
              ? item.componentProviderType
              : item.fromProviderType,
          existing:
            action === "selectExisting"
              ? true
              : action === "editExisting"
                ? item.existing
                : false,
          chipData: action === "selectExisting" ? [] : item.chipData,
          dependsOn: action === "selectExisting" ? [] : item.dependsOn,
          relationShips:
            action === "selectExisting"
              ? {}
              : item.relationShips
                ? item.relationShips
                : {},
          fromProviderName:
            action === "editExisting"
              ? item.originalProviderName
              : item.fromProviderName,
          originalProviderType:
            action === "editExisting"
              ? item.originalProviderType
              : item.fromProviderType,
          originalProviderId: item.originalProviderId,
          originalProviderName:
            action === "editExisting"
              ? item.originalProviderName
              : item.fromProviderName,
          customerViewable: item.customerViewable,
          physical: item.physical,
          activation: item.activation,
          suspendResource: item.suspendResource,
          resumeResource: item.resumeResource,
          customAttributes: item.customAttributes ? item.customAttributes : [],
          enrichmentConfig: item.enrichmentConfig,
          inventoryItemAndDetail: [],
          //Localised Content
          language: item.language,
          localisedName: item.localisedName,
          localisedDesc: item.localisedDesc,

          //variants
          variants: item.variants,
          hasVariant: item.variants && item.variants.length > 0 ? true : false,
          children: item.children ? item.children : [],
          assembly: item.assembly,

          // Price term data
          priceTenureUOM: item.priceTenureUOM,
          priceTenure: item.priceTenure,
          bom: item.bom ? item.bom : [],
          customer:
            item.customer && item.customer.length > 0 ? item.customer : [],
          otherPrices:
            item.otherPrices && item.otherPrices.length > 0
              ? item.otherPrices
              : [],
          ...providerInfo,
          originalPrice: item.originalPrice ? item.originalPrice : item.price,
          groupPrice: item.groupPrice
            ? Number(item.groupPrice).toFixed(2) + ""
            : "0.00",
          characteristics: item.characteristics ? item.characteristics : [],
          productSpec: item.productSpec ? item.productSpec : {},
        });
      } else if (item.priceType === "RC") {
        setComponentData({
          ...componentData,
          componentTypeName: item?.componentTypeName,
          statusDisplayName: props.state.statusDisplayName,
          status: props.state.status,

          add: item.add ? item.add : false,
          id: item.id,
          name: item.name,
          price: Number(item.price).toFixed(2) + "",
          partnerPrice: item.partnerPrice
            ? Number(item.partnerPrice).toFixed(2) + ""
            : Number(item.price).toFixed(2) + "",
          minimumPrice: item.minimumPrice
            ? Number(item.minimumPrice).toFixed(2) + ""
            : "",
          originalMinimumPrice: item.originalMinimumPrice
            ? Number(item.originalMinimumPrice).toFixed(2) + ""
            : "",
          quantity: item.quantity,
          priceType: item.priceType,
          description: item.description,
          featureCode: item.featureCode,
          componentType: item.componentType,
          displaySequence: item.displaySequence,
          componentProviderType:
            action === "editExisting"
              ? item.componentProviderType
              : item.fromProviderType,
          existing:
            action === "selectExisting"
              ? true
              : action === "editExisting"
                ? item.existing
                : false,
          chipData: action === "selectExisting" ? [] : item.chipData,
          dependsOn: action === "selectExisting" ? [] : item.dependsOn,
          relationShips:
            action === "selectExisting"
              ? {}
              : item.relationShips
                ? item.relationShips
                : {},
          fromProviderName:
            action === "editExisting"
              ? item.originalProviderName
              : item.fromProviderName,
          originalProviderType:
            action === "editExisting"
              ? item.originalProviderType
              : item.fromProviderType,
          originalProviderId: item.originalProviderId,
          originalProviderName:
            action === "editExisting"
              ? item.originalProviderName
              : item.fromProviderName,
          customerViewable: item.customerViewable,
          physical: item.physical,
          activation: item.activation,
          provisioning: item.provisioning,
          suspendResource: item.suspendResource,
          resumeResource: item.resumeResource,
          customAttributes: item.customAttributes ? item.customAttributes : [],
          enrichmentConfig: item.enrichmentConfig,
          inventoryItemAndDetail: [],
          //Localised Content
          language: item.language,
          localisedName: item.localisedName,
          localisedDesc: item.localisedDesc,
          //variants
          variants: item.variants,
          hasVariant: item.variants && item.variants.length > 0 ? true : false,
          children: item.children ? item.children : [],
          assembly: item.assembly,
          bom: item.bom ? item.bom : [],
          customer:
            item.customer && item.customer.length > 0 ? item.customer : [],

          // Price term data
          priceTenureUOM: item.priceTenureUOM,
          priceTenure: item.priceTenure,
          otherPrices:
            item.otherPrices && item.otherPrices.length > 0
              ? item.otherPrices
              : [],
          ...providerInfo,
          originalPrice: item.originalPrice ? item.originalPrice : item.price,
          groupPrice: item.groupPrice
            ? Number(item.groupPrice).toFixed(2) + ""
            : "0.00",
          characteristics: item.characteristics ? item.characteristics : [],
          productSpec: item.productSpec ? item.productSpec : {},
        });
      } else {
        setComponentData({
          ...componentData,
          componentTypeName: item?.componentTypeName,
          statusDisplayName: props.state.statusDisplayName,
          status: props.state.status,

          add: item.add ? item.add : false,
          id: item.id,
          name: item.name,
          price: Number(item.price).toFixed(2) + "",
          partnerPrice: item.partnerPrice
            ? Number(item.partnerPrice).toFixed(2) + ""
            : Number(item.price).toFixed(2) + "",
          minimumPrice: item.minimumPrice
            ? Number(item.minimumPrice).toFixed(2) + ""
            : "",
          originalMinimumPrice: item.originalMinimumPrice
            ? Number(item.originalMinimumPrice).toFixed(2) + ""
            : "",
          quantity: item.quantity,
          priceType: item.priceType,
          description: item.description,
          featureCode: item.featureCode,
          componentType: item.componentType,
          displaySequence: item.displaySequence,
          componentProviderType:
            action === "editExisting"
              ? item.componentProviderType
              : item.fromProviderType,
          existing:
            action === "selectExisting"
              ? true
              : action === "editExisting"
                ? item.existing
                : false,
          chipData: action === "selectExisting" ? [] : item.chipData,
          dependsOn: action === "selectExisting" ? [] : item.dependsOn,
          relationShips:
            action === "selectExisting"
              ? {}
              : item.relationShips
                ? item.relationShips
                : {},
          fromProviderName:
            action === "editExisting"
              ? item.originalProviderName
              : item.fromProviderName,
          originalProviderType:
            action === "editExisting"
              ? item.originalProviderType
              : item.fromProviderType,
          originalProviderId: item.originalProviderId,
          originalProviderName:
            action === "editExisting"
              ? item.originalProviderName
              : item.fromProviderName,
          customerViewable: item.customerViewable,
          physical: item.physical,
          activation: item.activation,
          provisioning: item.provisioning,
          suspendResource: item.suspendResource,
          resumeResource: item.resumeResource,
          customAttributes: item.customAttributes ? item.customAttributes : [],
          enrichmentConfig: item.enrichmentConfig,
          inventoryItemAndDetail: [],
          //Localised Content
          language: item.language,
          localisedName: item.localisedName,
          localisedDesc: item.localisedDesc,
          //variants
          variants: item.variants,
          hasVariant: item.variants && item.variants.length > 0 ? true : false,
          children: item.children ? item.children : [],
          assembly: item.assembly,
          bom: item.bom ? item.bom : [],
          customer:
            item.customer && item.customer.length > 0 ? item.customer : [],
          otherPrices:
            item.otherPrices && item.otherPrices.length > 0
              ? item.otherPrices
              : [],
          ...providerInfo,
          originalPrice: item.originalPrice ? item.originalPrice : item.price,
          groupPrice: item.groupPrice
            ? Number(item.groupPrice).toFixed(2) + ""
            : "0.00",
          characteristics: item.characteristics ? item.characteristics : [],
          productSpec: item.productSpec ? item.productSpec : {},
        });
      }
      if (item.margin) {
        setTempMarginValues(item.margin);
      } else {
        setTempMarginValues({});
      }
    }
  };

  const closePackageTemplateDialog = (item) => {
    if (item) {
      if (item.customAttributes && item.customAttributes.length > 0) {
        for (var i = 0; i < item.customAttributes.length; i++) {
          var index = customAttributesList.findIndex(
            (x) => x.attrName === item.customAttributes[i].attrName,
          );
          if (index > -1) {
            item.customAttributes[i].valueType =
              customAttributesList[index].valueType;
            item.customAttributes[i].options =
              customAttributesList[index].options;
            item.customAttributes[i].required =
              customAttributesList[index].required;
            if (customAttributesList[index].valueType === "boolean") {
              if (item.customAttributes[i].attrValue) {
                if (typeof item.customAttributes[i].attrValue === "string") {
                  if (item.customAttributes[i].attrValue === "true") {
                    item.customAttributes[i].attrValue = true;
                  } else {
                    item.customAttributes[i].attrValue = false;
                  }
                } else {
                  item.customAttributes[i].attrValue = true;
                }
              } else {
                item.customAttributes[i].attrValue = false;
              }
            }
          }
        }
      }
      item.originalMinimumPrice = Number(item.price).toFixed(2) + "";
      item.minimumPrice = Number(item.price).toFixed(2) + "";
      if (
        props.tenantRoles.includes("CHILD_PROVIDER") &&
        props.tenantInfo.tenantId === item.fromProviderId
      ) {
        item.groupPrice = Number(item.price).toFixed(2) + "";
      }
      if (item.otherPrices && item.otherPrices.length > 0) {
        for (i = 0; i < item.otherPrices.length; i++) {
          item.otherPrices[i].originalMinimumPrice =
            Number(item.otherPrices[i].price).toFixed(2) + "";
          if (
            props.tenantRoles.includes("CHILD_PROVIDER") &&
            props.tenantInfo.tenantId === item.fromProviderId
          ) {
            item.otherPrices[i].groupPrice =
              Number(item.otherPrices[i].price).toFixed(2) + "";
          }
        }
      }
      if (item.variants && item.variants.length > 0) {
        for (var v = 0; v < item.variants.length; v++) {
          item.variants[v].minimumPrice =
            Number(item.variants[v].price).toFixed(2) + "";
          if (
            props.tenantRoles.includes("CHILD_PROVIDER") &&
            props.tenantInfo.tenantId === item.fromProviderId
          ) {
            item.variants[v].groupPrice =
              Number(item.variants[v].price).toFixed(2) + "";
          }
          if (item.variants[v].partnerPrice) {
            item.variants[v].partnerPrice =
              Number(item.variants[v].partnerPrice).toFixed(2) + "";
          } else {
            item.variants[v].partnerPrice =
              Number(item.variants[v].price).toFixed(2) + "";
          }
          if (item.variants[v].originalPrice) {
            item.variants[v].originalPrice =
              Number(item.variants[v].originalPrice).toFixed(2) + "";
          } else {
            item.variants[v].originalPrice =
              Number(item.variants[v].price).toFixed(2) + "";
          }
          if (
            item.variants[v].otherPrices &&
            item.variants[v].otherPrices.length > 0
          ) {
            for (var ov = 0; ov < item.variants[v].otherPrices.length; ov++) {
              item.variants[v].otherPrices[ov].minimumPrice =
                Number(item.variants[v].otherPrices[ov].price).toFixed(2) + "";
              if (
                props.tenantRoles.includes("CHILD_PROVIDER") &&
                props.tenantInfo.tenantId === item.fromProviderId
              ) {
                item.variants[v].otherPrices[ov].groupPrice =
                  Number(item.variants[v].otherPrices[ov].price).toFixed(2) +
                  "";
              }
              if (item.variants[v].otherPrices[ov].partnerPrice) {
                item.variants[v].otherPrices[ov].partnerPrice =
                  Number(item.variants[v].otherPrices[ov].partnerPrice).toFixed(
                    2,
                  ) + "";
              } else {
                item.variants[v].otherPrices[ov].partnerPrice =
                  Number(item.variants[v].otherPrices[ov].price).toFixed(2) +
                  "";
              }
              if (item.variants[v].otherPrices[ov].originalPrice) {
                item.variants[v].otherPrices[ov].originalPrice =
                  Number(
                    item.variants[v].otherPrices[ov].originalPrice,
                  ).toFixed(2) + "";
              } else {
                item.variants[v].otherPrices[ov].originalPrice =
                  Number(item.variants[v].otherPrices[ov].price).toFixed(2) +
                  "";
              }
              item.variants[v].otherPrices[ov].price =
                Number(item.variants[v].otherPrices[ov].price).toFixed(2) + "";
            }
          }
        }
      }
      item.originalProviderId = item.fromProviderId;
      item.originalProviderName = item.fromProviderName;
      var oldEnrichmentConfig = item.enrichmentConfig
        ? item.enrichmentConfig
        : {};
      var tempEnrichmentConfig = [];
      if (
        oldEnrichmentConfig &&
        oldEnrichmentConfig.hasOwnProperty("purchaseable") &&
        oldEnrichmentConfig.purchaseable
      ) {
        var purchaseableList = oldEnrichmentConfig["purchaseable"].split(",");
        var removeableList = oldEnrichmentConfig["removeable"].split(",");
        var rePurchaseableList =
          oldEnrichmentConfig["rePurchaseable"].split(",");
        var visibleList = oldEnrichmentConfig["visible"].split(",");
        // Set purchaseable data
        for (var p = 0; p < purchaseableList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === purchaseableList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].purchaseable = JSON.parse(
                purchaseableList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: purchaseableList[p].split(":")[0],
                purchaseable: JSON.parse(purchaseableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: purchaseableList[p].split(":")[0],
              purchaseable: JSON.parse(purchaseableList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
        // Set removeable data
        for (var p = 0; p < removeableList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === removeableList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].removeable = JSON.parse(
                removeableList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: removeableList[p].split(":")[0],
                removeable: JSON.parse(removeableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: removeableList[p].split(":")[0],
              removeable: JSON.parse(removeableList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
        // Set rePurchaseable data
        for (var p = 0; p < rePurchaseableList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === rePurchaseableList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].rePurchaseable = JSON.parse(
                rePurchaseableList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: rePurchaseableList[p].split(":")[0],
                rePurchaseable: JSON.parse(rePurchaseableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: rePurchaseableList[p].split(":")[0],
              rePurchaseable: JSON.parse(rePurchaseableList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
        // Set visible data
        for (var p = 0; p < visibleList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === visibleList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].visible = JSON.parse(
                visibleList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: visibleList[p].split(":")[0],
                visible: JSON.parse(visibleList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: visibleList[p].split(":")[0],
              visible: JSON.parse(visibleList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
      }
      item.enrichmentConfig = tempEnrichmentConfig;
      console.log("check item data", item);
      setShowAddItem(true);
      setComponentFormDetails(item, "selectExisting");
      openPackageTemplateDialog(false);
      props.setUnsavedChanges(item);
      toggleEditComponentDialog(true);
      props.blockNavigation();
    } else {
      openPackageTemplateDialog(false);
    }
  };
  const [tempEditRow, setTempEditRow] = useState({});
  const editComponent = (row) => {
    row.language = "en_US";
    // setError({});
    if (props.tenantRoles.includes("CHILD_PROVIDER")) {
      if (row.margin && row.margin.groupMarginValue) {
        updateInitialMargin(row.margin.groupMarginValue);
      } else {
        updateInitialMargin("0");
      }
      if (row.margin && row.margin.marginValue) {
        updateSalesMargin(row.margin.marginValue);
      } else {
        updateSalesMargin("0");
      }
    } else {
      if (row.margin && row.margin.marginValue) {
        updateInitialMargin(row.margin.marginValue);
      } else {
        updateInitialMargin("0");
      }
    }
    if (row.margin && row.margin.minimumMarginValue) {
      updateMinimumMargin(row.margin.minimumMarginValue);
    } else {
      updateMinimumMargin("0");
    }
    if (componentData.id) {
      setTempEditRow(row);
      setOpenUnsavedChangesModal(true);
    } else {
      const data = JSON.parse(JSON.stringify(row));
      if (
        data.customAttributes &&
        data.customAttributes.length > 0 &&
        customAttributesList
      ) {
        for (var i = 0; i < data.customAttributes.length; i++) {
          var index = customAttributesList.findIndex(
            (x) => x.attrName === data.customAttributes[i].attrName,
          );
          if (index > -1) {
            data.customAttributes[i].valueType =
              customAttributesList[index].valueType;
            data.customAttributes[i].options =
              customAttributesList[index].options;
            data.customAttributes[i].required =
              customAttributesList[index].required;
            if (customAttributesList[index].valueType === "boolean") {
              if (data.customAttributes[i].attrValue) {
                if (typeof data.customAttributes[i].attrValue === "string") {
                  if (data.customAttributes[i].attrValue === "true") {
                    data.customAttributes[i].attrValue = true;
                  } else {
                    data.customAttributes[i].attrValue = false;
                  }
                } else {
                  data.customAttributes[i].attrValue = true;
                }
              } else {
                data.customAttributes[i].attrValue = false;
              }
            }
          }
        }
      }
      console.log("-----------data----------", data);
      setIsEdit(true);
      //saved data to componentData
      setComponentFormDetails({ ...data }, "editExisting");
      // window.scrollTo(0, 0);
      props.blockNavigation();
      props.setUnsavedChanges(row);
      toggleEditComponentDialog(true);
    }
  };

  const updateBucketItem = () => {
    setDialogErrorMsg("");
    if (isMarginChanged) {
      setMarkupWarning(true);
      return;
    }
    if (!validateAddItem(componentData)) {
      return;
    }
    //console.log("------------componentData.customAttributes------",componentData.customAttributes)
    if (
      componentData.customAttributes &&
      componentData.customAttributes.length > 0
    ) {
      for (var i = 0; i < componentData.customAttributes.length; i++) {
        if (
          componentData.customAttributes[i].required &&
          !componentData.customAttributes[i].attrValue
        ) {
          var error = componentData.customAttributes[i];
          // setDialogErrorMsg(t("REQUIRED_CUSTOM_ATTRIBUTE_ERROR", { error }));
          props.setErrorMessage(t('REQUIRED_CUSTOM_ATTRIBUTE_ERROR', { error }), false);
          return;
        }
      }
    }

    if (componentData.localisedName && componentData.localisedName.length > 0) {
      var localisedNameIndex = componentData.localisedName.findIndex(
        (x) => x.locale === "en_US",
      );
      if (localisedNameIndex > -1) {
        componentData.name =
          componentData.localisedName[localisedNameIndex].text;
      }
    }

    if (componentData.localisedDesc && componentData.localisedDesc.length > 0) {
      var localisedDescIndex = componentData.localisedDesc.findIndex(
        (x) => x.locale === "en_US",
      );
      if (localisedDescIndex > -1) {
        componentData.description =
          componentData.localisedDesc[localisedDescIndex].text;
      }
    }

    let data = { ...componentData };
    console.log("----------data-------------", data);
    data.tempDependency = {
      dependerBucketName: "",
      depender: "",
      dependerProviderType: "",
      dependerName: "",
      dependencyMode: "forEach",
      cardinality: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      dependencyType: "Mandatory",
    };
    data.selectedBucketComponents = [];
    data.margin = {
      marginType: "PERCENTAGE",
      marginValue: "",
      minimumMarginValue: "",
    };
    if (props.tenantRoles.includes("CHILD_PROVIDER")) {
      if (initialMargin && initialMargin >= 0) {
        data.margin.groupMarginValue = initialMargin;
      }
      if (initialMinimumMargin && initialMinimumMargin >= 0) {
        data.margin.minimumMarginValue = initialMinimumMargin;
      }
      if (salesMargin && salesMargin >= 0) {
        data.margin.marginValue = salesMargin;
      }
    } else {
      if (initialMargin && initialMargin >= 0) {
        data.margin.marginValue = initialMargin;
      }
      if (initialMinimumMargin && initialMinimumMargin >= 0) {
        data.margin.minimumMarginValue = initialMinimumMargin;
      }
    }
    setEditOtherPriceIndices(new Set());
    props.changeTableCompleteRowData(data);
    resetComponentForm(); //empty component data

    //once updated, show add item and hide update and cancel button
    setIsEdit(false);
    setShowAddItem(false);
    toggleEditComponentDialog(false);
    updateInitialMargin("0");
    updateMinimumMargin("0");
    updateSalesMargin("0");
    // updatedPackegedSolutionJSON();
  };

  const cancelUpdate = () => {
    resetComponentForm(); //empty component data
    setErrorr({});
    setDialogErrorMsg("");
    setDependencyError({});
    //once updated, show add item and hide update and cancel button
    setIsEdit(false);
    setShowAddItem(false);
    toggleEditComponentDialog(false);
    updateInitialMargin("0");
    updateMinimumMargin("0");
    updateSalesMargin("0");
    setMarginChanged(false);
    setEditOtherPriceIndices(new Set()); //reset the edit other price indices
  };

  const addBucketItem = async (e) => {
    setDialogErrorMsg("");
    if (isMarginChanged) {
      setMarkupWarning(true);
      return;
    }
    // let allowAddItem = validateAddItem(componentData);
    const allowAddItem = await validateAddItemAsync(componentData);
    console.log("allowAddItem", allowAddItem);
    // console.log('comp dara====', componentData);
    if (
      componentData.customAttributes &&
      componentData.customAttributes.length > 0
    ) {
      for (var i = 0; i < componentData.customAttributes.length; i++) {
        if (
          componentData.customAttributes[i].required &&
          !componentData.customAttributes[i].attrValue
        ) {
          var error = componentData.customAttributes[i];
          // props.setErrorMessage(t('REQUIRED_CUSTOM_ATTRIBUTE_ERROR', { error }), false);
          setDialogErrorMsg(t("REQUIRED_CUSTOM_ATTRIBUTE_ERROR", { error }));
          return;
        }
      }
    }
    if (componentData.localisedName && componentData.localisedName.length > 0) {
      var localisedNameIndex = componentData.localisedName.findIndex(
        (x) => x.locale === "en_US",
      );
      if (localisedNameIndex > -1) {
        componentData.name =
          componentData.localisedName[localisedNameIndex].text;
      }
    }

    if (componentData.localisedDesc && componentData.localisedDesc.length > 0) {
      var localisedDescIndex = componentData.localisedDesc.findIndex(
        (x) => x.locale === "en_US",
      );
      if (localisedDescIndex > -1) {
        componentData.description =
          componentData.localisedDesc[localisedDescIndex].text;
      }
    }
    if (allowAddItem) {
      let data = {
        chipData: componentData.chipData,
        dependsOn: componentData.dependsOn,
        add: true,

        //fields
        id: componentData.id,
        name: componentData.name.trim(),
        price: componentData.price + "",
        quantity: componentData.quantity,
        priceType: componentData.priceType,
        priceTenure:
          componentData.priceType === "NTC" || componentData.priceType === "RC"
            ? componentData.priceTenure
              ? componentData.priceTenure
              : "1"
            : null,
        priceTenureUOM:
          componentData.priceType === "NTC" || componentData.priceType === "RC"
            ? componentData.priceTenureUOM
              ? componentData.priceTenureUOM
              : "TF_mon"
            : null,
        // priceTenureUOM: componentData.priceTenureUOM ? (componentData.priceTenureUOM === 'TF_mon' && componentData.priceTenure === '3') ? 'TF_qtr' : componentData.priceTenureUOM : '',
        description: componentData.description.trim(),
        featureCode: componentData.featureCode,
        componentType: componentData.componentType,
        displaySequence: JSON.stringify(props.currentBucketItems.length + 1),
        componentProviderType: componentData.originalProviderType
          ? componentData.originalProviderType
          : componentData.componentProviderType,
        activation: componentData.activation,
        provisioning: componentData.provisioning,
        suspendResource: componentData.suspendResource,
        resumeResource: componentData.resumeResource,
        originalProviderId: componentData.originalProviderId,
        originalProviderName: componentData.originalProviderName,

        customer:
          componentData.customer && componentData.customer.length > 0
            ? componentData.customer
            : [],

        //attributes
        existing: componentData.existing,
        mandatory: componentData.mandatory,
        customerViewable: true,
        physical: componentData.physical,
        quantityModifiable: componentData.quantityModifiable,

        //variants
        variants: componentData.variants ? componentData.variants : [],
        hasVariant:
          componentData.variants && componentData.variants.length > 0
            ? true
            : false,
        assembly: componentData.assembly,
        children: componentData.children ? componentData.children : [],
        customAttributes: componentData.customAttributes
          ? componentData.customAttributes
          : [],

        // bom
        bom: componentData.bom ? componentData.bom : [],
        componentTypeName: componentData.componentTypeName ? componentData.componentTypeName : '',

        // Enrichment
        enrichmentConfig: componentData.enrichmentConfig
          ? componentData.enrichmentConfig
          : [],
        inventoryItemAndDetail: [],

        //Localised Content
        language: componentData.language,
        localisedName: componentData.localisedName
          ? componentData.localisedName
          : [],
        localisedDesc: componentData.localisedDesc
          ? componentData.localisedDesc
          : [],

        // depended on data fields
        tempDependency: {
          dependerBucketName: "",
          depender: "",
          dependerProviderType: "",
          dependerName: "",
          cardinality: {
            type: "Exact",
            range: {
              min: "",
              max: "",
            },
          },
          quantity: {
            type: "Exact",
            range: {
              min: "",
              max: "",
            },
          },
          dependencyType: "Mandatory",
        },
        selectedBucketComponents: [],
      };
      data.relationShips = {
        dependsOn: componentData.chipData,
      };
      if (componentData.priceType === "NTC") {
        data.priceTenureUOM = componentData.priceTenureUOM;
        data.priceTenure = componentData.priceTenure;
      }
      if (props.tenantInfo.tenantId === componentData.originalProviderId) {
        data.groupPrice = componentData.groupPrice
          ? componentData.groupPrice
          : "";
      }
      data.partnerPrice = componentData.partnerPrice
        ? componentData.partnerPrice
        : componentData.price;
      data.originalPrice = componentData.originalPrice
        ? componentData.originalPrice
        : componentData.price;
      data.minimumPrice = componentData.minimumPrice
        ? componentData.minimumPrice
        : "";
      if (componentData.otherPrices && componentData.otherPrices.length > 0) {
        data.otherPrices = componentData.otherPrices;
      } else {
        data.otherPrices = [];
      }
      data.margin = {
        marginType: "PERCENTAGE",
        marginValue: "",
        minimumMarginValue: "",
      };
      if (props.tenantRoles.includes("CHILD_PROVIDER")) {
        if (initialMargin && initialMargin >= 0) {
          data.margin.groupMarginValue = initialMargin;
        }
        if (initialMinimumMargin && initialMinimumMargin >= 0) {
          data.margin.minimumMarginValue = initialMinimumMargin;
        }
        if (salesMargin && salesMargin >= 0) {
          data.margin.marginValue = salesMargin;
        }
      } else {
        if (initialMargin && initialMargin >= 0) {
          data.margin.marginValue = initialMargin;
        }
        if (initialMinimumMargin && initialMinimumMargin >= 0) {
          data.margin.minimumMarginValue = initialMinimumMargin;
        }
      }
      props.getAssociatedBucketDetails(data);
      resetComponentForm(); //empty component data
      setShowAddItem(false);
      toggleEditComponentDialog(false);
      setIsEdit(false);
      updateInitialMargin("0");
      updateMinimumMargin("0");
      updateSalesMargin("0");
    }
  };
  const bulkAddBucketItem = (items, index) => {
    // console.log('item======', items)
    setDialogErrorMsg("");

    var allItems = [];
    items.forEach((item, itemIndex) => {
      let allowAddItem = validateAddItem(item);

      if (!allowAddItem) {
        console.log(`Item ${index} is invalid`);
        return;
      }

      let valid = true;

      if (item.customAttributes && item.customAttributes.length > 0) {
        for (var i = 0; i < item.customAttributes.length; i++) {
          if (
            item.customAttributes[i].required &&
            !item.customAttributes[i].attrValue
          ) {
            var error = item.customAttributes[i];
            // setDialogErrorMsg(t("REQUIRED_CUSTOM_ATTRIBUTE_ERROR", { error }));
            props.setErrorMessage(t('REQUIRED_CUSTOM_ATTRIBUTE_ERROR', { error }), false);
            console.log(
              `Item ${index} has a required custom attribute missing`,
            );
            valid = false;
            break;
          }
        }
      }

      if (!valid) {
        return;
      }

      if (item.localisedName && item.localisedName.length > 0) {
        var localisedNameIndex = item.localisedName.findIndex(
          (x) => x.locale === "en_US",
        );
        if (localisedNameIndex > -1) {
          item.name = item.localisedName[localisedNameIndex].text;
        }
      }

      if (item.localisedDesc && item.localisedDesc.length > 0) {
        var localisedDescIndex = item.localisedDesc.findIndex(
          (x) => x.locale === "en_US",
        );
        if (localisedDescIndex > -1) {
          item.description = item.localisedDesc[localisedDescIndex].text;
        }
      }
      item.originalProviderId = item.fromProviderId;
      if (allowAddItem) {
        let data = {
          chipData: item.chipData,
          dependsOn: item.dependsOn,
          add: true,

          // fields
          id: item.id,
          name: item.name.trim(),
          price: item.price + "",
          quantity: item.quantity,
          priceType: item.priceType,
          priceTenure:
            item.priceType === "NTC" || item.priceType === "RC"
              ? item.priceTenure
                ? item.priceTenure
                : "1"
              : null,
          priceTenureUOM:
            item.priceType === "NTC" || item.priceType === "RC"
              ? item.priceTenureUOM
                ? item.priceTenureUOM
                : "TF_mon"
              : null,
          description: item.description.trim(),
          featureCode: item.featureCode,
          componentType: item.componentType,
          displaySequence: JSON.stringify(props.currentBucketItems.length + 1),
          componentProviderType: item.originalProviderType
            ? item.originalProviderType
            : item.fromProviderType,
          activation: item.activation,
          provisioning: item.provisioning,
          suspendResource: item.suspendResource,
          resumeResource: item.resumeResource,
          originalProviderId: item.originalProviderId,

          customer:
            item.customer && item.customer.length > 0 ? item.customer : [],

          // attributes
          chipData: item.chipData ? item.chipData : [],
          dependsOn: item.dependsOn ? item.dependsOn : [],
          existing: item.existing ? item.existing : true, //fallback value set as true
          mandatory: item.mandatory ? item.mandatory : componentData.mandatory,
          customerViewable: true,
          physical: item.physical ? item.physical : componentData.physical,
          quantityModifiable: item.quantityModifiable
            ? item.quantityModifiable
            : componentData.quantityModifiable,

          // variants
          variants: item.variants ? item.variants : [],
          hasVariant: item.variants && item.variants.length > 0 ? true : false,
          assembly: item.assembly,
          children: item.children ? item.children : [],
          customAttributes: item.customAttributes ? item.customAttributes : [],

          // bom
          bom: item.bom ? item.bom : [],

          // Enrichment
          enrichmentConfig: item.enrichmentConfig ? item.enrichmentConfig : [],
          inventoryItemAndDetail: [],

          // Localised Content
          language: item.language,
          localisedName: item.localisedName ? item.localisedName : [],
          localisedDesc: item.localisedDesc ? item.localisedDesc : [],

          // depended on data fields
          tempDependency: {
            dependerBucketName: "",
            depender: "",
            dependerProviderType: "",
            dependerName: "",
            cardinality: {
              type: "Exact",
              range: {
                min: "",
                max: "",
              },
            },
            quantity: {
              type: "Exact",
              range: {
                min: "",
                max: "",
              },
            },
            dependencyType: "Mandatory",
          },
          selectedBucketComponents: [],
        };

        data.relationShips = {
          dependsOn: item.chipData ? item.chipData : [],
        };

        if (item.priceType === "NTC") {
          data.priceTenureUOM = item.priceTenureUOM;
          data.priceTenure = item.priceTenure;
        }

        data.partnerPrice = item.partnerPrice ? item.partnerPrice : item.price;
        data.originalPrice = item.partnerPrice ? item.partnerPrice : item.price;
        data.minimumPrice = item.minimumPrice ? item.minimumPrice : "";

        if (item.otherPrices && item.otherPrices.length > 0) {
          data.otherPrices = item.otherPrices;
        } else {
          data.otherPrices = [];
        }

        data.margin = {
          marginType: "PERCENTAGE",
          marginValue: "",
          minimumMarginValue: "",
        };

        if (initialMargin && initialMargin >= 0) {
          data.margin.marginValue = initialMargin;
        }

        if (initialMinimumMargin && initialMinimumMargin >= 0) {
          data.margin.minimumMarginValue = initialMinimumMargin;
        }
        allItems.push(data);
        // console.log('data======', data)
      }
      if (itemIndex + 1 === items.length) {
        props.getAssociatedBucketDetailsBulk(allItems);
        toggleEditComponentDialog(false);
        setIsEdit(false);
        updateInitialMargin("0");
        updateMinimumMargin("0");
        updateSalesMargin("0");
        resetComponentForm(); // empty component data
      }
    });
  };

  const resetComponentForm = () => {
    setComponentData(componentDataCopy);
    setComponentData({
      add: false,
      chipData: [],
      dependsOn: [],
      relationShips: {},

      //fields
      id: "",
      name: "",
      price: "",
      quantity: "",
      priceType: "",
      featureCode: "",
      description: "",
      componentType: "",
      displaySequence: "",

      depender: "",
      dependerProviderType: "",

      //attributes
      mandatory: false,
      customerViewable: false,
      physical: false,
      quantityModifiable: false,

      //variants
      variants: [],
      hasVariant: false,

      expandVariants: false,
      // dependency data
      tempDependency: {
        dependerBucketName: "",
        depender: "",
        dependerProviderType: "",
        dependerName: "",
        cardinality: {
          type: "Exact",
          range: {
            min: "",
            max: "",
          },
        },
        quantity: {
          type: "Exact",
          range: {
            min: "",
            max: "",
          },
        },
        dependencyType: "Mandatory",
      },
      selectedBucketComponents: [],
      characteristics: [],
    });
    props.setUnsavedChanges({});
    setDependencyError({});
  };
  const [errorr, setErrorr] = useState({});

  const validateAddItem = (compDetails) => {
    const err = {};
    if (compDetails.localisedName) {
      var localisedNameIndex = compDetails.localisedName.findIndex(
        (x) => x.locale === "en_US",
      );
    }
    if (compDetails.localisedDesc) {
      var localisedDescIndex = compDetails.localisedDesc.findIndex(
        (x) => x.locale === "en_US",
      );
    }

    if (compDetails.name === "" || compDetails.name === undefined) {
      // props.setErrorMessage(t('NAME_CANNOT_BE_EMPTY'), false);
      err.name = t("NAME_CANNOT_BE_EMPTY");
    }
    if (
      (compDetails.price === "" || compDetails.price === undefined) &&
      compDetails.variants === null
    ) {
      //No price required for components with variants
      // props.setErrorMessage(t('PRICE_CANNOT_BE_EMPTY'), false);
      err.price = t("PRICE_CANNOT_BE_EMPTY");
    }
    if (
      compDetails.description === "" ||
      compDetails.description === undefined
    ) {
      // props.setErrorMessage(t('DESCRIPTION_CANNOT_BE_EMPTY'), false);
      err.description = t("DESCRIPTION_CANNOT_BE_EMPTY");
    }
    if (
      compDetails.localisedName &&
      compDetails.localisedName.length > 0 &&
      (localisedNameIndex == -1 ||
        (localisedNameIndex > -1 &&
          compDetails.localisedName[localisedNameIndex].text == ""))
    ) {
      // props.setErrorMessage(t('LANGUAGE_ERROR'), false);
      //this feels redundant as we already have an error on the name field saying "Name is mandatory"
      // err.localisedName = t("LANGUAGE_ERROR");
    }
    if (
      compDetails.localisedDesc &&
      compDetails.localisedDesc.length > 0 &&
      (localisedDescIndex == -1 ||
        (localisedDescIndex > -1 &&
          compDetails.localisedDesc[localisedDescIndex].text == ""))
    ) {
      // props.setErrorMessage(t('LANGUAGE_ERROR'), false);
      //this feels redundant as we already have an error on the description field saying "Description is mandatory"
      // err.localisedDesc = t("LANGUAGE_ERROR");
    }

    if (Number(initialMargin) < Number(initialMinimumMargin)) {
      err.initialMargin = t("RECOMMENDED_MARKUP_ERROR");
    }
    if (Number(compDetails.price) < Number(compDetails.minimumPrice)) {
      err.price = t("RECOMMENDED_PRICE_ERROR");
    }
    if (compDetails.otherPrices && compDetails.otherPrices.length > 0) {
      compDetails.otherPrices.forEach((otherPrice, index) => {
        if (Number(otherPrice.price) < Number(otherPrice.minimumPrice)) {
          if (props.tenantRoles.includes("MASTER_PROVIDER")) {
            err[`otherPrice_${otherPrice.priceType}`] = t(
              "RECOMMENDED_PRICE_ERROR",
              { index: index + 1 },
            );
          } else {
            err[`otherPrice_sales_${otherPrice.priceType}`] = t(
              "SALES_PRICE_ERROR",
              { index: index + 1 },
            );
          }
        }
        if (!props.tenantRoles.includes("CHILD_PROVIDER")) {
          if (Number(otherPrice.minimumPrice) < Number(otherPrice.originalPrice)) {
            err[`otherPrice_minimum_${otherPrice.priceType}`] = t(
              "MINIMUM_PRICE_ERROR",
              { index: index + 1 },
            );
          }
        }
      });
    }
    console.log('check errrr', err);
    if (props.tenantRoles.includes("CHILD_PROVIDER")) {
      if (!salesMargin || isNaN(Number(salesMargin))) {
        err.salesMargin = t("SALES_MARGIN_ERROR");
      }
    }
    setErrorr(err);
    if (Object.keys(err).length === 0) {
      return true;
    } else {
      return false;
    }
  };

  const validateAddItemAsync = async (compDetails) => {
    return new Promise((resolve) => {
      const err = {};
      if (compDetails.localisedName) {
        var localisedNameIndex = compDetails.localisedName.findIndex(
          (x) => x.locale === "en_US",
        );
      }
      if (compDetails.localisedDesc) {
        var localisedDescIndex = compDetails.localisedDesc.findIndex(
          (x) => x.locale === "en_US",
        );
      }

      if (compDetails.name === "" || compDetails.name === undefined) {
        // props.setErrorMessage(t('NAME_CANNOT_BE_EMPTY'), false);
        err.name = t("NAME_CANNOT_BE_EMPTY");
      }
      if (
        (compDetails.price === "" || compDetails.price === undefined) &&
        compDetails.variants === null
      ) {
        //No price required for components with variants
        // props.setErrorMessage(t('PRICE_CANNOT_BE_EMPTY'), false);
        err.price = t("PRICE_CANNOT_BE_EMPTY");
      }
      if (
        compDetails.description === "" ||
        compDetails.description === undefined
      ) {
        // props.setErrorMessage(t('DESCRIPTION_CANNOT_BE_EMPTY'), false);
        err.description = t("DESCRIPTION_CANNOT_BE_EMPTY");
      }
      if (
        compDetails.localisedName &&
        compDetails.localisedName.length > 0 &&
        (localisedNameIndex == -1 ||
          (localisedNameIndex > -1 &&
            compDetails.localisedName[localisedNameIndex].text == ""))
      ) {
        // props.setErrorMessage(t('LANGUAGE_ERROR'), false);
        err.localisedName = t("LANGUAGE_ERROR");
      }
      if (
        compDetails.localisedDesc &&
        compDetails.localisedDesc.length > 0 &&
        (localisedDescIndex == -1 ||
          (localisedDescIndex > -1 &&
            compDetails.localisedDesc[localisedDescIndex].text == ""))
      ) {
        // props.setErrorMessage(t('LANGUAGE_ERROR'), false);
        err.localisedDesc = t("LANGUAGE_ERROR");
      }

      if (Number(initialMargin) < Number(initialMinimumMargin)) {
        err.initialMargin = t("RECOMMENDED_MARKUP_ERROR");
      }
      if (Number(compDetails.price) < Number(compDetails.minimumPrice)) {
        err.price = t("RECOMMENDED_PRICE_ERROR");
      }
      // if (compDetails.otherPrices && compDetails.otherPrices.length > 0) {
      //   compDetails.otherPrices.forEach((otherPrice, index) => {
      //     if (Number(otherPrice.price) < Number(otherPrice.minimumPrice)) {
      //       err[`otherPrice_${otherPrice.priceType}`] = t(
      //         "RECOMMENDED_PRICE_ERROR",
      //         { index: index + 1 },
      //       );
      //     }
      //   });
      // }
      if (compDetails.otherPrices && compDetails.otherPrices.length > 0) {
        compDetails.otherPrices.forEach((otherPrice, index) => {
          if (Number(otherPrice.price) < Number(otherPrice.minimumPrice)) {
            if (props.tenantRoles.includes("MASTER_PROVIDER")) {
              err[`otherPrice_${otherPrice.priceType}`] = t(
                "RECOMMENDED_PRICE_ERROR",
                { index: index + 1 },
              );
            } else {
              err[`otherPrice_sales_${otherPrice.priceType}`] = t(
                "SALES_PRICE_ERROR",
                { index: index + 1 },
              );
            }
          }
          if (!props.tenantRoles.includes("CHILD_PROVIDER")) {
            if (Number(otherPrice.minimumPrice) < Number(otherPrice.originalPrice)) {
              err[`otherPrice_minimum_${otherPrice.priceType}`] = t(
                "MINIMUM_PRICE_ERROR",
                { index: index + 1 },
              );
            }
          }
        });
      }
      if (props.tenantRoles.includes("CHILD_PROVIDER")) {
        // if (!salesMargin || isNaN(Number(salesMargin))) {
        // 	err.salesMargin = t('SALES_MARGIN_ERROR');
        // }
        if (Number(salesMargin) < Number(initialMinimumMargin)) {
          err.salesMargin = t("SALES_MARKUP_ERROR");
        }
      }
      setErrorr(err);
      console.log("check err", err);
      if (Object.keys(err).length === 0) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  const dependencies = (e) => {
    props.setErrorMessage("", false);
    let tempComponentData = { ...componentData };
    let tempDependencyData = { ...tempComponentData.tempDependency };
    let tempDependencyError = { ...dependencyError };
    let inputName = e.target.name;
    let inputValue = e.target.value;
    if (inputName === "dependencyMode") {
      tempDependencyData.dependencyMode = inputValue;
      if (inputValue === 'forEach') {
        tempDependencyData.quantity = {
          type: "Exact",
          range: {
            min: "",
            max: "",
          },
        }
        if (tempDependencyError.quantity) {
          delete tempDependencyError.quantity;
        }
      }
    } else if (inputName === "dependencyType") {
      tempDependencyData.dependencyType = inputValue;
      if (tempDependencyError.dependencyType) {
        delete tempDependencyError.dependencyType;
      }
    } else if (inputName === "dependOnBucketName") {
      if (inputValue) {
        if (inputValue === "PACKAGED_SOLUTION") {
          tempDependencyData.dependerBucketName = inputValue;
          tempComponentData.selectedBucketComponents = [];
        } else {
          let selectedBucketDetails = extractLeafCategories(
            props.bucketList,
          ).find((obj) => {
            return obj.id === inputValue;
          });
          tempDependencyData.dependerBucketName = selectedBucketDetails.id;
          let tempComponentList = [...props.state.components];
          let selectedBucketItems = jp.query(
            tempComponentList,
            '$[?(@.componentType=="' + selectedBucketDetails.id + '")]',
          );
          let flattenedBucketItems = [];
          for (var i = 0; i < selectedBucketItems.length; i++) {
            if (
              selectedBucketItems[i].variants &&
              selectedBucketItems[i].variants.length > 0
            ) {
              for (var j = 0; j < selectedBucketItems[i].variants.length; j++) {
                let tempVarComponent = { ...selectedBucketItems[i] };
                tempVarComponent.name =
                  selectedBucketItems[i].name +
                  "." +
                  selectedBucketItems[i].variants[j].name;
                tempVarComponent.id =
                  selectedBucketItems[i].variants[j].productId;
                tempVarComponent.price =
                  selectedBucketItems[i].variants[j].price;
                tempVarComponent.featureCode =
                  selectedBucketItems[i].variants[j].featureCode;
                tempVarComponent.description =
                  selectedBucketItems[i].variants[j].description;
                flattenedBucketItems.push({ ...tempVarComponent });
              }
            } else {
              flattenedBucketItems.push({ ...selectedBucketItems[i] });
            }
          }
          tempComponentData.selectedBucketComponents = flattenedBucketItems;
        }
      }
      if (tempDependencyError.dependerBucketName) {
        delete tempDependencyError.dependerBucketName;
      }
    } else if (inputName === "depender") {
      let selectedBucketDetails =
        tempComponentData.selectedBucketComponents.find((obj) => {
          return obj.featureCode === inputValue;
        });
      tempDependencyData.depender = selectedBucketDetails.featureCode;
      tempDependencyData.featureCode = selectedBucketDetails.featureCode;
      tempDependencyData.dependerName = selectedBucketDetails.name;
      tempDependencyData.dependerProviderType =
        selectedBucketDetails.componentProviderType;
      if (tempDependencyError.depender) {
        delete tempDependencyError.depender;
      }
    } else if (inputName === "type") {
      tempDependencyData.cardinality.type =
        tempDependencyData.cardinality.type === "Exact" ? "Range" : "Exact";
      tempDependencyData.cardinality.range.min = "";
      tempDependencyData.cardinality.range.max = "";
      if (tempDependencyError.cardinality) {
        delete tempDependencyError.cardinality;
      }
    } else if (inputName === "quantityType") {
      // NEW: quantity type toggle
      tempDependencyData.quantity.type =
        tempDependencyData.quantity.type === "Exact" ? "Range" : "Exact";
      tempDependencyData.quantity.range.min = "";
      tempDependencyData.quantity.range.max = "";
      if (tempDependencyError.quantity) {
        delete tempDependencyError.quantity;
      }
    } else if (inputName === "quantityMin") {
      // NEW: quantity min value
      if ((inputValue === "" || inputValue >= 0) && inputValue < 10000) {
        tempDependencyData.quantity.range.min = inputValue;

        if (tempDependencyData.quantity.type === "Exact") {
          tempDependencyData.quantity.range.max = inputValue;
        }
        // Clear quantity.range.min error
        if (tempDependencyError.quantity?.range?.min) {
          delete tempDependencyError.quantity.range.min;
          // Clean up empty objects
          if (Object.keys(tempDependencyError.quantity.range).length === 0) {
            delete tempDependencyError.quantity.range;
          }
          if (Object.keys(tempDependencyError.quantity).length === 0) {
            delete tempDependencyError.quantity;
          }
        }
      }
    } else if (inputName === "quantityMax") {
      // NEW: quantity max value
      if ((inputValue === "" || inputValue >= 0) && inputValue < 10000) {
        tempDependencyData.quantity.range.max = inputValue;

        // Clear quantity.range.max error
        if (tempDependencyError.quantity?.range?.max) {
          delete tempDependencyError.quantity.range.max;
          // Clean up empty objects
          if (Object.keys(tempDependencyError.quantity.range).length === 0) {
            delete tempDependencyError.quantity.range;
          }
          if (Object.keys(tempDependencyError.quantity).length === 0) {
            delete tempDependencyError.quantity;
          }
        }
      }
    } else if (inputName === "min" || inputName === "max") {
      if ((inputValue === "" || inputValue >= 0) && inputValue < 10000) {
        tempDependencyData.cardinality.range[inputName] = inputValue;

        // Clear cardinality.range.min or cardinality.range.max error
        if (tempDependencyError.cardinality?.range?.[inputName]) {
          delete tempDependencyError.cardinality.range[inputName];
          // Clean up empty objects
          if (Object.keys(tempDependencyError.cardinality.range).length === 0) {
            delete tempDependencyError.cardinality.range;
          }
          if (Object.keys(tempDependencyError.cardinality).length === 0) {
            delete tempDependencyError.cardinality;
          }
        }
      }
    }
    let finalData = {
      ...tempComponentData,
      tempDependency: { ...tempDependencyData },
    };
    setComponentData(finalData);
    setDependencyError(tempDependencyError);
    console.log("check finalData- dependency", finalData);
  };
  const validateDependencies = () => {
    let tempComponentData = { ...componentData };
    let error = {
      cardinality: { range: {} },
      quantity: { range: {} }
    };
    let errorMessages = [];
    let isValid = true;

    // 1. Validate required fields
    if (!tempComponentData.tempDependency.dependerBucketName) {
      error.dependerBucketName = t('MANDATORY_FIELD_ERROR');
      errorMessages.push(t('COMPONENT_TYPE_REQUIRED'));
      isValid = false;
    }

    if (!tempComponentData.tempDependency.dependencyType) {
      error.dependencyType = t('MANDATORY_FIELD_ERROR');
      errorMessages.push(t('DEPENDENCY_TYPE_REQUIRED'));
      isValid = false;
    }

    // 2. Validate depender (if not PACKAGED_SOLUTION)
    if (tempComponentData.tempDependency.dependerBucketName !== "PACKAGED_SOLUTION") {
      if (!tempComponentData.tempDependency.depender) {
        error.depender = t('MANDATORY_FIELD_ERROR');
        errorMessages.push(t('CHOOSE_COMPONENT_REQUIRED'));
        isValid = false;
      }
    }

    // 3. Validate cardinality for Mandatory dependencies
    if (tempComponentData.tempDependency.dependencyType === "Mandatory") {
      if (tempComponentData.tempDependency.cardinality.range.min < 1) {
        if (!error.cardinality) error.cardinality = {};
        if (!error.cardinality.range) error.cardinality.range = {};
        error.cardinality.range.min = t('MANDATORY_FIELD_ERROR');
        errorMessages.push(t('QUANTITY_IS_REQUIRED_FOR_MANDATORY_ITEMS'));
        isValid = false;
      }

      if (tempComponentData.tempDependency.cardinality.type === "Range") {
        if (
          +tempComponentData.tempDependency.cardinality.range.max <
          +tempComponentData.tempDependency.cardinality.range.min
        ) {
          if (!error.cardinality) error.cardinality = {};
          if (!error.cardinality.range) error.cardinality.range = {};
          error.cardinality.range.max = t('MANDATORY_FIELD_ERROR');
          errorMessages.push(t('MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE'));
          isValid = false;
        }
      }
    }

    // 4. Validate cardinality for Optional dependencies with Range
    if (tempComponentData.tempDependency.dependencyType !== "Mandatory") {
      if (
        tempComponentData.tempDependency.cardinality.type === "Range" &&
        (tempComponentData.tempDependency.cardinality.range.max ||
          tempComponentData.tempDependency.cardinality.range.min)
      ) {
        if (tempComponentData.tempDependency.cardinality.range.min < 1) {
          if (!error.cardinality) error.cardinality = {};
          if (!error.cardinality.range) error.cardinality.range = {};
          error.cardinality.range.min = t('MANDATORY_FIELD_ERROR');
          errorMessages.push(t('MIN_AND_MAX_VALUE_REQUIRED'));
          isValid = false;
        }

        if (tempComponentData.tempDependency.cardinality.range.max < 1) {
          if (!error.cardinality) error.cardinality = {};
          if (!error.cardinality.range) error.cardinality.range = {};
          error.cardinality.range.max = t('MANDATORY_FIELD_ERROR');
          errorMessages.push(t('MIN_AND_MAX_VALUE_REQUIRED'));
          isValid = false;
        }

        if (
          +tempComponentData.tempDependency.cardinality.range.max > 0 &&
          +tempComponentData.tempDependency.cardinality.range.min > 0 &&
          +tempComponentData.tempDependency.cardinality.range.max <
          +tempComponentData.tempDependency.cardinality.range.min
        ) {
          if (!error.cardinality) error.cardinality = {};
          if (!error.cardinality.range) error.cardinality.range = {};
          error.cardinality.range.max = t('MANDATORY_FIELD_ERROR');
          errorMessages.push(t('MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE'));
          isValid = false;
        }
      }
    }

    // 5. Validate quantity for conditional dependencies
    if (tempComponentData.tempDependency.dependencyMode === "conditional") {
      if (tempComponentData.tempDependency.quantity.range.min < 1) {
        if (!error.quantity) error.quantity = {};
        if (!error.quantity.range) error.quantity.range = {};
        error.quantity.range.min = t('MANDATORY_FIELD_ERROR');
        errorMessages.push(t('QUANTITY_IS_REQUIRED_FOR_CONDITIONAL_ITEMS'));
        isValid = false;
      }

      if (
        tempComponentData.tempDependency.quantity.type === "Range" &&
        (tempComponentData.tempDependency.quantity.range.max ||
          tempComponentData.tempDependency.quantity.range.min)
      ) {
        if (tempComponentData.tempDependency.quantity.range.min < 1) {
          if (!error.quantity) error.quantity = {};
          if (!error.quantity.range) error.quantity.range = {};
          error.quantity.range.min = t('MANDATORY_FIELD_ERROR');
          if (!errorMessages.includes(t('MIN_AND_MAX_VALUE_REQUIRED'))) {
            errorMessages.push(t('MIN_AND_MAX_VALUE_REQUIRED'));
          }
          isValid = false;
        }

        if (tempComponentData.tempDependency.quantity.range.max < 1) {
          if (!error.quantity) error.quantity = {};
          if (!error.quantity.range) error.quantity.range = {};
          error.quantity.range.max = t('MANDATORY_FIELD_ERROR');
          if (!errorMessages.includes(t('MIN_AND_MAX_VALUE_REQUIRED'))) {
            errorMessages.push(t('MIN_AND_MAX_VALUE_REQUIRED'));
          }
          isValid = false;
        }

        if (
          +tempComponentData.tempDependency.quantity.range.max > 0 &&
          +tempComponentData.tempDependency.quantity.range.min > 0 &&
          +tempComponentData.tempDependency.quantity.range.max <
          +tempComponentData.tempDependency.quantity.range.min
        ) {
          if (!error.quantity) error.quantity = {};
          if (!error.quantity.range) error.quantity.range = {};
          error.quantity.range.max = t('MANDATORY_FIELD_ERROR');
          if (!errorMessages.includes(t('MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE'))) {
            errorMessages.push(t('MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE'));
          }
          isValid = false;
        }
      }
    }

    if (!isValid) {
      setDependencyError(error);
      // Show the first (most relevant) error message in toast
      if (errorMessages.length > 0) {
        props.setErrorMessage(errorMessages[0], false);
      }
    } else {
      setDependencyError({});
    }

    return isValid;
  };

  const addDependencies = (row) => {
    if (!validateDependencies()) {
      return; // Stop if validation fails
    }
    setDialogErrorMsg("");
    let tempComponentData = { ...componentData };
    if (
      !tempComponentData.tempDependency.dependerBucketName ||
      !tempComponentData.tempDependency.dependencyType
      // !tempComponentData.tempDependency.cardinality.range.min ||
      // !tempComponentData.tempDependency.cardinality.range.max
    ) {
      // setDialogErrorMsg(t("ALL_FIELDS_REQUIRED_TO_ADD_DEPENDENCY"));
      // props.setErrorMessage(t('ALL_FIELDS_REQUIRED_TO_ADD_DEPENDENCY'), false);
      // return;
    } else {
      // if()
      if (
        tempComponentData.tempDependency.dependerBucketName ===
        "PACKAGED_SOLUTION"
      ) {
        tempComponentData.tempDependency.dependerType = "PACKAGED_SOLUTION";
      } else {
        if (!tempComponentData.tempDependency.depender) {
          // props.setErrorMessage(t('ALL_FIELDS_REQUIRED_TO_ADD_DEPENDENCY'), false);
          // setDialogErrorMsg(t("ALL_FIELDS_REQUIRED_TO_ADD_DEPENDENCY"));
          // return;
        } else {
          tempComponentData.tempDependency.dependerType = "COMPONENT";
        }
      }
      if (tempComponentData.tempDependency.dependencyType === "Mandatory") {
        if (tempComponentData.tempDependency.cardinality.range.min < 1) {
          // props.setErrorMessage(t('QUANTITY_IS_REQUIRED_FOR_MANDATORY_ITEMS'), false);
          // setDialogErrorMsg(t("QUANTITY_IS_REQUIRED_FOR_MANDATORY_ITEMS"));
          // return;
        }
        if (tempComponentData.tempDependency.cardinality.type === "Range") {
          if (
            tempComponentData.tempDependency.cardinality.range.max >=
            tempComponentData.tempDependency.cardinality.range.min
          ) {
          } else {
            // props.setErrorMessage(t('MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE'), false);
            // setDialogErrorMsg(t("MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE"));
            // return;
          }
        } else {
          tempComponentData.tempDependency.cardinality.range.max =
            tempComponentData.tempDependency.cardinality.range.min;
        }
      } else {
        // tempComponentData.tempDependency.cardinality.range.min = 0;
        // tempComponentData.tempDependency.cardinality.type = 'Range';
        if (
          tempComponentData.tempDependency.cardinality.type === "Exact" &&
          tempComponentData.tempDependency.cardinality.range.min > 0
        ) {
          tempComponentData.tempDependency.cardinality.range.max =
            tempComponentData.tempDependency.cardinality.range.min;
          // tempComponentData.tempDependency.cardinality.type = 'Exact';
        } else if (
          tempComponentData.tempDependency.cardinality.type === "Range" &&
          (tempComponentData.tempDependency.cardinality.range.max ||
            tempComponentData.tempDependency.cardinality.range.min)
        ) {
          if (tempComponentData.tempDependency.cardinality.range.min < 1) {
            // setDialogErrorMsg(t("MIN_AND_MAX_VALUE_REQUIRED"));
            // props.setErrorMessage(t('MIN_AND_MAX_VALUE_REQUIRED'), false);
            // return;
          }
          if (tempComponentData.tempDependency.cardinality.range.max < 1) {
            // setDialogErrorMsg(t("MIN_AND_MAX_VALUE_REQUIRED"));
            // props.setErrorMessage(t('MIN_AND_MAX_VALUE_REQUIRED'), false);
            // return;
          }
          if (
            tempComponentData.tempDependency.cardinality.range.max >=
            tempComponentData.tempDependency.cardinality.range.min
          ) {
          } else {
            // setDialogErrorMsg(t("MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE"));
            // props.setErrorMessage(t('MAX_VALUE_CANNOT_BE_LESS_THAN_MIN_VALUE'), false);
            // return;
          }
        }
      }
    }
    if (tempComponentData.chipData) {
    } else {
      tempComponentData.chipData = [];
    }
    tempComponentData.chipData.push(componentData.tempDependency);
    if (!isEdit) {
      if (tempComponentData.relationShips.dependsOn) {
        tempComponentData.relationShips.dependsOn.push({
          ...componentData.tempDependency,
        });
      } else {
        tempComponentData.relationShips.dependsOn = [];
        tempComponentData.relationShips.dependsOn.push({
          ...componentData.tempDependency,
        });
      }
    }
    let defaultTempDependencyData = {
      dependerBucketName: "",
      depender: "",
      dependencyMode: "forEach",
      dependerProviderType: "",
      dependerName: "",
      cardinality: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      quantity: {
        type: "Exact",
        range: {
          min: "",
          max: "",
        },
      },
      dependencyType: "Mandatory",
    };
    tempComponentData.tempDependency = defaultTempDependencyData;
    tempComponentData.selectedBucketComponents = [];

    setDependencyError({});
    setComponentData(tempComponentData);
  };

  const removeTempDependency = (index) => {
    let tempComponentData = JSON.parse(JSON.stringify(componentData));
    tempComponentData.chipData.splice(index, 1);
    // if (tempComponentData.relationShips && tempComponentData.relationShips.dependsOn) {
    // 	tempComponentData.relationShips.dependsOn.splice(index, 1);
    // }
    setComponentData(tempComponentData);
  };

  const [selectedToRemove, setComponentToRemove] = useState({
    row: {},
    index: "",
  });
  const [openRemoveComponentConfirmation, changeComponentConfirmation] =
    useState(false);

  const openRemoveConfirmation = (row, index) => {
    setComponentToRemove({
      row: row,
      index: index,
    });
    changeComponentConfirmation(true);
  };
  const removeComponent = (value) => {
    if (value) {
      props.blockNavigation();
      changeComponentConfirmation(false);
      props.removeItemFromBucket(selectedToRemove.row);
    } else {
      setComponentToRemove({
        row: {},
        index: "",
      });
      changeComponentConfirmation(false);
    }
  };

  const getBucketName = (id) => {
    if (id === "PACKAGED_SOLUTION") {
      return t("ALL");
    }
    var selectedBucketDetails = jp.query(
      props.bucketList,
      '$..[?(@.id=="' + id + '")]',
    );
    if (selectedBucketDetails && selectedBucketDetails.length > 0) {
      return selectedBucketDetails[0].name;
    }
  };

  // const applyPromo = (componentNode, event) => {
  // 	let controlValue = event.target.checked;
  // 	if (!controlValue) {
  // 		delete componentNode.promoPrice;
  // 		componentNode.promoApplied = false;
  // 	} else {
  // 		componentNode.promoPrice = [
  // 			{
  // 				name: componentNode.name,
  // 				featureCode: componentNode.featureCode,
  // 				price: componentNode.price,
  // 			},
  // 		];
  // 		componentNode.promoApplied = true;
  // 	}
  // };

  // const applyPromoForcefully = (componentNode) => {
  // 	componentNode.promoPrice = [
  // 		{
  // 			name: componentNode.name,
  // 			featureCode: componentNode.featureCode,
  // 			price: componentNode.price,
  // 		},
  // 	];
  // 	componentNode.promoApplied = true;
  // };

  const showBucketsList = () => {
    let bucketIndex = props.bucketList.findIndex(
      (a) => a.id === props.selectedBucketId,
    );
    if (bucketIndex === 0) {
      return false;
    } else {
      return true;
    }
  };

  const [currentTab, changeTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    changeTab(newValue);
  };

  const [openUnsavedChangesModal, setOpenUnsavedChangesModal] = useState(false);
  const closeUnsavedChangesDialog = (val) => {
    if (val) {
      const data = JSON.parse(JSON.stringify(tempEditRow));
      setIsEdit(true);
      //saved data to componentData
      setComponentFormDetails({ ...data }, "editExisting");
      window.scrollTo(0, 0);
      props.setUnsavedChanges(tempEditRow);
    }
    setOpenUnsavedChangesModal(false);
  };

  const [activationResourceList, setActivationResources] = useState([]);
  const [provisioningResourceList, setProvisioningResources] = useState([]);
  const [suspendResourceList, setSuspendResources] = useState([]);
  const [resumeResourceList, setResumeResources] = useState([]);
  const [preQualResourcesList, setPreQualResourcesList] = useState([]);
  //configuration methods
  const getResources = (resourceType) => {
    BusApiCall(
      "GET",
      `${constants.busV4Url}/resources?type=${resourceType}&associationType=${resourceType === "QUALIFICATION" ? "PROD_COMP_ALL" : props.selectedBucketId}`,
    )
      .then((res) => {
        let data = res.data;
        // if (data && data.resourceList && data.resourceList.length > 0) {
        // 	data.resourceList.sort((a, b) => (a.resourceName > b.resourceName) ? 1 : ((b.resourceName > a.resourceName) ? -1 : 0));
        // 	if (resourceType === "ACTIVATION") {

        // 	} else if (resourceType === "PROVISIONING") {
        // 		setProvisioningResources(data.resourceList);
        // 	} else if (resourceType === "SUBSCRIPTION_SUSPEND") {
        // 		setSuspendResources(data.resourceList);
        // 	} else if (resourceType === "SUBSCRIPTION_RESUME") {
        // 		setResumeResources(data.resourceList);
        // 	}
        // }
        if (data && data.resourceList && data.resourceList.length > 0) {
          data.resourceList.sort((a, b) =>
            a.resourceName > b.resourceName
              ? 1
              : b.resourceName > a.resourceName
                ? -1
                : 0,
          );
          if (resourceType === "ACTIVATION") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_ACT") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            setActivationResources(list);
          } else if (resourceType === "PROVISIONING") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_PROV") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            setProvisioningResources(list);
          } else if (resourceType === "SUBSCRIPTION_SUSPEND") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_SUSPEND") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            setSuspendResources(list);
          } else if (resourceType === "SUBSCRIPTION_RESUME") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_RESUME") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            setResumeResources(list);
          } else if (resourceType === "QUALIFICATION") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_RESUME") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            if (props.preQuals.length > 0) {
              for (var i = 0; i < props.preQuals.length; i++) {
                list.some((obj) => {
                  if (obj.resourceId === props.preQuals[i].resourceId) {
                    return (obj.selected = true);
                  }
                });
              }
            }
            setPreQualResourcesList(list);
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(t("DEFAULT_ERROR_MESSAGE"), false);
        }
      });
  };

  const [showAddComponent, setAddComponent] = useState(false);
  const [addComponentType, setAddComponentType] = useState();
  const openComponentDialog = (type) => {
    openPackageTemplateDialog(false);
    setAddComponentType(type);
    setAddComponent(true);
  };

  const closeComponentDialog = (val) => {
    if (val) {
      if (val.children) {
        for (var i = 0; i < val.children.length; i++) {
          delete val.children[i].expandKitComponents;
        }
      }
      val.assembly = addComponentType === "assembly" ? true : false;
      props.setLoading(true);
      BusApiCall("POST", `${constants.busV4Url}/components/products`, val)
        .then((productRes) => {
          if (productRes.data.productId) {
            props.setErrorMessage(t("PRODUCT_CREATED_SUCCESSFULLY"), true);
            BusApiCall(
              "GET",
              `${constants.busV4Url}/catalogs/products?componentType=${props.selectedBucketId}&mode=pmui`,
            )
              .then((res) => {
                let data = res.data;
                if (data) {
                  if (data.length > 0) {
                    data[0].price = JSON.parse(data[0].price).toFixed(2);
                  }
                  let product = {};
                  for (var i = 0; i < data.length; i++) {
                    if (data[i].id === productRes.data.productId) {
                      product = data[i];
                    }
                  }
                  closePackageTemplateDialog(product);
                  props.setLoading(false);
                  setAddComponent(false);
                }
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  props.setErrorMessage(err.response.data.message, false);
                } else {
                  props.setErrorMessage(t("DEFAULT_ERROR_MESSAGE"), false);
                }
                props.setLoading(false);
              });
          } else {
            setProductErrorMessage(productRes.data.message);
          }
        })
        .catch((err) => {
          props.setLoading(false);
          // setAddComponent(false);
          // if (err.response && err.response.data && err.response.data.message) {
          // 	props.setErrorMessage(err.response.data.message, false)
          // } else {
          // 	props.setErrorMessage(t('DEFAULT_ERROR_MESSAGE'), false)
          // }
          setProductErrorMessage(
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : this.props.t("DEFAULT_ERROR_MESSAGE"),
          );
        });
    } else {
      setAddComponent(false);
    }
  };

  // New code for pre-qual
  const [selectedResource, setSelectedResource] = useState({});
  const [connectionFields, setConnectionFields] = useState({});
  const [tableFields, setTableFields] = useState([]);
  const [tableEditable, setTableEditable] = useState(false);
  const [uploadedFile, setUploadedFileName] = useState("");

  const selectResource = (object) => {
    let connectionFields = {};
    let parameters = [];
    let paramsUpdatable = false;
    if (object) {
      if (object.connectionFields && object.connectionFields.length > 0) {
        object.connectionFields.map((field, i) => {
          connectionFields[field] = "";
        });
      }
      if (object.parameters && object.parameters !== null) {
        parameters = JSON.parse(object.parameters);
      }
      paramsUpdatable = object.paramsUpdatable ? object.paramsUpdatable : false;
    } else {
      object = {};
    }
    setSelectedResource(object);
    setConnectionFields(connectionFields);
    setTableFields(parameters);
    setTableEditable(paramsUpdatable);
  };

  const updateConnectionFields = (e) => {
    let tempData = { ...connectionFields };
    tempData[e.target.name] = e.target.value;
    setConnectionFields(tempData);

    let tempResource = { ...selectedResource };
    if (selectedResource.targetTypeId === "EMAIL") {
      tempResource.targetAddress = e.target.value;
    } else if (selectedResource.targetTypeId === "REST_ENDPOINT") {
      if (e.target.name === "URL") {
        tempResource.targetAddress = e.target.value;
      } else {
        tempResource.targetAddress = "";
      }
    } else {
      tempResource.targetAddress = "";
    }
    setSelectedResource(tempResource);
  };

  const updateTableFields = (i, e) => {
    let tempData = [...tableFields];
    tempData[i][e.target.name] = e.target.value;
    if (e.target.name === "label") {
      tempData[i].name = setCamelCase(e.target.value);
    }
    setTableFields(tempData);
  };

  const setCamelCase = (str) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  };

  const onuploadedFileChange = (e) => {
    let file = e.target.files[0];
    if (file.type === "application/json") {
      setUploadedFileName(e.target.files[0].name);
      const reader = new FileReader();
      let jsonContent = "";
      reader.readAsText(file);
      reader.onload = function () {
        jsonContent = reader.result;
        let jsonObject = JSON.parse(jsonContent);
        var url = jp.query(jsonObject, "$..servers[0].url");
        var allrefs = jp.query(jsonObject, "$..post..schema");
        let post_schemas = allrefs;
        let refSchema = post_schemas[0].$ref;
        var pieces = refSchema.split(/[\s\/]+/);
        var postParameters = jp.query(
          jsonObject,
          "$.components.schemas." + pieces[pieces.length - 1] + ".properties",
        );
        let connectionFields = { ...connectionFields };
        connectionFields.URL = url[0];
        setConnectionFields(connectionFields);
        let localSelectedRes = { ...selectedResource };
        localSelectedRes.targetAddress = connectionFields.URL;
        setSelectedResource(localSelectedRes);

        for (var i = 0; i < postParameters.length; i++) {
          let tempData = [...tableFields];
          for (const [key, value] of Object.entries(postParameters[i])) {
            let obj = {
              label: value.label,
              name: setCamelCase(key),
              type: value.type,
              validation: value.validation,
            };
            tempData.push(obj);
          }
          if (postParameters.length === i + 1) {
            setTableFields(tempData);
          }
        }
      };
    } else {
      props.setErrorMessage(t("INVALID_FILE_FORMAT"), false);
    }
  };

  const addNewRow = () => {
    let obj = {
      name: "",
      type: "string",
      label: "",
      validation: "",
    };
    let tempData = [...tableFields];
    tempData.push(obj);
    setTableFields(tempData);
  };

  const removeRow = (index) => {
    let tempData = [...tableFields];
    tempData.splice(index, 1);
    setTableFields(tempData);
  };

  const submitData = () => {
    var prequalData = {};
    if (selectedResource.resourceId) {
      prequalData.resourceId = selectedResource.resourceId
        ? selectedResource.resourceId
        : "";
      prequalData.providerId = selectedResource.providerId
        ? selectedResource.providerId
        : "";
      prequalData.targetTypeId = selectedResource.targetTypeId
        ? selectedResource.targetTypeId
        : "";
      prequalData.targetAddress = selectedResource.targetAddress
        ? selectedResource.targetAddress
        : "";

      prequalData.extraFields = connectionFields;
      let temptableFields = [];
      for (let i = 0; i < tableFields.length; i++) {
        if (tableFields[i].label) {
          temptableFields.push(tableFields[i]);
        }
      }
      prequalData.parameters = tableFields
        ? JSON.stringify(temptableFields)
        : "";

      if (mode === "add") {
        let list = [...preQualResourcesList];
        list.some((obj) => {
          if (obj.resourceId === prequalData.resourceId) {
            return (obj.selected = true);
          }
        });
        setPreQualResourcesList(list);
        props.addPreQual(prequalData);
      } else {
        props.editPreQual(prequalData, editObject.index);
        setMode("add");
      }
      setSelectedResource({});
      setConnectionFields({});
      setTableFields([]);
      setUploadedFileName("");
      setTableEditable(false);
    }
  };
  const [mode, setMode] = useState("add");
  const [editObject, setEditObject] = useState({});
  const editPreQual = (object, index) => {
    object.index = index;
    setMode("edit");
    setEditObject(object);
    let connectionFields = {};
    let parameters = [];
    let paramsUpdatable = false;
    let orginalResource = preQualResourcesList.find(
      (x) => x.resourceId === object.resourceId,
    );
    if (object) {
      if (
        orginalResource.connectionFields &&
        orginalResource.connectionFields.length > 0
      ) {
        orginalResource.connectionFields.map((field, i) => {
          connectionFields[field] = object.extraFields[field];
        });
      }
      if (object.parameters && object.parameters !== null) {
        parameters = JSON.parse(object.parameters);
      }
      paramsUpdatable = orginalResource.paramsUpdatable
        ? orginalResource.paramsUpdatable
        : false;
      object.resourceName = orginalResource.resourceName;
    } else {
      object = {};
    }
    setSelectedResource(object);
    setConnectionFields(connectionFields);
    setTableFields(parameters);
    setTableEditable(paramsUpdatable);
  };

  const cancelEdit = () => {
    setMode("add");
    setSelectedResource({});
    setConnectionFields({});
    setTableFields([]);
    setUploadedFileName("");
    setTableEditable(false);
  };

  const getPriceTenureUOM = (val) => {
    // console.log('getpricetemure===', val);
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else {
      return "";
    }
  };
  // Enrichment code start
  const [selectedEnrichmentChannel, selectEnrichmentChannel] = useState("");
  const addEnrichmentRow = (parentId) => {
    if (selectedEnrichmentChannel) {
      var row = {
        id: selectedEnrichmentChannel,
        purchaseable: false,
        removeable: false,
        rePurchaseable: false,
        visible: false,
      };
      props.addEnrichmentRow(row, parentId);
    }
  };
  // Enrichment code end
  const onChangeAttribute = (e) => {
    props.setErrorMessage("", false);
    setDialogErrorMsg("");
    var tempData = { ...componentData };
    var index = tempData.customAttributes.findIndex(
      (x) => x.attrName === e.target.name,
    );
    if (index > -1) {
      if (tempData.customAttributes[index].valueType === "boolean") {
        if (tempData.customAttributes[index].attrValue) {
          tempData.customAttributes[index].attrValue = false;
        } else {
          tempData.customAttributes[index].attrValue = true;
        }
      } else {
        tempData.customAttributes[index].attrValue = e.target.value;
      }
      if (tempData.existing) {
        tempData.customAttributes[index].update = false;
      } else {
        tempData.customAttributes[index].update = true;
      }
      setComponentData(tempData);
    }
  };

  const [customAttributesList, setCustomAttributesList] = useState([]);
  const filterCustomAttributes = () => {
    var selectedBucketIndex = props.bucketList.findIndex(
      (x) => x.id === props.selectedBucketId,
    );
    var selectedBucket = props.bucketList[selectedBucketIndex];
    var customAttributes =
      selectedBucket && selectedBucket.customAttributes
        ? selectedBucket.customAttributes
        : [];
    setCustomAttributesList(customAttributes);
  };

  const [openDependencyWarning, setDependencyWarning] = useState(false);
  const closeDependencyWarning = (val) => {
    if (val) {
      if (isEdit) {
        updateBucketItem();
      } else {
        addBucketItem();
      }
    }
    setDependencyWarning(false);
  };

  const updateVariantData = (e, component, variantIndex) => {
    var tempData = { ...componentData };
    if (componentData.id && componentData.id === component.id) {
      var variant = tempData.variants[variantIndex];
      var controlName = e.target.name;
      if (
        controlName === "name" ||
        controlName === "description" ||
        controlName === "price" ||
        controlName === "featureCode"
      ) {
        variant[e.target.name] = e.target.value;
        setComponentData(tempData);
      }
    }
  };

  const [productErrorMessage, setProductErrorMessage] = useState("");
  const resetErrorMessage = () => {
    setProductErrorMessage("");
  };

  // View rpoduct details items
  const [showProductDetails, setViewPorductDetails] = useState(false);
  const [productDetails, setProductDetails] = useState({});

  const openShowDetails = (product) => {
    setProductDetails(product);
    setViewPorductDetails(true);
  };

  const onChangeOtherPrice = (e, type) => {
    if (e.target.value >= 0) {
      const updatedOtherPrices = componentData.otherPrices.map((price) => {
        if (price.priceType === type) {
          let t = e.target.value;
          let tPrice =
            t.indexOf(".") >= 0
              ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
              : t;
          return { ...price, [e.target.name]: tPrice };
        }
        return price;
      });
      setComponentData({ ...componentData, otherPrices: updatedOtherPrices });
    } else {
      const updatedOtherPrices = componentData.otherPrices.map((price) => {
        if (price.priceType === type) {
          return { ...price, [e.target.name]: "" };
        }
        return price;
      });
      setComponentData({ ...componentData, otherPrices: updatedOtherPrices });
    }
  };

  // const onChangeOtherPrice = (e, type) => {
  //   var data = { ...componentData };
  //   // if (e.target.value >= 0) {
  //   // 	for (var i = 0; i < data.otherPrices.length; i++) {
  //   // 		if (data.otherPrices[i].priceType === type) {
  //   // 			data.otherPrices[i][e.target.name] = e.target.value + "";
  //   // 		}
  //   // 	}
  //   // 	setComponentData(data);
  //   // }
  //   if (e.target.value >= 0) {
  //     for (var i = 0; i < data.otherPrices.length; i++) {
  //       if (data.otherPrices[i].priceType === type) {
  //         let t = e.target.value;
  //         let tPrice =
  //           t.indexOf(".") >= 0
  //             ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
  //             : t;
  //         data.otherPrices[i][e.target.name] = tPrice;
  //         setComponentData(data);
  //       }
  //     }
  //   } else {
  //     for (var i = 0; i < data.otherPrices.length; i++) {
  //       if (data.otherPrices[i].priceType === type) {
  //         data.otherPrices[i][e.target.name] = "";
  //         setComponentData(data);
  //       }
  //     }
  //   }
  // };

  const onBlurOtherPrice = (e, type) => {
    const formatted = Number(e.target.value || 0).toFixed(2);
    const data = { ...componentData };
    for (let i = 0; i < data.otherPrices.length; i++) {
      if (data.otherPrices[i].priceType === type) {
        data.otherPrices[i][e.target.name] = formatted;
        setComponentData(data);
        break;
      }
    }
  };

  const onVariantChange = (e, index) => {
    var data = { ...componentData };
    data.variants[index][e.target.name] = e.target.value;
    setComponentData(data);
  };

  const disableOtherPriceOption = (list) => {
    if (list && list.length > 0) {
      var tempList = [];
      var allOtherPricesList = [...componentData.allOtherPricesList];
      for (var i = 0; i < allOtherPricesList.length; i++) {
        let items = jp.query(
          list,
          '$..[?(@.priceType=="' + allOtherPricesList[i].value + '")]',
        );
        if (items.length > 0) {
          if (items.length === 1) {
            if (items[0].remove) {
              tempList.push(allOtherPricesList[i]);
            } else {
              tempList.push({ ...allOtherPricesList[i], disabled: true });
            }
          } else {
            tempList.push(allOtherPricesList[i]);
          }
        } else {
          tempList.push(allOtherPricesList[i]);
        }
      }
      setComponentData((prevState) => ({
        ...prevState,
        priceOptions: tempList,
      }));
    } else {
      var tempList = [...componentData.allOtherPricesList];
      setComponentData((prevState) => ({
        ...prevState,
        priceOptions: tempList,
      }));
    }
  };

  function extractLeafCategories(categories) {
    let leafCategories = [];

    function traverse(category) {
      if (!category.subCategories || category.subCategories.length === 0) {
        leafCategories.push(category);
      } else {
        for (let subCategory of category.subCategories) {
          traverse(subCategory);
        }
      }
    }

    for (let category of categories) {
      traverse(category);
    }

    return leafCategories;
  }

  const numbersOnly = (e) => {
    // List of keys to block: +, -, e, E
    if (["+", "-", "e", "E", "."].includes(e.key)) {
      e.preventDefault(); // Block the key
    }
  };

  const productStateChange = (allow, action) => {
    setStateChangeDialog(true);
    setStateChangeDialogAction(action);
  };

  const stateChangeDialogResponse = (value) => {
    if (value == "true") {
      if (stateChangeDialogAction == "P_RETIRED") {
        props.changeProductStatus(true, "P_RETIRED");
      } else if (stateChangeDialogAction == "P_OBSOLETE") {
        props.changeProductStatus(true, "P_OBSOLETE");
      } else {
        props.submitPackageJSON("REVIEW");
      }
    } else if (value == undefined) {
      props.setErrorMessage(t("FILL_TASK_FORM"), false);
    } else {
      setStateChangeDialog(false);
    }
  };

  const selectStateChangeRadioResponse = (e) => {
    setStateChangeRadioResponse(e.target.value);
  };

  const goBack = () => {
    if (currentTab !== 0 && currentTab !== 2) {
      handleTabChange("", currentTab - 1);
    } else if (currentTab === 2) {
      if (showAssemblyInstructions) {
        handleTabChange("", 1);
      } else {
        handleTabChange("", 0);
      }
    } else if (currentTab === 0) {
      props.goBack();
    }
  };

  const publishList = (
    <Grid
      item
      style={{ borderRight: "1px solid lightgrey", padding: "1rem" }}
      size={{
        xs: 12,
        md: 3,
      }}
    >
      {/* tabs */}
      <List>
        {[
          { text: t("CONFIGURATIONS"), value: 0 },
          showAssemblyInstructions && {
            text: t("ASSEMBLY_INSTRUCTIONS"),
            value: 1,
          },
          { text: t("T&C"), value: 2 },
          { text: t("PREQUALS"), value: 3 },
          { text: t("CUSTOMERS"), value: 4 },
        ]
          .filter(Boolean)
          .map((tab, index) => (
            <React.Fragment key={index}>
              <ListItem
                button
                key={tab.text}
                // className={currentTab === tab.value ? classess.selected : classess.listItem}
                onClick={(e) => {
                  handleTabChange(e, tab.value);
                  props.toggleShowCategory();
                }}
                style={
                  {
                    // borderLeft: currentTab === tab.value ? `2px solid ${props.tenantData.color}` : `2px solid white`,
                    // fontWeight: currentTab === tab.value ? 'bold' : 'normal',
                    // display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                  }
                }
              >
                <ListItemText
                  // style={{ color: currentTab === tab.value ? props.tenantData.color : "inherit" }}
                  primary={tab.text}
                />
              </ListItem>
            </React.Fragment>
          ))}
      </List>
    </Grid>
  );

  const publishTabData = () => {
    return (
      <>
        <Grid item size={{ xs: 12, md: 12 }} style={{ padding: '1rem' }}>
          {currentTab === 0 &&
            props.providerType === "SALES_CHNL_PROVIDER" && (
              <>
                {/* <div className={classes.div__container}> */}
                {isMobile && <h3>{t("CONFIGURATIONS")}</h3>}
                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  style={{ marginTop: "1rem" }}
                >
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <Grid container spacing={2} justifyContent="center">
                      {/* <Grid item xs={12}>
													<FormControlLabel
														checked={props.orderApproval}
														control={<Checkbox color="primary" />}
														label="Require Order Approval"
														labelPlacement="end"
														className={classes.requireApproval}
														onChange={props.updateTrigger}
														name="orderApproval"
													// style={{ marginBottom: '15px', paddingLeft: '8px' }}s
													/>
												</Grid> */}

                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          name={"termTenure"}
                          type={"number"}
                          min={0}
                          value={props.termTenure}
                          placeholder={t("TERM_TENURE")}
                          onChange={(e) => {
                            if (
                              e.target.value >= 0 ||
                              e.target.value === ""
                            ) {
                              props.updateOfferingTerm(e);
                            }
                          }}
                          onKeyDown={(e) => {
                            numbersOnly(e);
                          }}
                          // disabled={props.state.statusDisplayName === 'Published'}
                          disabled={props.state.status === "P_PUBLISHED"}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                        >
                          <InputLabel
                            id="termTenureUOM"
                            htmlFor="outlined-age-native-simple"
                            style={{
                              backgroundColor: "white",
                              padding: "0 8px",
                              opacity: 1,
                            }}
                            shrink={true}
                          >
                            {t("TERM_TENURE_UOM")}
                          </InputLabel>
                          <Select
                            label="TERM_TENURE_UOM"
                            native
                            labelId="termTenureUOM"
                            value={props.termTenureUOM}
                            onChange={props.updateOfferingTerm}
                            inputProps={{
                              name: "termTenureUOM",
                              id: "termTenureUOM",
                            }}
                            disabled={
                              props.termTenure === 0 ||
                              props.termTenure === "0" ||
                              props.termTenure === "" ||
                              props.state.status === "P_PUBLISHED"
                            }
                          >
                            <option value=""></option>
                            <option value="TF_day">{t("DAY")}</option>
                            <option value="TF_mon">{t("MONTH")}</option>
                            <option value="TF_wk">{t("WEEK")}</option>
                            <option value="TF_yr">{t("YEAR")}</option>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          name={"termNoticePeriod"}
                          type={"number"}
                          min={0}
                          value={props.termNoticePeriod}
                          placeholder={t("TERM_NOTICE_PERIOD")}
                          // onChange={props.updateOfferingTerm}
                          onChange={(e) => {
                            if (
                              e.target.value >= 0 ||
                              e.target.value === ""
                            ) {
                              props.updateOfferingTerm(e);
                            }
                          }}
                          onKeyDown={(e) => {
                            numbersOnly(e);
                          }}
                          // disabled={props.state.statusDisplayName === 'Published'}
                          disabled={props.state.status === "P_PUBLISHED"}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        // disabled={!props.termTenure || props.termTenure === '0' || props.termTenure === 0}
                        />
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                        // disabled={props.termNoticePeriod === 0 || props.termNoticePeriod === '0' || props.termNoticePeriod === ''}
                        >
                          <InputLabel
                            id="termNoticePeriodUOM"
                            htmlFor="outlined-age-native-simple"
                            shrink={true}
                            style={{
                              backgroundColor: "white",
                              padding: "0 8px",
                              opacity: "1",
                            }}
                          >
                            {t("TERM_NOTICE_PERIOD_UOM")}
                          </InputLabel>
                          <Select
                            native
                            label="TERM_NOTICE_PERIOD_UOM"
                            labelId="termNoticePeriodUOM"
                            value={props.termNoticePeriodUOM}
                            onChange={props.updateOfferingTerm}
                            inputProps={{
                              name: "termNoticePeriodUOM",
                              id: "termNoticePeriodUOM",
                            }}
                            disabled={
                              props.termNoticePeriod === 0 ||
                              props.termNoticePeriod === "0" ||
                              props.termNoticePeriod === "" ||
                              props.state.status === "P_PUBLISHED"
                            }
                          >
                            <option value=""></option>
                            <option value="TF_day">{t("DAY")}</option>
                            <option value="TF_mon">{t("MONTH")}</option>
                            <option value="TF_wk">{t("WEEK")}</option>
                            <option value="TF_yr">{t("YEAR")}</option>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <TextField
                          name={"releaseDate"}
                          type="date"
                          size="small"
                          variant="outlined"
                          label={t("RELEASE_DATE")}
                          value={props.releaseDate}
                          onChange={props.updateTrigger}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          // disabled={props.state.statusDisplayName === 'Published'}
                          disabled={props.state.status === "P_PUBLISHED"}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <TextField
                          error={!!props.error.expiryDate}
                          name={"expiryDate"}
                          type="date"
                          size="small"
                          variant="outlined"
                          label={t("EXPIRY_DATE")}
                          value={props.expiryDate}
                          onChange={props.updateTrigger}
                          inputProps={{ min: props.releaseDate }}
                          // disabled={props.state.statusDisplayName === 'Published'}
                          disabled={props.state.status === "P_PUBLISHED"}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        {/* <FormControlLabel
                          // style={{ marginLeft: '2px' }}
                          disabled={props.state.status === "P_PUBLISHED"}
                          control={
                            <Checkbox
                              checked={props.showOfferingQty}
                              onChange={event => props.changeShowOfferingQty(event)}
                              name={"showOfferingQty"}
                              color="primary"
                            />
                          }
                          label={t("SHOW_OFFERING_QUANTITY")}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                        // disabled={props.termNoticePeriod === 0 || props.termNoticePeriod === '0' || props.termNoticePeriod === ''}
                        >
                          <InputLabel
                            id="showOfferingQty"
                            htmlFor="outlined-age-native-simple"
                            shrink={true}
                            style={{
                              backgroundColor: "white",
                              padding: "0 0px",
                              opacity: "1",
                            }}
                          >
                            {t("QUANTITY_HANDLING")}
                          </InputLabel>
                          <Select
                            native
                            label="QUANTITY_CON"
                            labelId="showOfferingQty"
                            value={props.showOfferingQty}
                            onChange={event => props.changeShowOfferingQty(event)}
                            inputProps={{
                              name: "showOfferingQty",
                              id: "showOfferingQty",
                            }}
                            disabled={props.state.status === "P_PUBLISHED"}
                          >
                            <option value={true}>Editable</option>
                            <option value={false}>Fixed to 1 (Hidden in Sales)</option>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <Tooltip title="Controls whether quantity is shown and editable when adding the offering during sales.">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ position: 'relative', top: '7px', left: '-14px' }}
                          >
                            <g clipPath="url(#clip0_380_7010)">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                fill="#96A1B0"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_380_7010">
                                <rect
                                  width="12"
                                  height="12"
                                  fill="white"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </Tooltip>
                      </Grid>
                      <div style={{ minHeight: "1em" }}>
                        {props.error.expiryDate ? (
                          <Typography color="error">
                            {props.error.expiryDate}
                          </Typography>
                        ) : (
                          <span>&nbsp;</span>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                  {/* <Divider orientation={isMobile ? "horizontal" : "vertical"} flexItem /> */}
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <Grid container spacing={2} style={{ display: 'block' }}>
                      {props.packageMode == "edit" &&
                        props.productHistoryDetails &&
                        props.productHistoryDetails.length > 0 && (
                          <ComponentComments
                            showApprovalLink={true}
                            showCommentInput={false}
                            nextTask={props.nextTask}
                            status={props.status}
                            comments={props.productHistoryDetails}
                            offeringProductId={props.state.packageId}
                            productStateChange={productStateChange}
                            submitPackageJSON={props.submitPackageJSON}
                            changeProductStatus={
                              props.changeProductStatus
                            }
                            confirmApprove={props.confirmApprove}
                          />
                        )}

                      {/* 												
												<Grid item xs={12}>
													<Grid item xs={12}>
														{t("BILLING_TRIGGER")}
													</Grid>
													<Grid item xs={12}>
														<FormControl className={classes.billingTriggerPhase}>
															<RadioGroup
																defaultValue="DEFAULT"
																value={props.billingTriggerPhase}
																aria-label="activationTrigger"
																name="billingTriggerPhase"
																row
																onChange={props.updateTrigger}
																style={{ paddingLeft: "8px" }}
															>
																<FormControlLabel
																	value="DEFAULT"
																	control={<Radio color="primary" />}
																	label={t("DEFAULT")}
																	labelPlacement="right"
																	style={{ paddingRight: "14px" }}
																/>
																<FormControlLabel
																	value="ACTIVATION"
																	control={<Radio color="primary" />}
																	label={t("ACTIVATION")}
																	labelPlacement="right"
																	style={{ paddingRight: "14px" }}
																/>
																<FormControlLabel
																	value="PROVISIONING"
																	control={<Radio color="primary" />}
																	label={t("PROVISIONING")}
																	labelPlacement="right"
																/>
															</RadioGroup>
														</FormControl>
													</Grid>
												</Grid>
												<Grid item xs={12}>
													<FormControl variant="outlined" className="custom-select-input" size={"small"}>
														<InputLabel htmlFor={"selectedBucket"}> {t("COMPONENT_TYPE")} </InputLabel>
														<Select
															native
															onChange={props.updateTrigger}
															labelId={"billingTriggerComponentTypeLabel"}
															inputProps={{
																name: "selectedBucket",
																id: "selectedBucket",
															}}
															value={props.selectedBucket}
															disabled={props.billingTriggerPhase === "DEFAULT"}
															label={t("COMPONENT_TYPE")}
														>
															<option value=""></option>
															{props.bucketList
																.sort((a, b) => (a && b ? a.sequenceNum - b.sequenceNum : 0))
																.map(
																	(bucket, index) =>
																		bucket.sequenceNum !== props.bucketSeqNum && //the currect bucket shouldn  't be displayed
																		bucket.sequenceNum < props.bucketSeqNum && ( //only the bucket which are prior to the current ones should be displayed
																			<option key={index} value={bucket.id}>
																				{bucket.name}
																			</option>
																		)
																)}
														</Select>
													</FormControl>
												</Grid>
												<Grid item xs={12}>
													<FormControl variant="outlined" className="custom-select-input" size={"small"}>
														<InputLabel htmlFor={"billingTriggerProdId"}> {t("CHOOSE_COMPONENT")} </InputLabel>

														<Select
															native
															onChange={props.updateTrigger}
															inputProps={{
																name: "billingTriggerProdId",
																id: "billingTriggerProdId",
															}}
															value={props.billingTriggerProdId}
															disabled={props.billingTriggerPhase === "DEFAULT"}
															label={t("CHOOSE_COMPONENT")}
														>
															<option value=""></option>
															{props.components.map((bucketItem, i) =>
																props.billingTriggerPhase === "ACTIVATION"
																	? bucketItem.activation &&
																	bucketItem.activation.resourceId !== "NOOP_ACT" &&
																	bucketItem.componentType === props.selectedBucket && (
																		<option key={i} value={bucketItem.id}>
																			{bucketItem.name}
																		</option>
																	)
																	: bucketItem.provisioning &&
																	bucketItem.provisioning.resourceId !== "NOOP_PROV" &&
																	bucketItem.componentType === props.selectedBucket && (
																		<option key={i} value={bucketItem.id}>
																			{bucketItem.name}
																		</option>
																	)
															)}
														</Select>
													</FormControl>
												</Grid>
												 */}

                      {props.packageMode != "edit" && (
                        <Grid
                          item
                          size={{
                            xs: 12,
                          }}
                        >
                          <>
                            <Grid
                              item
                              size={{
                                xs: 12,
                              }}
                            >
                              <Input
                                divClass={classes.customDiv}
                                name={"comment"}
                                value={props.comment ? props.comment : ""}
                                onChange={(event) =>
                                  props.addPackageReviewComments(event)
                                }
                                placeholder={t("REVIEW_COMMENTS") + " *"}
                                variant={"outlined"}
                                inputProps={{ rows: 2, cols: 31 }}
                                size={"small"}
                                multiline={true}
                              />
                            </Grid>
                          </>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          {currentTab === 1 && (
            <>
              {isMobile && <h3>{t("ASSEMBLY_INSTRUCTIONS")}</h3>}
              <Grid container spacing={3} justifyContent="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <AssemblyInstructions
                    data={props}
                    onInstructionChange={props.onInstructionChange}
                    removeInstruction={props.removeInstruction}
                    changeInstructionSequence={
                      props.changeInstructionSequence
                    }
                    onChangeRoutingData={props.onChangeRoutingData}
                    addInstruction={props.addInstruction}
                  />
                </Grid>
              </Grid>
            </>
          )}
          {currentTab === 2 && (
            <>
              {isMobile && <h3>{t("T&C")}</h3>}
              <Grid container spacing={3} justifyContent="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <div>
                    {/* <Grid item xs={4}>
										<FormControl variant="outlined" className="custom-select-input" size={'small'}>
											<InputLabel id="language" htmlFor="outlined-age-native-simple"> {t('SELECT_LANGUAGE') + ' *'}</InputLabel>
											<Select
												native
												labelId="language"
												value={props.productTermsLocale}
												onChange={event => props.changeProductTermsLocale(event)}
												inputProps={{
													name: 'language',
													id: 'language',
												}}
											>
												<option value="en_US">{t('English')}</option>
												<option value="spanish">{t('Spanish')}</option>
												<option value="en_FR">{t('French')}</option>
											</Select>
										</FormControl>
									</Grid> */}
                    <TiptapEditor
                      value={props.productTerms}
                      onChange={props.onChangeTerms}
                      placeholder={t("TERM_&_CONDITIONS")}
                      // readOnly={props.state.statusDisplayName === 'Published'}
                      readOnly={props.state.status === "P_PUBLISHED"}
                    // readOnly={props.readonly ? true : false}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          )}
          {currentTab === 3 && (
            <>
              {isMobile && <h3>{t("PREQUALS")}</h3>}
              <Grid container spacing={3} justifyContent="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <PreQualificationModule
                    statusDisplayName={props.state.statusDisplayName}
                    status={props.state.status}
                    preQualResourcesList={preQualResourcesList}
                    connectionFields={connectionFields}
                    tableFields={tableFields}
                    tableEditable={tableEditable}
                    uploadedFile={uploadedFile}
                    selectedResource={selectedResource}
                    components={props.components}
                    onuploadedFileChange={onuploadedFileChange}
                    selectResource={selectResource}
                    updateConnectionFields={updateConnectionFields}
                    updateTableFields={updateTableFields}
                    addNewRow={addNewRow}
                    removeRow={removeRow}
                    submitData={submitData}
                    preQuals={props.preQuals}
                    deletePreQual={props.deletePreQual}
                    editPreQual={editPreQual}
                    mode={mode}
                    cancelEdit={cancelEdit}
                  />
                </Grid>
              </Grid>
            </>
          )}
          {currentTab === 4 && (
            <>
              {isMobile && <h3>{t("CUSTOMERS")}</h3>}
              <Grid container spacing={3} justifyContent="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <ManageCustomersHierarchy
                    screen="products"
                    subScreen="product"
                    selectCustomers={props.selectCustomers}
                    customerData={props.selectedCustomer}
                    offeringState={props.state.statusDisplayName}
                  // preSelectedCustomer={props.selectedCustomer}
                  />
                </Grid>
              </Grid>
            </>
          )}

          {/* Action Button to submit package : Starts */}
          {
            // props.isLastBucket
            props.bucketList[props.bucketList.length - 1].id === props.selectedBucketId && props.packageMode !== "promo" && (
              <Grid container spacing={1} justifyContent="center" style={{ marginTop: "1rem" }}>
                <Grid item size={{ xs: 12, md: 1 }}>
                  <Button className="buttonSecondary" onClick={() => goBack()}>
                    {t("BACK")}
                  </Button>
                </Grid>
                {/* <Grid
						item
						xs={props.packageMode === "CREATE" ? 5 : props.packageMode === "promo" ? 6 : props.addToCatalog === "true" ? 1 : props.providerType != "SALES_CHNL_PROVIDER" ? 3 : 2}
					></Grid> */}
                {props.isAddToCatalog === "true" ? (
                  <Grid
                    item
                    // xs={props.packageMode === "CREATE" ? 4 : props.packageMode === "promo" ? 3 : props.addToCatalog === "true" ? 8 : props.providerType != "SALES_CHNL_PROVIDER" ? 6 : 7}
                    size={{ xs: 12, md: 11 }}
                    align="right"
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    {props.packageMode !== "promo" && (
                      <Button onClick={() => props.downloadTemplate()} className={classes.downloadTemplateButton + " " + "buttonSecondary"}>
                        {t("EXPORT_PRODUCT_TEMPLATE")}
                      </Button>
                    )}
                    {props.packageMode == 'edit' && <Button onClick={() => props.offeringSummary()}
                      className={classes.downloadTemplateButton + ' ' + 'buttonSecondary'}>
                      {t('OFFERING_SUMMARY')}
                    </Button>}
                    {props.providerType === "SALES_CHNL_PROVIDER" && (props.state.addToCatalog === "true" || props.state.addToCatalog === true) && (
                      <Button
                        onClick={() => props.submitPackageJSON("IMPORT_TO_CATALOG", showAssemblyInstructions)}
                        className={classes.downloadTemplateButton}
                      >
                        {t("IMPORT_TO_MY_CATALOG")}
                      </Button>
                    )}
                  </Grid>
                ) : (
                  <>
                    <Grid
                      item
                      // xs={props.packageMode === "CREATE" ? 4 : props.packageMode === "promo" ? 3 : props.addToCatalog === "true" ? 8 : props.providerType != "SALES_CHNL_PROVIDER" ? 6 : 7}
                      size={{ xs: 12, md: 11 }}
                      align="right"
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      {props.packageMode !== "promo" && (
                        <Button onClick={() => props.downloadTemplate()} className={classes.downloadTemplateButton + " " + "buttonSecondary"}>
                          {t("EXPORT_PRODUCT_TEMPLATE")}
                        </Button>
                      )}
                      {props.packageMode == 'edit' && <Button onClick={() => props.offeringSummary()}
                        className={classes.downloadTemplateButton + ' ' + 'buttonSecondary'}>
                        {t('OFFERING_SUMMARY')}
                      </Button>}

                      {(props.packageMode === "edit" || props.packageMode === "promo") && (
                        <>
                          {/* {props.packageMode === "edit" && props.packageMode != "promo" && (
									<Button onClick={() => props.downloadTemplate()} className={classes.downloadTemplateButton}>
										{t('EXPORT_PRODUCT_TEMPLATE')}
									</Button>
								)} */}
                          {(props.userPerms.includes("CATALOG_ADMIN") ||
                            props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                            props.userPerms.includes("CATALOG_CREATE")) &&
                            props.packageMode === "edit" && (
                              <>
                                {(props.state.addToCatalog === "false" || !props.state.addToCatalog) && !props.approvedForSale &&
                                  props.status == "P_IN_DRAFT" &&
                                  //add extra check which is needed for update
                                  props.userPerms.includes("CONTENTMGR_ADMIN") && props.userPerms.includes("CATALOG_PRICE_MAINT") &&
                                  (
                                    <Button
                                      onClick={() => props.submitPackageJSON("UPDATE", showAssemblyInstructions)}
                                      className={classes.downloadTemplateButton}
                                    >
                                      {t("SAVE_SOLUTION")}
                                    </Button>
                                  )}
                                {/* If Sales Channel, show import option, else save */}
                                {props.providerType === "SALES_CHNL_PROVIDER" &&
                                  (props.state.addToCatalog === "true" || props.state.addToCatalog === true) && (
                                    <Button
                                      onClick={() => props.submitPackageJSON("IMPORT_TO_CATALOG", showAssemblyInstructions)}
                                      className={classes.downloadTemplateButton}
                                    >
                                      {t("IMPORT_TO_MY_CATALOG")}
                                    </Button>
                                  )}
                                {//add extra check which is needed for update
                                  props.userPerms.includes("CONTENTMGR_ADMIN") && props.userPerms.includes("CATALOG_PRICE_MAINT") &&
                                  // <Button onClick={() => props.submitPackageJSON("NEW_SOLUTION", showAssemblyInstructions)}>
                                  <Button onClick={() => setSaveAsOfferingDialog(true)}>
                                    {t("SAVE_AS_NEW_SOLUTION")}
                                  </Button>
                                }
                                {/* 																		
																		{!props.submittedForReview && (
																			<Button onClick={() => props.submitPackageJSON("PS_REVIEW")} style={{ marginLeft: 15 }}>
																				{t("SUBMIT_FOR_REVIEW")}
																			</Button>
																		)}

																		{props.userPerms.includes("CUMULATOR_PRODUCT_APPROVE") && props.submittedForReview && (
																			<>
																				<Button onClick={() => props.submitPackageJSON("PS_APPROVE")} style={{ marginLeft: 15 }}>
																					{t("SUBMIT_FOR_APPROVAL")}
																				</Button>
																				<Button onClick={() => props.submitPackageJSON("PS_RESUBMITTED")} style={{ marginLeft: 15 }}>
																					{t("RESUBMITTED")}
																				</Button>
																			</>
																		)}
																		*/}
                              </>
                            )}
                        </>
                      )}
                      {props.packageMode !== "edit" &&
                        props.packageMode !== "promo" &&
                        (props.userPerms.includes("CATALOG_ADMIN") ||
                          props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                          props.userPerms.includes("CATALOG_CREATE")) && (props.state.status !== 'P_PUBLISHED') && (
                          <Button onClick={() => props.submitPackageJSON("CREATE", showAssemblyInstructions)}>{t("ADD_PRODUCT")}</Button>
                        )}
                    </Grid>
                  </>
                )}
              </Grid>
            )
          }
        </Grid>

      </>
    )
  }
  const handleCharacteristicsUpdate = (updatedCharacteristics) => {
    var tempData = { ...componentData };
    setSelectedCharacteristics(updatedCharacteristics);
    tempData.characteristics = updatedCharacteristics;
    props.changeTableCompleteRowData(tempData);
    resetComponentForm();
  };

  const [editOtherPriceIndices, setEditOtherPriceIndices] = useState(new Set());
  const overwriteOtherPrice = (event, pIndex) => {
    setEditOtherPriceIndices(prev => new Set([...prev, pIndex]));
  };

  // Helper function to format quantity/cardinality display
  const formatQuantityRange = (obj) => {
    if (!obj || !obj.range) return "";
    const { type, range } = obj;
    if (type === "Exact" || range.min === range.max) {
      return range.min || range.max || "";
    }
    // Range type
    if (range.min && range.max) {
      return `${range.min}-${range.max}`;
    }
    return range.min || range.max || "";
  };

  // Helper function to build dependency chip label
  const getDependencyLabel = (chipVal, currentItemName) => {
    const dependerQty = formatQuantityRange(chipVal.quantity);
    const dependeeQty = formatQuantityRange(chipVal.cardinality);
    const dependerName = chipVal.dependerName || getBucketName(chipVal.dependerBucketName);
    const dependencyType = chipVal.dependencyType?.toLowerCase() || "mandatory";

    const prefix = chipVal.dependencyMode === "forEach" ? "For each" : "For every";
    // "For every 3-5 camera, 2 HDD is Mandatory"
    return `${prefix} ${dependerQty || "1"} ${dependerName}, ${dependeeQty} ${currentItemName} is ${dependencyType}`;
  };

  return (
    <div className={classes.root}>
      {/* Top Component Detail Form : Starts */}
      {/* {console.log('props======', props)} */}
      {props.packageMode !== "promo" && props.selectedBucketId === "PROD_COMP_PUBLISH" && (
        <>
          <Grid container spacing={0}>
            {!props.isMobile ?
              !props.showBucketsOnLeft ?
                <Grid container spacing={3} justifyContent="center" style={{ marginTop: '1rem' }}>
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Box display="flex" justifyContent="center" style={{ width: '100%' }}>
                      <Tabs
                        // indicatorColor="primary"
                        onChange={handleTabChange}
                        // textColor="primary"
                        value={currentTab}
                        variant="scrollable"
                        className={classes.createPackageTabs}
                      >
                        {props.providerType === "SALES_CHNL_PROVIDER" &&
                          <Tab value={0} label={t('CONFIGURATIONS')} />
                        }
                        {showAssemblyInstructions &&
                          <Tab value={1} label={t('ASSEMBLY_INSTRUCTIONS')} />
                        }
                        <Tab value={2} label={t('T&C')} />
                        <Tab value={3} label={t('PREQUALS')} />
                        {props.providerType === "SALES_CHNL_PROVIDER" &&
                          <Tab value={4} label={t('CUSTOMERS')} />
                        }
                      </Tabs>
                    </Box>
                  </Grid>
                  <Box className={classes.tabUnderLine}
                    style={{ display: "flex", marginTop: '2rem', marginBottom: '1rem', justifyContent: "center", width: "100%" }}></Box>
                  {publishTabData()}
                </Grid>
                :
                <Split
                  sizes={[20, 80]} // Initial sizes in percentages
                  minSize={[200, 600]} // Minimum sizes in pixels
                  expandToMin={false}
                  gutterSize={10}
                  gutterAlign="center"
                  snapOffset={30}
                  dragInterval={1}
                  direction="horizontal"
                  cursor="col-resize"
                  className='split'
                >
                  {/* left */}
                  <div style={{ overflow: 'auto', borderRight: '1px solid lightgrey' }}>
                    <Grid item size={{ xs: 12, md: 12 }} style={{ padding: '1rem' }}>
                      {/* tabs */}
                      <List>
                        {[
                          { text: t("CONFIGURATIONS"), value: 0 },
                          showAssemblyInstructions &&
                          { text: t("ASSEMBLY_INSTRUCTIONS"), value: 1 },
                          { text: t("T&C"), value: 2 },
                          // { text: t("PREQUALS"), value: 3 },
                          { text: t("CUSTOMERS"), value: 4 }
                        ].filter(Boolean)
                          .map((tab, index) => (
                            <React.Fragment key={index}>
                              <StyledNavListItem button key={tab.text}
                                isSelected={currentTab === tab.value}
                                themeColor={props.tenantData.color}
                                onClick={(e) => {
                                  handleTabChange(e, tab.value);
                                }}
                              >
                                <ListItemText
                                  // style={{ color: currentTab === tab.value ? props.tenantData.color : "inherit" }} 
                                  primary={tab.text} />
                              </StyledNavListItem>
                            </React.Fragment>
                          ))
                        }
                      </List>

                    </Grid>
                  </div>
                  {/* right */}
                  <div style={{ overflow: 'auto' }}>
                    {publishTabData()}
                  </div>
                </Split>
              :
              props.isMobile && props.showCategory &&
              (<Drawer
                anchor="left"
                // variant='permanant'
                open={props.showCategory}
                onClose={() => { props.toggleShowCategory() }}
                // classes={{ paper: classes.drawerPaper }}
                PaperProps={{
                  style: {
                    width: '100%',
                    maxWidth: '100vw',
                  },
                }}
              >
                <div>
                  <div>
                    <IconButton onClick={() => { props.toggleShowCategory() }}>
                      <ChevronLeft />
                    </IconButton>
                  </div>
                  <Card variant='outlined' className={'roundedCorners'}>
                    {publishList}
                  </Card>
                </div>

              </Drawer>)
            }
            {(isMobile && !props.showCategory) && publishTabData()}
          </Grid>
        </>
      )}
      {/* Top Component Detail Form : Ends */}
      {/* Component Detail Table : Starts */}
      {props.selectedBucketId !== "PROD_COMP_PUBLISH" && (
        <Grid container spacing={3} justifyContent="center">
          {/* <Grid item xs={12}></Grid> */}
          <Grid
            item
            size={{
              xs: 12,
              md: 12,
            }}
          >
            <Toolbar disableGutters={true}>
              <div style={{ display: "flex", justifyContent: props.packageMode === "promo" ? "flex-end" : "space-between", width: "100%", alignItems: "center" }}>
                {/* <Typography
                className={classes.title}
                variant="h6"
                id="tableTitle"
              > */}
                {/* {t(props.bucketName)} */}
                {props.packageMode != "promo" &&
                  (props.userPerms.includes("CATALOG_ADMIN") ||
                    props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                    props.userPerms.includes("CATALOG_CREATE")) &&
                  props.state.status !== "P_PUBLISHED" && (
                    <Button
                      // style={{ marginLeft: "25px" }}
                      onClick={() => {
                        openTemplateDialog();
                      }}
                    >
                      {t("CHOOSE_EXISTING")}
                    </Button>
                  )}
                {/* </Typography> */}
                {props.packageMode !== "promo" && (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    {/* <Typography
                    className={classes.title}
                    variant="h6"
                    id="tableTitle"
                  > */}
                    {/* <FormGroup style={{ float: 'right' }}>
                                    <FormControlLabel
                                        control={<Checkbox checked={props.selectionType[props.selectedBucketId] === 'SINGLE'} color="primary" onChange={event => props.changeSelectionType(event, props.selectedBucketId)} />}
                                        label="Singleton?"
                                    />
                                </FormGroup> */}
                    {props.basicDetail.categoryId &&
                      props.basicDetail.categoryId !== "PKG" &&
                      props.parentTabValue !== 2 && (
                        <>
                          <FormControl
                            variant="outlined"
                            className="custom-select-input"
                            style={{ width: "160px" }}
                            size={"small"}
                          >
                            <InputLabel htmlFor="selectionType">
                              {" "}
                              {t("SELECTION_TYPE")}
                            </InputLabel>
                            <Select
                              native
                              labelId="selection Type"
                              label={t("SELECTION_TYPE")}
                              onChange={(event) =>
                                props.changeSelectionType(
                                  event,
                                  props.selectedBucketId,
                                )
                              }
                              inputProps={{
                                name: "selectionType",
                                id: "selectionType",
                              }}
                              value={props.selectionType[props.selectedBucketId]}
                            >
                              <option value=""></option>
                              <option value="SINGLE">{t("SINGLE")}</option>
                              <option value="MULTIPLE">{t("MULTIPLE")}</option>
                              <option value="LIMIT">{t("USE_RANGE")}</option>
                              <option value="ALL">{t("ALL")}</option>
                            </Select>
                          </FormControl>
                          {props.selectionType[props.selectedBucketId] === "LIMIT" && (
                            <>
                              {/* <FormControlLabel
                            style={{ paddingLeft: ".5rem" }}
                            control={
                              <Switch
                                color="primary"
                                checked={
                                  props.selectionType[props.selectedBucketId] === "MULTIPLE" && props.addLimit[props.selectedBucketId]
                                }
                                inputProps={{
                                  "aria-label": "Add Limit Checkbox",
                                }}
                                name="addLimit"
                                onChange={(event) => props.changeAddLimit(event, props.selectedBucketId)}
                              />
                            }
                            label={props.t("ADD_LIMIT")}
                         /> */}
                              {/* {props.addLimit[props.selectedBucketId] && ( */}
                              {props.selectionType[props.selectedBucketId] === "LIMIT" && (
                                <div style={{ display: "flex", alignItems: "center", gap: ".5rem", paddingLeft: '.5rem' }}>
                                  <Input
                                    size={"small"}
                                    type={"number"}
                                    name={"minLimit"}
                                    placeholder={t("MIN")}
                                    variant={"outlined"}
                                    style={{ width: "100px" }}
                                    min={0}
                                    step={1}
                                    onKeyDown={(event) => {
                                      // Prevent decimal point, 'e', '+', and '-' keys
                                      if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(event) => {
                                      // Remove any decimal values and ensure integer
                                      const value = event.target.value;
                                      if (value === '' || /^\d+$/.test(value)) {
                                        props.changeSelectionTypeMinLimit(event, props.selectedBucketId);
                                      } else {
                                        // If decimal is pasted, convert to integer
                                        event.target.value = Math.floor(Number(value));
                                        props.changeSelectionTypeMinLimit(event, props.selectedBucketId);
                                      }
                                    }}
                                    error={
                                      props.selectionTypeMinLimit[props.selectedBucketId] &&
                                      props.selectionTypeMaxLimit[props.selectedBucketId] &&
                                      Number(props.selectionTypeMinLimit[props.selectedBucketId]) > Number(props.selectionTypeMaxLimit[props.selectedBucketId])
                                    }
                                    // helperText={
                                    // props.selectionTypeMinLimit[props.selectedBucketId] && 
                                    // props.selectionTypeMaxLimit[props.selectedBucketId] &&
                                    // Number(props.selectionTypeMinLimit[props.selectedBucketId]) > Number(props.selectionTypeMaxLimit[props.selectedBucketId])
                                    //   ? t("MIN_MUST_BE_LESS_THAN_MAX")
                                    //   : ""
                                    // }
                                    value={props.selectionTypeMinLimit[props.selectedBucketId]}
                                  />
                                  <Input
                                    size={"small"}
                                    type={"number"}
                                    name={"maxLimit"}
                                    placeholder={t("MAX")}
                                    variant={"outlined"}
                                    style={{ width: "100px" }}
                                    min={props.selectionTypeMinLimit[props.selectedBucketId] || 0}
                                    step={1}
                                    onKeyDown={(event) => {
                                      // Prevent decimal point, 'e', '+', and '-' keys
                                      if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(event) => {
                                      // Remove any decimal values and ensure integer
                                      const value = event.target.value;
                                      if (value === '' || /^\d+$/.test(value)) {
                                        props.changeSelectionTypeMaxLimit(event, props.selectedBucketId);
                                      } else {
                                        // If decimal is pasted, convert to integer
                                        event.target.value = Math.floor(Number(value));
                                        props.changeSelectionTypeMaxLimit(event, props.selectedBucketId);
                                      }
                                    }}
                                    error={
                                      props.selectionTypeMinLimit[props.selectedBucketId] &&
                                      props.selectionTypeMaxLimit[props.selectedBucketId] &&
                                      Number(props.selectionTypeMaxLimit[props.selectedBucketId]) < Number(props.selectionTypeMinLimit[props.selectedBucketId])
                                    }
                                    // helperText={
                                    // props.selectionTypeMinLimit[props.selectedBucketId] && 
                                    // props.selectionTypeMaxLimit[props.selectedBucketId] &&
                                    // Number(props.selectionTypeMaxLimit[props.selectedBucketId]) < Number(props.selectionTypeMinLimit[props.selectedBucketId])
                                    //   ? t("MAX_MUST_BE_GREATER_THAN_MIN")
                                    //   : ""
                                    // }
                                    value={props.selectionTypeMaxLimit[props.selectedBucketId]}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                  </div>
                )}
                {props.packageMode === "promo" && (
                  <Typography
                    className={classes.title}
                    variant="h6"
                    id="tableTitle"
                  >
                    <Input
                      size={"small"}
                      type={"number"}
                      name={"promoMarkdown"}
                      placeholder={t("MARKDOWN") + " (%)"}
                      variant={"outlined"}
                      style={{ width: "130px", marginRight: "15px" }}
                      onChange={(event) => {
                        props.updatePromoMarkdown(event);
                      }}
                      value={props.promoMarkdown}
                    />
                    {(props.userPerms.includes("CATALOG_ADMIN") ||
                      props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                      props.userPerms.includes("CATALOG_CREATE") ||
                      props.userPerms.includes("CATALOG_UPDATE")) &&
                      props.state.status !== "P_PUBLISHED" && (
                        <Button onClick={() => props.applyPromoMarkdown()}>
                          {props.t("APPLY_MARKDOWN")}
                        </Button>
                      )}
                  </Typography>
                )}
              </div>
            </Toolbar>
            {/* <Paper className={classes.root}> */}
            <Box
              className="roundCorners"
              style={{
                border: "1px solid lightgrey",
                marginTop: "1rem",
                background: "white",
              }}
            >
              {/* <Table className={classes.table + ' ' + 'newGlobalTable'}> */}
              {/* <Table className={classes.table + ' ' + 'subscriptionTable'}> */}
              <TableContainer>
                <Table className={"subscriptionTable"}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{t("EXPAND")}</TableCell>
                      <TableCell align="left">{t("PROVIDER")}</TableCell>
                      <TableCell align="left">{t("TYPE")}</TableCell>
                      {props.packageMode !== "promo" && (
                        <TableCell align="left">
                          {t("CUSTOMER_VIEWABLE")}
                        </TableCell>
                      )}
                      <TableCell align="left">{t("NAME")}</TableCell>
                      {/* <TableCell align="left" >{t('MANDATORY')}</TableCell>
										<TableCell align="left" >{t('Quantity Modifiable')}</TableCell> */}
                      {/* {props.packageMode !== "promo" && <TableCell align="left">{t('DISPLAY_SEQUENCE')}</TableCell>} */}
                      <TableCell
                        align="left"
                        style={{ whiteSpace: "nowrap", minWidth: "9rem" }}
                      >
                        {t("PRODUCT_CODE")}
                      </TableCell>
                      {/* <TableCell align="left" className={classes.featureCodeCell}>{t('QUANTITY')}</TableCell> */}
                      <TableCell align="left" className={classes.priceCell}>
                        {t("PRICE")} ({currencyFormatter("", false)})
                      </TableCell>
                      {props.packageMode !== "promo" &&
                        props.basicDetail.categoryId &&
                        props.basicDetail.categoryId !== "PKG" &&
                        props.parentTabValue !== 2 && (
                          <>
                            <TableCell
                              align="left"
                              className={classes.priceCell}
                            >
                              {t("APPLICABLE_TO")}
                            </TableCell>
                          </>
                        )}
                      <TableCell
                        className={classes.actionCell}
                        align="left"
                        style={
                          props.packageMode !== "promo"
                            ? { width: "auto" }
                            : { width: "10%" }
                        }
                      >
                        {props.packageMode !== "promo"
                          ? t("ACTION")
                          : t("APPLY_PRICE")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.currentBucketItems &&
                      props.currentBucketItems.map((row, index) => (
                        <React.Fragment key={index}>
                          {!row.remove && (
                            <TableRow
                              style={{
                                backgroundColor:
                                  !row.expandVariants && !row.expandEnrichment
                                    ? "#ffffff"
                                    : "#eee",
                              }}
                            >
                              <TableCell>
                                {row.variants && row.variants.length > 0 && (
                                  <Tooltip title={t("EXPAND_VARIANTS")}>
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={(event) => {
                                        props.expandVariantDetails(
                                          event,
                                          row,
                                          !row.expandVariants,
                                        );
                                      }}
                                    >
                                      {row.expandVariants ? (
                                        <KeyboardArrowUpIcon />
                                      ) : (
                                        <KeyboardArrowDownIcon />
                                      )}
                                    </IconButton>
                                  </Tooltip>
                                )}
                                {row.otherPrices &&
                                  row.otherPrices.length > 0 && (
                                    <Tooltip title={t("EXPAND_OTHER_PRICES")}>
                                      <IconButton
                                        aria-label="expand row"
                                        size="small"
                                        onClick={(event) => {
                                          props.expandOtherPrices(
                                            event,
                                            row,
                                            !row.expandOtherPrices,
                                          );
                                        }}
                                      >
                                        {row.expandOtherPrices ? (
                                          <KeyboardArrowUpIcon />
                                        ) : (
                                          <KeyboardArrowDownIcon />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                {row.bom && row.bom.length > 0 ? (
                                  <Tooltip title={t("EXPAND_PRODUCTS")}>
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={(event) => {
                                        // props.expandComponentDetails(event, row, !row.expandComponents);
                                        props.expandVariantDetails(
                                          event,
                                          row,
                                          !row.expandVariants,
                                        );
                                      }}
                                    >
                                      {row.expandchildren ? (
                                        <KeyboardArrowUpIcon />
                                      ) : (
                                        <KeyboardArrowDownIcon />
                                      )}
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  row.children &&
                                  row.children.length > 0 && (
                                    <Tooltip title={t("EXPAND_PRODUCTS")}>
                                      <IconButton
                                        aria-label="expand row"
                                        size="small"
                                        onClick={(event) => {
                                          // props.expandComponentDetails(event, row, !row.expandComponents);
                                          props.expandVariantDetails(
                                            event,
                                            row,
                                            !row.expandVariants,
                                          );
                                        }}
                                      >
                                        {row.expandchildren ? (
                                          <KeyboardArrowUpIcon />
                                        ) : (
                                          <KeyboardArrowDownIcon />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                  )
                                )}
                              </TableCell>
                              <TableCell>
                                {row.originalProviderName
                                  ? row.originalProviderName
                                  : row.fromProviderName
                                    ? row.fromProviderName
                                    : ""}
                              </TableCell>
                              <TableCell>
                                {row.bom && row.bom.length > 0 ? (
                                  <Tooltip
                                    title={t("BOM")}
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                  >
                                    {/* <GroupWorkIcon /> */}
                                    <FilterNoneOutlined />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    title={t("PRODUCT")}
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                  >
                                    {/* <Filter1Icon /> */}
                                    <LooksOneOutlined />
                                  </Tooltip>
                                )}
                              </TableCell>
                              {props.packageMode !== "promo" && (
                                <TableCell>
                                  <Tooltip title={t("CUSTOMER_VIEWABLE")}>
                                    <Checkbox
                                      color="primary"
                                      name="customerViewable"
                                      style={{ marginLeft: "10px" }}
                                      onChange={(event) => {
                                        props.changeIsViewable(
                                          !row.customerViewable,
                                          row,
                                        );
                                      }}
                                      checked={row.customerViewable}
                                      disabled={
                                        !(
                                          props.userPerms.includes(
                                            "CATALOG_ADMIN",
                                          ) ||
                                          props.userPerms.includes(
                                            "CATALOG_ADMIN_ALL",
                                          ) ||
                                          props.userPerms.includes(
                                            "CATALOG_CREATE",
                                          ) ||
                                          props.userPerms.includes(
                                            "CATALOG_UPDATE",
                                          )
                                        ) ||
                                        // props.state.statusDisplayName === 'Published'
                                        props.state.status === "P_PUBLISHED"
                                      }
                                    />
                                  </Tooltip>
                                </TableCell>
                              )}
                              <TableCell
                                component="th"
                                scope="row"
                                style={{ whiteSpace: isMobile ? "nowrap" : "" }}
                              >
                                <div className={classes.nameDiv}>
                                  <span className={classes.NameSpan}>
                                    {row.name}
                                  </span>
                                </div>
                              </TableCell>
                              {/* {props.packageMode !== "promo" && (
															<TableCell component="th" scope="row">
																<div className={classes.nameDiv}>
																	<Input
																		size={"small"}
																		type={"number"}
																		name={"displaySequence"}
																		// placeholder={'Display Sequence'}
																		variant={"outlined"}
																		style={{ width: "60px" }}
																		onChange={(event) => {
																			// props.changeTableData(event, row);
																		}}
																		value={row.displaySequence}
																		onBlur={() => {
																			sortTableItems();
																			// props.sortTableItems();
																		}}
																	// className={"noArrowInput"}
																	/>
																</div>
															</TableCell>
														)} */}
                              <TableCell component="th" scope="row">
                                {/* <div className={classes.nameDiv}> */}
                                <span className={classes.NameSpan}>
                                  {row.featureCode}
                                </span>
                                {/* <Input
																	size={"small"}
																	type={"text"}
																	name={"featureCode"}
																	// placeholder={'Product Code'}
																	variant={"outlined"}
																	disabled={true}
																	// disabled={row.originalProviderId === props.providerId || props.selectedBucketId === "PROD_COMP_PACKAGE"}
																	onChange={(event) => {
																		props.changeTableData(event, row);
																	}}
																	value={row.featureCode}
																/> */}
                                {/* </div> */}
                              </TableCell>
                              {/* <TableCell component="th" scope="row">
													<div className={classes.nameDiv}>
														<span className={classes.NameSpan} >{row.quantity}</span>
													</div>
												</TableCell> */}
                              <TableCell component="th" scope="row">
                                <div
                                  className={classes.nameDiv}
                                  style={{ width: "210px" }}
                                >
                                  <span
                                    className={classes.NameSpan}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* {row.price} */}
                                    {props.packageMode !== "promo" ? (
                                      row.price
                                    ) : (
                                      <Input
                                        size={"small"}
                                        type={"number"}
                                        name={"price"}
                                        // placeholder={"Price"}
                                        variant={"outlined"}
                                        style={{
                                          width: "100px",
                                          float: "left",
                                        }}
                                        onChange={(event) => {
                                          props.changeTableData(event, row);
                                        }}
                                        onKeyDown={(event) => {
                                          // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                          if (event.keyCode === 69) {
                                            event.preventDefault();
                                          }
                                        }}
                                        value={row.price}
                                        className={classes.tablePriceInput}
                                        //virtual price does not matter
                                        disabled={
                                          (row.variants &&
                                            row.variants.length > 0
                                            ? true
                                            : false) ||
                                          isAuxiliary ||
                                          props.selectedBucketId ===
                                          "PROD_COMP_PACKAGE"
                                        }
                                      />
                                    )}
                                    <span>
                                      &nbsp;
                                      {row.priceType === "NTC"
                                        ? t("NTC")
                                        : row.priceType === "RC"
                                          ? t("RC")
                                          : t(row.priceType)}{" "}
                                      {row.priceType === "NTC"
                                        ? row.priceTenure > 1
                                          ? "(" +
                                          row.priceTenure +
                                          " " +
                                          getPriceTenureUOM(
                                            row.priceTenureUOM,
                                          ) +
                                          "s" +
                                          ")"
                                          : "(" +
                                          row.priceTenure +
                                          getPriceTenureUOM(
                                            row.priceTenureUOM,
                                          ) +
                                          ")"
                                        : ""}
                                      {row.priceType === "RC"
                                        ? row.priceTenure
                                          ? row.priceTenure > 1
                                            ? "(" +
                                            "per " +
                                            row.priceTenure +
                                            " " +
                                            getPriceTenureUOM(
                                              row.priceTenureUOM,
                                            ) +
                                            "s" +
                                            ")"
                                            : "(" +
                                            "per " +
                                            getPriceTenureUOM(
                                              row.priceTenureUOM,
                                            ) +
                                            ")"
                                          : ""
                                        : ""}
                                      {/* code for quarterly */}
                                      {/* {row.priceType === 'RC' ? row.priceTenureUOM ? (row.priceTenure === 3 && row.priceTenureUOM === 'TF_mon') ? '(' + getPriceTenureUOM('TF_qtr') + ')' :
																	'(' + getPriceTenureUOM(row.priceTenureUOM) + ')' :
																	'(' + getPriceTenureUOM('TF_mon') + ')' : ''} */}
                                    </span>
                                  </span>
                                </div>
                              </TableCell>
                              {props.packageMode !== "promo" &&
                                props.basicDetail.categoryId &&
                                props.basicDetail.categoryId !== "PKG" &&
                                props.parentTabValue !== 2 && (
                                  <>
                                    <TableCell component="th" scope="row">
                                      {/* Added dependencies Table */}
                                      <TableContainer>
                                        <Table className={classes.table}>
                                          <TableBody>
                                            {row.chipData &&
                                              row.chipData.map(
                                                (chipVal, chipIndex) => (
                                                  <TableRow key={chipIndex}>
                                                    <TableCell
                                                      style={{
                                                        border: 0,
                                                        padding: 0,
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title={getDependencyLabel(chipVal, row.name)}
                                                      // title={
                                                      //   "Is " +
                                                      //   chipVal.dependencyType +
                                                      //   " with " +
                                                      //   getBucketName(
                                                      //     chipVal.dependerBucketName,
                                                      //   ) +
                                                      //   " " +
                                                      //   chipVal.dependerName +
                                                      //   (chipVal.dependencyType ===
                                                      //     "Mandatory"
                                                      //     ? ". Quantity "
                                                      //     : chipVal
                                                      //       .cardinality
                                                      //       .range.max
                                                      //       ? ". Quantity "
                                                      //       : "") +
                                                      //   (chipVal.dependencyType ===
                                                      //     "Mandatory"
                                                      //     ? chipVal
                                                      //       .cardinality
                                                      //       .type ===
                                                      //       "Exact"
                                                      //       ? "Exact: " +
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.min
                                                      //       : "Min:" +
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.min +
                                                      //       " Max:" +
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.max
                                                      //     : chipVal
                                                      //       .cardinality
                                                      //       .type ===
                                                      //       "Range" &&
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.max &&
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.min
                                                      //       ? "Min:" +
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.min +
                                                      //       " Max:" +
                                                      //       chipVal
                                                      //         .cardinality
                                                      //         .range.max
                                                      //       : chipVal
                                                      //         .cardinality
                                                      //         .range.max
                                                      //         ? " Exact:" +
                                                      //         chipVal
                                                      //           .cardinality
                                                      //           .range.max
                                                      //         : "")
                                                      // }
                                                      >
                                                        <Chip
                                                          label={getDependencyLabel(chipVal, row.name)}
                                                          // label={
                                                          //   "Is " +
                                                          //   chipVal.dependencyType +
                                                          //   " with " +
                                                          //   getBucketName(
                                                          //     chipVal.dependerBucketName,
                                                          //   ) +
                                                          //   " " +
                                                          //   chipVal.dependerName +
                                                          //   (chipVal.dependencyType ===
                                                          //     "Mandatory"
                                                          //     ? ". Quantity "
                                                          //     : chipVal
                                                          //       .cardinality
                                                          //       .range.max
                                                          //       ? ". Quantity "
                                                          //       : "") +
                                                          //   (chipVal.dependencyType ===
                                                          //     "Mandatory"
                                                          //     ? chipVal
                                                          //       .cardinality
                                                          //       .type ===
                                                          //       "Exact"
                                                          //       ? "Exact: " +
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range.min
                                                          //       : "Min:" +
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range.min +
                                                          //       " Max:" +
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range.max
                                                          //     : chipVal
                                                          //       .cardinality
                                                          //       .type ===
                                                          //       "Range" &&
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range
                                                          //         .max &&
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range.min
                                                          //       ? "Min:" +
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range.min +
                                                          //       " Max:" +
                                                          //       chipVal
                                                          //         .cardinality
                                                          //         .range.max
                                                          //       : chipVal
                                                          //         .cardinality
                                                          //         .range.max
                                                          //         ? " Exact:" +
                                                          //         chipVal
                                                          //           .cardinality
                                                          //           .range.max
                                                          //         : "")
                                                          // }
                                                          color="primary"
                                                          variant="outlined"
                                                          onDelete={() =>
                                                            props.removeDependsOnChip(
                                                              row.id,
                                                              chipIndex,
                                                            )
                                                          }
                                                          style={{
                                                            marginBottom: 5,
                                                            width: "150px",
                                                          }}
                                                          className={
                                                            "custom-chip-style"
                                                          }
                                                          disabled={
                                                            !(
                                                              props.userPerms.includes(
                                                                "CATALOG_ADMIN",
                                                              ) ||
                                                              props.userPerms.includes(
                                                                "CATALOG_ADMIN_ALL",
                                                              ) ||
                                                              props.userPerms.includes(
                                                                "CATALOG_CREATE",
                                                              ) ||
                                                              props.userPerms.includes(
                                                                "CATALOG_UPDATE",
                                                              )
                                                            ) ||
                                                            // props.state.statusDisplayName === 'Published'
                                                            props.state
                                                              .status ===
                                                            "P_PUBLISHED"
                                                          }
                                                        />
                                                      </Tooltip>
                                                    </TableCell>
                                                  </TableRow>
                                                ),
                                              )}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                      {/* dependencies Table */}
                                    </TableCell>
                                  </>
                                )}
                              <TableCell
                                align="left"
                                className={classes.actionCell}
                              >
                                {props.packageMode !== "promo" ? (
                                  <>
                                    <>
                                      <Button
                                        style={{ padding: "2px 8px" }}
                                        // className={classes.button2}
                                        className={"buttonSecondary"}
                                        aria-describedby={`popper-${index}`}
                                        type="button"
                                        onClick={(event) =>
                                          handleClick(event, row)
                                        }
                                      >
                                        ...
                                      </Button>
                                      <Popper
                                        id={`popper-${index}`}
                                        open={openPopper && selectedRow === row}
                                        anchorEl={anchorEl}
                                        placement="bottom-start"
                                        style={{ zIndex: "99" }}
                                      >
                                        <ClickAwayListener
                                          onClickAway={handleClose}
                                        >
                                          <Paper>
                                            <MenuList>
                                              <MenuItem
                                                onClick={() => {
                                                  editComponent(row, index);
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    marginRight: ".5rem",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <EditIconNew />
                                                </span>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  {t("EDIT")}
                                                </span>
                                              </MenuItem>

                                              {(props.userPerms.includes(
                                                "CATALOG_ADMIN",
                                              ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_ADMIN_ALL",
                                                ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_CREATE",
                                                ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_UPDATE",
                                                )) &&
                                                props.state.status !==
                                                "P_PUBLISHED" && (
                                                  <MenuItem
                                                    onClick={(event) => {
                                                      props.expandEnrichmentDetails(
                                                        event,
                                                        row,
                                                        !row.expandEnrichment,
                                                      );
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: ".5rem",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                    >
                                                      <PlusIcon />
                                                    </span>
                                                    <span
                                                      style={{
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      {t("ENRICHMENT_CONFIG")}
                                                    </span>
                                                  </MenuItem>
                                                )}
                                              {props.menuPaths.includes(
                                                "/specification",
                                              ) && (
                                                  <MenuItem
                                                    onClick={() => {
                                                      handleOpenTreeDialog(
                                                        row,
                                                        index,
                                                      );
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: ".5rem",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                      }}
                                                    >
                                                      <ClipboardWithGear />
                                                    </span>
                                                    <span
                                                      style={{ fontSize: "14px" }}
                                                    >
                                                      {t("EDIT")}{" "}
                                                      {t("PRODUCT_SPECIFICATION")}
                                                    </span>
                                                  </MenuItem>
                                                )}
                                              {(props.userPerms.includes(
                                                "CUMULATOR_CATALOG_VIEW",
                                              ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_VIEW",
                                                )) && (
                                                  <MenuItem
                                                    onClick={() => {
                                                      openShowDetails(row, index);
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: ".5rem",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                      }}
                                                    >
                                                      <ViewIconNew />
                                                    </span>
                                                    <span
                                                      style={{ fontSize: "14px" }}
                                                    >
                                                      {t("VIEW_RESOURCE")}
                                                    </span>
                                                  </MenuItem>
                                                )}

                                              {props.currentBucketItemsCount >
                                                1 &&
                                                (props.userPerms.includes(
                                                  "CATALOG_ADMIN",
                                                ) ||
                                                  props.userPerms.includes(
                                                    "CATALOG_ADMIN_ALL",
                                                  ) ||
                                                  props.userPerms.includes(
                                                    "CATALOG_CREATE",
                                                  ) ||
                                                  props.userPerms.includes(
                                                    "CATALOG_UPDATE",
                                                  )) &&
                                                props.state.status !==
                                                "P_PUBLISHED" && (
                                                  <span>
                                                    {row.displaySequence && (
                                                      <span>
                                                        {JSON.parse(
                                                          row.displaySequence,
                                                        ) !== 1 && (
                                                            <MenuItem
                                                              onClick={() =>
                                                                props.changeDisplaySequence(
                                                                  "up",
                                                                  row,
                                                                )
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  marginRight:
                                                                    ".5rem",
                                                                  display: "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                }}
                                                              >
                                                                <UpIcon />
                                                              </span>
                                                              <span
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                              >
                                                                {t("MOVE_UP")}
                                                              </span>
                                                            </MenuItem>
                                                          )}
                                                        {+row.displaySequence !==
                                                          props.currentBucketItemsCount && (
                                                            <MenuItem
                                                              onClick={() =>
                                                                props.changeDisplaySequence(
                                                                  "down",
                                                                  row,
                                                                )
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  marginRight:
                                                                    ".5rem",
                                                                  display: "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                }}
                                                              >
                                                                <DownIcon />
                                                              </span>
                                                              <span
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                              >
                                                                {t("MOVE_DOWN")}
                                                              </span>
                                                            </MenuItem>
                                                          )}
                                                      </span>
                                                    )}
                                                  </span>
                                                )}
                                              {(props.userPerms.includes(
                                                "CATALOG_ADMIN",
                                              ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_ADMIN_ALL",
                                                ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_CREATE",
                                                ) ||
                                                props.userPerms.includes(
                                                  "CATALOG_UPDATE",
                                                )) &&
                                                props.state.status !==
                                                "P_PUBLISHED" && (
                                                  <MenuItem
                                                    onClick={() => {
                                                      openRemoveConfirmation(
                                                        row,
                                                        index,
                                                      );
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: ".5rem",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                    >
                                                      <DeleteIconNew />
                                                    </span>
                                                    <span
                                                      style={{
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      {t("REMOVE")}
                                                    </span>
                                                  </MenuItem>
                                                )}
                                            </MenuList>
                                          </Paper>
                                        </ClickAwayListener>
                                      </Popper>
                                    </>
                                    {/* <table>
																			<tbody>
																				<tr>
																					<td style={{ padding: 0 }}>
																						{row.priceType === "RC"
																							? (row.activation || row.provisioning || row.suspendResource) && (
																								<Tooltip title={t("VIEW")} style={{ marginRight: "5px" }}>
																									<IconButton
																										onClick={() => {
																											openShowDetails(row, index);
																										}}
																										className="buttonSecondary"
																									>
																										<ViewIconNew />
																									</IconButton>
																								</Tooltip>
																							)
																							: (row.activation || row.provisioning) && (
																								<Tooltip title={t("VIEW")} style={{ marginRight: "5px" }}>
																									<IconButton
																										onClick={() => {
																											openShowDetails(row, index);
																										}}
																										className="buttonSecondary"
																									>
																										<ViewIconNew />
																									</IconButton>
																								</Tooltip>
																							)}
																					</td>
																					<td style={{ padding: 0 }}>
																						<IconButton
																							className="buttonSecondary"
																							style={{ marginRight: "5px" }}
																							onClick={() => {
																								openRemoveConfirmation(row, index);
																							}}
																						>
																							<DeleteIconNew />
																						</IconButton>
																					</td>
																					{!isAuxiliary && (
																						<td style={{ padding: 0 }}>
																							<IconButton
																								className="buttonSecondary"
																								style={{ marginRight: "5px" }}
																								onClick={() => {
																									editComponent(row, index);
																								}}
																							>
																								<EditIconNew />
																							</IconButton>
																						</td>
																					)}
																					<td style={{ padding: 0 }}>
																						<Tooltip title={t("ENRICHMENT_CONFIG")} placement="bottom">
																							<IconButton
																								className="buttonSecondary"
																								style={{ marginRight: "5px" }}
																								onClick={(event) => {
																									props.expandEnrichmentDetails(event, row, !row.expandEnrichment);
																								}}
																							>
																								<PlusIcon />
																							</IconButton>
																						</Tooltip>
																					</td>
																					<td style={{ padding: 0 }}>
																						{props.currentBucketItemsCount > 1 && (
																							<>
																								{row.displaySequence && (
																									<>
																										{JSON.parse(row.displaySequence) !== 1 && (
																											<Tooltip title={t("MOVE_UP")}>
																												<IconButton
																													className="buttonSecondary"
																													style={{ marginRight: "5px" }}
																													alt={t("MOVE_UP")}
																													onClick={() => props.changeDisplaySequence("up", row)}
																												>
																													<UpIcon />
																												</IconButton>

																											</Tooltip>
																										)}
																										{+row.displaySequence !== props.currentBucketItemsCount && (
																											<Tooltip title={t("MOVE_DOWN")}>
																												<IconButton
																													className="buttonSecondary"
																													alt={t("MOVE_DOWN")}
																													onClick={() => props.changeDisplaySequence("down", row)}
																												>
																													<DownIcon />
																												</IconButton>

																											</Tooltip>
																										)}
																									</>
																								)}
																							</>
																						)}
																					</td>
																				</tr>
																			</tbody>
																		</table> */}
                                  </>
                                ) : (
                                  <Tooltip title={t("APPLY_PRICE")}>
                                    <Checkbox
                                      name="applySpecialPrice"
                                      color="primary"
                                      checked={row.promoApplied}
                                      onClick={(event) => {
                                        props.changeTableData(event, row);
                                      }}
                                      inputProps={{ "aria-label": "Add Promo" }}
                                    />
                                  </Tooltip>
                                )}
                              </TableCell>
                              {/* <TableCell align="center" className={classes.actionCell}></TableCell> */}
                            </TableRow>
                          )}

                          {/* Component Variant Call */}
                          {row.bom && row.bom.length > 0 ? (
                            <ComponentBOM
                              index={index}
                              mode={"offering"}
                              disableChild={!row.customerViewable}
                              data={row}
                              changeBomProductsData={
                                props.changeBomProductsData
                              }
                              component={props.currentBucketItems}
                              expandVariants={row.expandVariants}
                              addToCatalog={props.state.addToCatalog}
                              packageMode={props.packageMode}
                            />
                          ) : (
                            // row.assembly ?
                            // 	<ComponentAssembly index={index} data={row} component={props.currentBucketItems} expandVariants={row.expandVariants} addToCatalog={props.state.addToCatalog} packageMode={props.packageMode} />
                            // 	:
                            <ComponentVariants
                              index={index}
                              componentName=""
                              component={props.currentBucketItems}
                              expandVariants={row.expandVariants}
                              addToCatalog={props.state.addToCatalog}
                              packageMode={props.packageMode}
                              updateVariantData={updateVariantData}
                              getPriceTenureUOM={getPriceTenureUOM}
                              selectedBucketId={props.selectedBucketId}
                              isAuxiliary={isAuxiliary}
                              productRow={row}
                              changeVariantOtherPrice={
                                props.changeVariantOtherPrice
                              }
                            />
                          )}
                          <TableRow>
                            <TableCell
                              style={{
                                paddingBottom: 0,
                                paddingTop: 0,
                                border: row.expandEnrichment ? "" : "none",
                              }}
                              colSpan={9}
                            >
                              <Collapse
                                in={row.expandEnrichment}
                                timeout="auto"
                                unmountOnExit
                              >
                                <div style={{ paddingTop: 12 }}>
                                  <EnrichmentConfig
                                    data={row.enrichmentConfig}
                                    selectedEnrichmentChannel={
                                      selectedEnrichmentChannel
                                    }
                                    addEnrichmentRow={addEnrichmentRow}
                                    selectEnrichmentChannel={
                                      selectEnrichmentChannel
                                    }
                                    onChange={props.changeEnrichmentRow}
                                    deleteEnrichment={props.deleteEnrichment}
                                    parentId={row.id}
                                    channelList={props.channelList}
                                    // disableInputFields={props.state.statusDisplayName === 'Published'}
                                    disableInputFields={
                                      props.state.status === "P_PUBLISHED"
                                    }
                                  />
                                </div>
                              </Collapse>
                            </TableCell>
                          </TableRow>

                          {/* other prices */}
                          <TableRow>
                            <TableCell
                              style={{
                                paddingBottom: 0,
                                paddingTop: 0,
                                border: row.expandOtherPrices ? "" : "none",
                              }}
                              colSpan={props.packageMode === "promo" ? 6 : 9}
                            >
                              <Collapse
                                in={row.expandOtherPrices}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Box margin={1}>
                                  <Card
                                    variant="outlined"
                                    className={
                                      "roundCorners " + classes.cartItemCard
                                    }
                                    style={{ padding: "0" }}
                                  >
                                    <Grid
                                      container
                                      className={classes.cardItemHeader}
                                    >
                                      {/* <Grid xs={12} style={{ padding: '1rem' }}>
																				<b>{t("OTHER_PRICES")} : {row.name}</b>
																			</Grid> */}
                                      <div
                                        className={classes.includedItemsTable}
                                        style={{ width: "100%" }}
                                      >
                                        <TableContainer>
                                          <Table
                                            size="small"
                                            aria-label="purchases"
                                            className={
                                              "newGlobalTable roundCorners"
                                            }
                                          >
                                            {/* <TableHead>
																							<TableRow>
																								<TableCell><b>{t('NAME')}</b></TableCell>
																								<TableCell><b>{t("PRICE")} ({currencyFormatter("", false)})</b></TableCell>
																							</TableRow>
																						</TableHead> */}
                                            <TableBody>
                                              <TableRow>
                                                <TableCell colSpan={3}>
                                                  <b>
                                                    {t("OTHER_PRICES")} :{" "}
                                                    {row.name}
                                                  </b>
                                                </TableCell>
                                              </TableRow>
                                              {row.otherPrices &&
                                                row.otherPrices.length > 0 &&
                                                row.otherPrices.map(
                                                  (price, pIndex) => (
                                                    <TableRow
                                                      key={`otherPrice_${pIndex}`}
                                                    >
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {t(price.priceType)}
                                                        </span>
                                                      </TableCell>
                                                      <TableCell>
                                                        {props.packageMode !==
                                                          "promo" ? (
                                                          price.price
                                                        ) : (
                                                          <Input
                                                            size={"small"}
                                                            type={"number"}
                                                            name={"price"}
                                                            // placeholder={"Price"}
                                                            variant={"outlined"}
                                                            style={{
                                                              width: "100px",
                                                              float: "left",
                                                            }}
                                                            onChange={(
                                                              event,
                                                            ) => {
                                                              props.changeTableDataOtherPrice(
                                                                event,
                                                                row,
                                                                price.priceType,
                                                              );
                                                            }}
                                                            onKeyDown={(
                                                              event,
                                                            ) => {
                                                              // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                                              if (
                                                                event.keyCode ===
                                                                69
                                                              ) {
                                                                event.preventDefault();
                                                              }
                                                            }}
                                                            value={price.price}
                                                            className={
                                                              classes.tablePriceInput
                                                            }
                                                            //virtual price does not matter
                                                            disabled={
                                                              // (row.variants && row.variants.length > 0 ? true : false) ||
                                                              isAuxiliary ||
                                                              props.selectedBucketId ===
                                                              "PROD_COMP_PACKAGE"
                                                            }
                                                          />
                                                        )}
                                                        {price.priceType ===
                                                          "USAGE_CHARGE" ? (
                                                          <>
                                                            &nbsp;{t("RC")}{" "}
                                                            {`(per ${getPriceTenureUOM(price.priceTenureUOMDesc)})`}
                                                          </>
                                                        ) : (
                                                          <>&nbsp;{t("NRC")}</>
                                                        )}
                                                      </TableCell>
                                                      <TableCell>
                                                        &nbsp;
                                                      </TableCell>
                                                    </TableRow>
                                                  ),
                                                )}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      </div>
                                    </Grid>
                                  </Card>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                    {props.currentBucketItemsCount === 0 && (
                      <TableRow>
                        <TableCell colSpan="8" align="center">
                          {/* No {t(props.bucketName)} selected. */}
                          {t("NO_BUCKET_SELECTED", { props })}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* </Paper> */}
            </Box>
          </Grid>
        </Grid>
      )}
      {/* Component Detail Table : Ends */}
      {/* {props.packageMode === "promo" && props.selectedBucketId === "PROD_COMP_PACKAGE" && (
				<Grid container spacing={2}>
					<Grid item xs={6}></Grid>
					<Grid item xs={6}>
						<Button
							style={{ float: 'right' }}
							onClick={() => {
								props.applySpecialPrice();
							}}
						>
							{t("APPLY_SPECIAL_PRICE")}
						</Button>
					</Grid>
				</Grid>
			)} */}
      {/* Action Button to submit package : Ends */}
      <Dialog
        disableScrollLock={true}
        maxWidth={"lg"}
        PaperComponent={DraggableDialogPaper}
        fullWidth={true}
        open={showEditComponentDialog}
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              {isEdit ? t("UPDATE_ITEM") : t("ADD_ITEM")}
            </Grid>
            <Grid
              item
              align={"right"}
              size={{
                xs: 6,
              }}
            >
              {props.selectedBucketId !== "PROD_COMP_PACKAGE" && (
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                  style={{
                    float: "right",
                    width: isMobile ? "150px" : "200px",
                  }}
                  error={!!(errorr.localisedName || errorr.localisedDesc)}
                >
                  <InputLabel
                    id="language"
                    htmlFor="outlined-age-native-simple"
                  >
                    {t("SELECT_LANGUAGE") + " *"}
                  </InputLabel>
                  <Select
                    native
                    label={t("SELECT_LANGUAGE") + " *"}
                    onChange={(event) => {
                      onLanguageChange(event);
                      setErrorr({});
                    }}
                    inputProps={{
                      name: "language",
                      id: "language",
                    }}
                    value={componentData.language ? componentData.language : ""}
                  >
                    <option value="en_US">{t("English")}</option>
                    <option value="spanish">{t("Spanish")}</option>
                    <option value="en_FR">{t("French")}</option>
                  </Select>
                  {(errorr.localisedName || errorr.localisedDesc) && (
                    <span
                      style={{
                        color: "#f44336",
                        marginLeft: "0px",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {errorr.localisedName
                        ? errorr.localisedName
                        : errorr.localisedDesc}
                    </span>
                  )}
                </FormControl>
              )}
            </Grid>
          </Grid>
        </DialogTitle>
        {dialogErrorMsg && (
          <div className={classes1.errorBanner}>
            <span
              className={classes1.errorMessage}
              style={{ color: "color: #D8210E", fontWeight: "600" }}
            >
              {dialogErrorMsg}
            </span>
          </div>
        )}
        <DialogContent dividers>
          <React.Fragment>
            <Box
              className="borderOutline roundCorners"
              style={{ marginBottom: ".5rem" }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  style={{ display: "flex", alignItems: "center" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                    {t("ITEM_DETAILS")}
                  </h3>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 5,
                  }}
                >
                  <Input
                    error={!!errorr.name}
                    helperText={errorr.name}
                    divClass={classes.customDiv}
                    inputProps={{
                      maxLength: 100,
                    }}
                    name={"name"}
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("NAME") + " *"}
                    onChange={(event) => {
                      onChange(event);
                      setErrorr({
                        ...errorr,
                        name: "",
                      });
                    }}
                    value={componentData.name ? componentData.name : ""}
                    disabled={
                      (!isEdit && !showAddItem) ||
                      isAuxiliary ||
                      props.selectedBucketId === "PROD_COMP_PACKAGE" ||
                      props.state.status === "P_PUBLISHED"
                    }
                  />
                </Grid>
                {/* {props.basicDetail.categoryId && props.basicDetail.categoryId !== 'PKG' && */}
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                >
                  <Input
                    divClass={classes.customDiv}
                    size={"small"}
                    variant={"outlined"}
                    name={"featureCode"}
                    placeholder={t("PRODUCT_CODE") + "*"}
                    onChange={(event) => onChange(event)}
                    value={
                      componentData.featureCode ? componentData.featureCode : ""
                    }
                    disabled={true}
                  // disabled={(props.selectedBucketId === "PROD_COMP_PACKAGE") || (!isEdit && !showAddItem) || isAuxiliary || componentData.originalProviderId === props.providerId}
                  />
                </Grid>
                {/* } */}
                {/* <Grid item xs={(props.basicDetail.categoryId && props.basicDetail.categoryId !== 'PKG') ? 2 : 3}> */}

                {/* row 3 */}
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Input
                    error={!!errorr.description}
                    helperText={errorr.description}
                    divClass={classes.customDiv}
                    size={"small"}
                    variant={"outlined"}
                    name={"description"}
                    placeholder={t("DESCRIPTION") + " *"}
                    onChange={(event) => {
                      onChange(event);
                      setErrorr({
                        ...errorr,
                        description: "",
                      });
                    }}
                    multiline={true}
                    inputProps={{ rows: 2, cols: 31 }}
                    value={
                      componentData.description ? componentData.description : ""
                    }
                    disabled={
                      (!isEdit && !showAddItem) ||
                      isAuxiliary ||
                      props.selectedBucketId === "PROD_COMP_PACKAGE" ||
                      props.state.status === "P_PUBLISHED"
                    }
                  />
                </Grid>
              </Grid>
            </Box>
            <Box
              className="borderOutline roundCorners"
              style={{ marginBottom: ".5rem" }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  style={{ display: "flex", alignItems: "center" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                    {t("PRICE_DETAILS")}
                  </h3>
                </Grid>
                {/* Apply margin */}
                {
                  // props.tenantInfo.tenantId === componentData.originalProviderId ? (
                  // 	""
                  // ) : (
                  <>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 3,
                      }}
                    >
                      <Input
                        error={!!errorr.initialMargin}
                        helperText={errorr.initialMargin}
                        divClass={classes.customDiv}
                        size={"small"}
                        variant={"outlined"}
                        name={"margin"}
                        min={0}
                        placeholder={t("RECOMMENDED_MARKUP") + " (%)"}
                        type={"number"}
                        onChange={(event) => {
                          if (
                            event.target.value >= 0 ||
                            event.target.value === ""
                          ) {
                            updateMargin(event.target.value, "rec");
                            setErrorr({
                              ...errorr,
                              initialMargin: "",
                            });
                          }
                        }}
                        onKeyDown={(event) => {
                          // Intercept the letter "e" (Key code 69) and prevent its default behavior
                          if (event.keyCode === 69) {
                            event.preventDefault();
                          }
                        }}
                        value={initialMargin}
                        disabled={
                          (props.tenantRoles.includes("CHILD_PROVIDER") &&
                            props.tenantInfo.tenantId !==
                            componentData.originalProviderId) ||
                          props.state.status === "P_PUBLISHED"
                        }
                      />
                    </Grid>
                    {props.tenantRoles.includes("CHILD_PROVIDER") && (
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 3,
                        }}
                      >
                        <Input
                          error={!!errorr.salesMargin}
                          helperText={errorr.salesMargin}
                          divClass={classes.customDiv}
                          size={"small"}
                          variant={"outlined"}
                          min={0}
                          name={"salesMargin"}
                          placeholder={t("SALES_MARKUP") + " (%)"}
                          type={"number"}
                          onChange={(event) => {
                            if (
                              event.target.value >= 0 ||
                              event.target.value === ""
                            ) {
                              updateMargin(event.target.value, "sale");
                              setErrorr({
                                ...errorr,
                                salesMargin: "",
                              });
                            }
                          }}
                          onKeyDown={(event) => {
                            // Intercept the letter "e" (Key code 69) and prevent its default behavior
                            if (event.keyCode === 69) {
                              event.preventDefault();
                            }
                          }}
                          value={salesMargin}
                          // disabled={props.state.statusDisplayName === 'Published'}
                          disabled={props.state.status === "P_PUBLISHED"}
                        />
                      </Grid>
                    )}
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 3,
                      }}
                    >
                      <Input
                        error={!!errorr.initialMinimumMargin}
                        helperText={errorr.initialMinimumMargin}
                        divClass={classes.initialMinimumMargin}
                        size={"small"}
                        variant={"outlined"}
                        min={0}
                        name={"minimumMargin"}
                        placeholder={t("MINIMUM_MARKUP") + " (%)"}
                        type={"number"}
                        onChange={(event) => {
                          if (
                            event.target.value >= 0 ||
                            event.target.value === ""
                          ) {
                            updateMargin(event.target.value, "min");
                            setErrorr({
                              ...errorr,
                              initialMinimumMargin: "",
                              salesMargin: "",
                            });
                          }
                        }}
                        onKeyDown={(event) => {
                          // Intercept the letter "e" (Key code 69) and prevent its default behavior
                          if (event.keyCode === 69) {
                            event.preventDefault();
                          }
                        }}
                        value={initialMinimumMargin}
                        disabled={
                          (props.tenantRoles.includes("CHILD_PROVIDER") &&
                            props.tenantInfo.tenantId !==
                            componentData.originalProviderId) ||
                          props.state.status === "P_PUBLISHED"
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 2,
                      }}
                    >
                      {(props.userPerms.includes("CATALOG_ADMIN") ||
                        props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                        props.userPerms.includes("CATALOG_CREATE") ||
                        props.userPerms.includes("CATALOG_UPDATE")) &&
                        props.state.status !== "P_PUBLISHED" && (
                          <Button onClick={() => applyMargin()}>
                            {t("APPLY_MARGIN")}
                          </Button>
                        )}
                    </Grid>
                    <Grid
                      item
                      style={{ paddingTop: 0, paddingBottom: 0 }}
                      size={{
                        xs: 12,
                      }}
                    ></Grid>
                  </>
                  // )
                }

                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                >
                  {props.tenantRoles.includes("CHILD_PROVIDER") ? (
                    <Input
                      divClass={classes.customDiv}
                      name={"partnerPrice"}
                      min={1}
                      variant={"outlined"}
                      type={"number"}
                      size={"small"}
                      placeholder={
                        t("RECOMMENDED_PRICE") +
                        " : (" +
                        currencyFormatter("", false) +
                        ")"
                      }
                      value={Number(componentData.groupPrice).toFixed(2)}
                      disabled={true}
                    />
                  ) : (
                    <Input
                      error={!!errorr.price}
                      helperText={errorr.price}
                      divClass={classes.customDiv}
                      name={"price"}
                      min={1}
                      variant={"outlined"}
                      type={"number"}
                      size={"small"}
                      onChange={(event) => {
                        onChange(event);
                        setErrorr({
                          ...errorr,
                          price: "",
                        });
                      }}
                      onKeyDown={(event) => {
                        // Intercept the letter "e" (Key code 69) and prevent its default behavior
                        if (event.keyCode === 69) {
                          event.preventDefault();
                        }
                      }}
                      placeholder={
                        t("RECOMMENDED_PRICE") +
                        " * : (" +
                        currencyFormatter("", false) +
                        ")"
                      }
                      value={Number(componentData.price).toFixed(2)}
                      // disabled={(!isEdit && !showAddItem) || isAuxiliary || componentData.hasVariant || props.selectedBucketId === "PROD_COMP_PACKAGE"}
                      disabled={true}
                    />
                  )}
                </Grid>
                {
                  // (props.tenantInfo.tenantId === componentData.originalProviderId &&
                  // 	props.providerType === "SALES_CHNL_PROVIDER"
                  // ) ? '' : (
                  props.tenantRoles.includes("CHILD_PROVIDER") ? (
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 3,
                      }}
                    >
                      <Input
                        error={!!errorr.price}
                        helperText={errorr.price}
                        divClass={classes.customDiv}
                        name={"price"}
                        min={1}
                        variant={"outlined"}
                        type={"number"}
                        size={"small"}
                        placeholder={
                          t("SALES_PRICE") +
                          " : (" +
                          currencyFormatter("", false) +
                          ")" +
                          " *"
                        }
                        value={Number(componentData.price).toFixed(2)}
                        onChange={(event) => {
                          onChange(event);
                          setErrorr({
                            ...errorr,
                            price: "",
                          });
                        }}
                        onKeyDown={(event) => {
                          // Intercept the letter "e" (Key code 69) and prevent its default behavior
                          if (event.keyCode === 69) {
                            event.preventDefault();
                          }
                        }}
                        disabled={true}
                      />
                    </Grid>
                  ) : (
                    ""
                  )
                  // )
                }
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                >
                  <Input
                    error={!!errorr.minimumPrice}
                    helperText={errorr.minimumPrice}
                    divClass={classes.customDiv}
                    name={"minimumPrice"}
                    min={1}
                    variant={"outlined"}
                    type={"number"}
                    size={"small"}
                    onChange={(event) => {
                      onChange(event);
                      setErrorr({
                        ...errorr,
                        price: "",
                      });
                    }}
                    onKeyDown={(event) => {
                      // Intercept the letter "e" (Key code 69) and prevent its default behavior
                      if (event.keyCode === 69) {
                        event.preventDefault();
                      }
                    }}
                    placeholder={
                      t("MINIMUM_PRICE") +
                      " : (" +
                      currencyFormatter("", false) +
                      ")"
                    }
                    value={Number(componentData.minimumPrice).toFixed(2)}
                    // disabled={(!isEdit && !showAddItem) || isAuxiliary || componentData.hasVariant || props.selectedBucketId === "PROD_COMP_PACKAGE"}
                    disabled={true}
                  />
                </Grid>
                {/* <Grid
                  item
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                > */}
                {props.tenantInfo.tenantId ===
                  componentData.originalProviderId &&
                  props.providerType === "SALES_CHNL_PROVIDER" ? (
                  ""
                ) : props.tenantRoles.includes("CHILD_PROVIDER") ? (
                  ""
                ) : (
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 3,
                    }}
                  >
                    <Input
                      divClass={classes.customDiv}
                      name={"partnerPrice"}
                      min={1}
                      variant={"outlined"}
                      type={"number"}
                      size={"small"}
                      placeholder={
                        t("PARTNER_PRICE") +
                        " : (" +
                        currencyFormatter("", false) +
                        ")"
                      }
                      value={Number(componentData.originalPrice).toFixed(2)}
                      disabled={true}
                    />
                  </Grid>
                )}
                {/* </Grid> */}
                {/* <Grid item size={{ xs: 0, md: 3 }}></Grid> */}
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                >
                  {/* <FormControl variant="outlined" className="custom-select-input" size={"small"} disabled={!isEdit && (!showAddItem || props.packageMode === "edit" || props.packageMode === "promo") || isAuxiliary}>
									<InputLabel htmlFor="priceType">{t('SELECT_PRICE_TYPE')}</InputLabel>
									<Select native onChange={(event) => onChange(event)} inputProps={{ name: "priceType", id: "priceType" }} value={componentData.priceType ? componentData.priceType : ""}>
										<option value="" disabled></option>
										<option value="NRC">{t('NRC_FULL')}</option>
										<option value="MRC">{t('MRC_FULL')}</option>
										<option value="NTC">{t('NTC_FULL')}</option>
									</Select>
								</FormControl> */}
                  <FormControl
                    variant="outlined"
                    className="custom-select-input"
                    size={"small"}
                    disabled={true}
                  >
                    <InputLabel htmlFor="priceType">
                      {t("SELECT_PRICE_TYPE") + " *"}
                    </InputLabel>
                    <Select
                      native
                      label={t("SELECT_PRICE_TYPE") + " *"}
                      onChange={(event) => onChange(event)}
                      inputProps={{ name: "priceType", id: "priceType" }}
                      value={
                        componentData.priceType ? componentData.priceType : ""
                      }
                    >
                      <option value="" disabled></option>
                      <option value="NRC">{t("NRC_FULL")}</option>
                      <option value="RC">{t("RC_FULL")}</option>
                      <option value="NTC">{t("NTC_FULL")}</option>
                    </Select>
                  </FormControl>
                </Grid>
                {(componentData.priceType === "RC" ||
                  componentData.priceType === "NTC") && (
                    <>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 3,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          size={"small"}
                          className={classes.customeSelectLabel}
                          disabled={true}
                        >
                          <InputLabel htmlFor="priceTenureUOM">
                            {t("SELECT_TENURE_UOM") + " *"}
                          </InputLabel>
                          <Select
                            value={
                              componentData.priceTenureUOM
                                ? componentData.priceTenureUOM
                                : ""
                            }
                            native
                            label={t("SELECT_TENURE_UOM") + " *"}
                            onChange={(event) => props.onChange(event)}
                            inputProps={{
                              name: "priceTenureUOM",
                              id: "priceTenureUOM",
                            }}
                            // disabled={props.readonlyMode}
                            disabled={true}
                          >
                            <option value="" disabled></option>
                            {componentData.priceType === "NTC" && (
                              <option value="TF_hr">{t("HOURS")}</option>
                            )}
                            <option value="TF_day">{t("DAILY")}</option>
                            <option value="TF_wk">{t("WEEKLY")}</option>
                            <option value="TF_mon">{t("MONTHLY")}</option>
                            {/* <option value="TF_qtr">{t('QUARTERLY')}</option> */}
                            <option value="TF_yr">{t("YEARLY")}</option>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 3,
                        }}
                      >
                        <Input
                          name={"priceTenure"}
                          value={componentData.priceTenure}
                          onChange={(event) => props.onChange(event)}
                          onKeyDown={(event) => {
                            // Intercept the letter "e" (Key code 69) and prevent its default behavior
                            if (event.keyCode === 69) {
                              event.preventDefault();
                            }
                          }}
                          placeholder={t("TERM_TENURE") + " *"}
                          type={"number"}
                          size={"small"}
                          min={1}
                          variant={"outlined"}
                          disabled={true}
                        />
                      </Grid>
                    </>
                  )}
                {/* {componentData.originalPrice} */}
                {/* row 4 */}
                {/* <Grid item xs={2} >
                            <Input
                                size={'small'}
                                type={'number'}
                                name={'quantity'}
                                placeholder={'Qty'}
                                min={1} variant={'outlined'}
                                onChange={event => onChange(event)}
                                value={componentData.quantity ? componentData.quantity : ""}
                                disabled={!isEdit && !showAddItem}
                            />
                        </Grid> */}

                {/* Other prices wrapper start */}
                {componentData.otherPrices &&
                  componentData.otherPrices.length > 0 && (
                    <>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                          {t("OTHER_PRICES")}
                        </h3>
                      </Grid>
                      {componentData.otherPrices.map((price, pIndex) => (
                        <>
                          <div className="otherPricesGroup" key={pIndex}>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 2,
                              }}
                            >
                              {props.tenantRoles.includes("CHILD_PROVIDER") ? (
                                <Input
                                  error={
                                    !!errorr[`otherPrice_${price.priceType}`]
                                  }
                                  helperText={
                                    errorr[`otherPrice_${price.priceType}`]
                                  }
                                  name={"originalPrice"}
                                  // value={Number(price.groupPrice).toFixed(2)}
                                  value={price.groupPrice}
                                  placeholder={
                                    t("RECOMMENDED_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  type={"number"}
                                  size={"small"}
                                  min={1}
                                  variant={"outlined"}
                                  disabled={true}
                                // disabled={!editOtherPriceIndices.has(pIndex)}
                                />
                              ) : (
                                <Input
                                  error={
                                    !!errorr[`otherPrice_${price.priceType}`]
                                  }
                                  helperText={
                                    errorr[`otherPrice_${price.priceType}`]
                                  }
                                  name={"price"}
                                  // value={Number(price.price).toFixed(2)}
                                  value={price.price}
                                  onChange={(event) =>
                                    onChangeOtherPrice(event, price.priceType)
                                  }
                                  onBlur={(event) => onBlurOtherPrice(event, price.priceType)}
                                  onKeyDown={(event) => {
                                    // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                    if (event.keyCode === 69) {
                                      event.preventDefault();
                                    }
                                  }}
                                  placeholder={
                                    t("RECOMMENDED_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  type={"number"}
                                  size={"small"}
                                  min={1}
                                  variant={"outlined"}
                                  // disabled={true}
                                  disabled={props.enabledFeatures.feature_override_recommendedPrice && props.enabledFeatures.feature_override_recommendedPrice === 'enabled' && !editOtherPriceIndices.has(pIndex)}
                                />
                              )}
                            </Grid>
                            {
                              // (props.tenantInfo.tenantId === componentData.originalProviderId &&
                              // 	props.providerType === "SALES_CHNL_PROVIDER"
                              // ) ? '' : (
                              props.tenantRoles.includes("CHILD_PROVIDER") ? (
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 2,
                                  }}
                                >
                                  <Input
                                    error={
                                      !!errorr[`otherPrice_sales_${price.priceType}`]
                                    }
                                    helperText={
                                      errorr[`otherPrice_sales_${price.priceType}`]
                                    }
                                    name={"price"}
                                    // value={Number(price.price).toFixed(2)}
                                    value={price.price}
                                    onChange={(event) =>
                                      onChangeOtherPrice(event, price.priceType)
                                    }
                                    onKeyDown={(event) => {
                                      // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                      if (event.keyCode === 69) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={(event) => onBlurOtherPrice(event, price.priceType)}
                                    placeholder={
                                      t("SALES_PRICE") +
                                      " : (" +
                                      currencyFormatter("", false) +
                                      ")" +
                                      " *"
                                    }
                                    type={"number"}
                                    size={"small"}
                                    min={1}
                                    variant={"outlined"}
                                    // disabled={true}
                                    disabled={!editOtherPriceIndices.has(pIndex)}
                                  />
                                </Grid>
                              ) : (
                                ""
                              )
                              // )
                            }
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 2,
                              }}
                            >
                              {props.tenantRoles.includes("CHILD_PROVIDER") ?
                                <Input
                                  // divClass={classes.customDiv}
                                  // error={!!props.err.price}
                                  // helperText={props.err.price}
                                  name={"minimumPrice"}
                                  value={Number(price.minimumPrice).toFixed(2)}
                                  onChange={(event) =>
                                    onChangeOtherPrice(event, price.priceType)
                                  }
                                  onKeyDown={(event) => {
                                    // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                    if (event.keyCode === 69) {
                                      event.preventDefault();
                                    }
                                  }}
                                  placeholder={
                                    t("MINIMUM_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  type={"number"}
                                  size={"small"}
                                  min={1}
                                  variant={"outlined"}
                                  disabled={true}
                                />
                                :
                                <Input
                                  // divClass={classes.customDiv}
                                  // error={!!props.err.price}
                                  // helperText={props.err.price}
                                  name={"minimumPrice"}
                                  // value={Number(price.minimumPrice).toFixed(2)}
                                  value={price.minimumPrice}
                                  onChange={(event) =>
                                    onChangeOtherPrice(event, price.priceType)
                                  }
                                  onBlur={(event) => onBlurOtherPrice(event, price.priceType)}
                                  onKeyDown={(event) => {
                                    // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                    if (event.keyCode === 69) {
                                      event.preventDefault();
                                    }
                                  }}
                                  placeholder={
                                    t("MINIMUM_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  error={
                                    !!errorr[`otherPrice_minimum_${price.priceType}`]
                                  }
                                  helperText={
                                    errorr[`otherPrice_minimum_${price.priceType}`]
                                  }
                                  type={"number"}
                                  size={"small"}
                                  min={1}
                                  variant={"outlined"}
                                  // disabled={true}
                                  disabled={props.enabledFeatures.feature_override_minimumPrice && props.enabledFeatures.feature_override_minimumPrice === 'enabled' && !editOtherPriceIndices.has(pIndex)}
                                />
                              }
                            </Grid>
                            {props.tenantInfo.tenantId ===
                              componentData.originalProviderId &&
                              props.providerType === "SALES_CHNL_PROVIDER" ? (
                              ""
                            ) : props.tenantRoles.includes("CHILD_PROVIDER") ? (
                              ""
                            ) : (
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 2,
                                }}
                              >
                                <Input
                                  divClass={classes.customDiv}
                                  name={"partnerPrice"}
                                  min={1}
                                  variant={"outlined"}
                                  type={"number"}
                                  size={"small"}
                                  placeholder={
                                    t("PARTNER_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  value={Number(price.originalPrice).toFixed(2)}
                                  disabled={true}
                                />
                              </Grid>
                            )}
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 3,
                              }}
                            >
                              <FormControl
                                variant="outlined"
                                size={"small"}
                                className="custom-select-input-white-label"
                                disabled={true}
                              >
                                <InputLabel htmlFor={"priceTypeLabel" + pIndex}>
                                  {t("SELECT_PRICE_TYPE")}
                                </InputLabel>
                                <Select
                                  value={price.priceType ? price.priceType : ""}
                                  native
                                  label={t("SELECT_PRICE_TYPE")}
                                  onChange={(event) =>
                                    onChangeOtherPrice(event, pIndex)
                                  }
                                  inputProps={{
                                    name: "priceType",
                                    id: "priceTypeLabel" + pIndex,
                                  }}
                                >
                                  <option
                                    value="DEPOSIT"
                                    disabled={
                                      componentData.otherPrices.findIndex(
                                        (x) => x.priceType === "DEPOSIT",
                                      ) > -1
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("DEPOSIT_PRICE")}
                                  </option>
                                  <option
                                    value="CANCELLATION_PRICE"
                                    disabled={
                                      componentData.otherPrices.findIndex(
                                        (x) =>
                                          x.priceType === "CANCELLATION_PRICE",
                                      ) > -1
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("CANCELLATION_PRICE")}
                                  </option>
                                  <option
                                    value="SHIFT_PRICE"
                                    disabled={
                                      componentData.otherPrices.findIndex(
                                        (x) => x.priceType === "SHIFT_PRICE",
                                      ) > -1
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("SHIFT_PRICE")}
                                  </option>
                                  <option
                                    value="SUSPENSION_PRICE"
                                    disabled={
                                      componentData.otherPrices.findIndex(
                                        (x) =>
                                          x.priceType === "SUSPENSION_PRICE",
                                      ) > -1
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("SUSPENSION_PRICE")}
                                  </option>
                                  <option
                                    value="REACTIVATION_PRICE"
                                    disabled={
                                      componentData.otherPrices.findIndex(
                                        (x) =>
                                          x.priceType === "REACTIVATION_PRICE",
                                      ) > -1
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("REACTIVATION_PRICE")}
                                  </option>
                                  <option
                                    value="USAGE_CHARGE"
                                    disabled={
                                      componentData.otherPrices.findIndex(
                                        (x) => x.priceType === "USAGE_CHARGE",
                                      ) > -1
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("USAGE_CHARGE")}
                                  </option>
                                </Select>
                                {/* {props.err.priceType && <span style={{ color: '#f44336', marginLeft: '0px', fontSize: '0.75rem', marginTop: '4px' }}>{props.err.priceType}</span>} */}
                              </FormControl>
                            </Grid>
                            {price.priceType === "USAGE_CHARGE" ? (
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 3,
                                }}
                              >
                                <FormControl
                                  variant="outlined"
                                  size={"small"}
                                  className="custom-select-input-white-label"
                                  disabled={true}
                                >
                                  <InputLabel
                                    htmlFor={"priceTenureUOM" + pIndex}
                                  >
                                    {t("USAGE_CHARGE_UOM")}
                                  </InputLabel>
                                  <Select
                                    //disabled={props.mode === 'edit'}
                                    value={
                                      price.priceTenureUOM
                                        ? price.priceTenureUOM
                                        : ""
                                    }
                                    native
                                    label={t("USAGE_CHARGE_UOM")}
                                    onChange={(event) =>
                                      onChangeOtherPrice(event, pIndex)
                                    }
                                    inputProps={{
                                      name: "priceTenureUOM",
                                      id: "priceTenureUOM" + pIndex,
                                    }}
                                  >
                                    <option value={"TF_hr"}>
                                      {t("HOURLY")}
                                    </option>
                                    <option value={"TF_day"}>
                                      {t("DAILY")}
                                    </option>
                                    <option value={"TF_wk"}>
                                      {t("WEEKLY")}
                                    </option>
                                    <option value={"TF_mon"}>
                                      {t("MONTHLY")}
                                    </option>
                                    <option value={"TF_yr"}>
                                      {t("YEARLY")}
                                    </option>
                                    <option value={"DATA_MB"}>
                                      {t("PER_MB")}
                                    </option>
                                    <option value={"DATA_GB"}>
                                      {t("PER_GB")}
                                    </option>
                                  </Select>
                                </FormControl>
                              </Grid>
                            ) : (
                              ""
                            )}
                            <Grid item size={{ xs: 6, md: 2 }}>
                              {/* {!props.tenantRoles.includes("CHILD_PROVIDER") && !editOtherPriceIndices.has(pIndex) && ( */}
                              {props.providerType === "SALES_CHNL_PROVIDER" &&
                                <>
                                  {props.tenantRoles.includes("MASTER_PROVIDER") ?
                                    <>
                                      {(props.enabledFeatures.feature_override_minimumPrice && props.enabledFeatures.feature_override_minimumPrice === 'enabled'
                                        ||
                                        props.enabledFeatures.feature_override_recommendedPrice && props.enabledFeatures.feature_override_recommendedPrice === 'enabled')
                                        &&
                                        <>
                                          {!editOtherPriceIndices.has(pIndex) && (
                                            <Tooltip title={t("EDIT_PRICE")}>
                                              <IconButton
                                                // variant="outlined"
                                                className='buttonSecondary'
                                                size={"small"}
                                                onClick={(event) => {
                                                  overwriteOtherPrice(event, pIndex)
                                                }}
                                              >
                                                <EditIconNew />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                        </>
                                      }
                                    </>
                                    :
                                    <>
                                      {props.enabledFeatures.feature_override_salePrice && props.enabledFeatures.feature_override_salePrice === 'enabled' &&
                                        <>
                                          {!editOtherPriceIndices.has(pIndex) && (
                                            <Tooltip title={t("EDIT_PRICE")}>
                                              <Button
                                                // variant="outlined"
                                                className='buttonSecondary'
                                                size={"small"}
                                                onClick={(event) => {
                                                  overwriteOtherPrice(event, pIndex)
                                                }}
                                              >
                                                <EditIconNew />
                                              </Button>
                                            </Tooltip>
                                          )}
                                        </>
                                      }
                                    </>
                                  }
                                </>
                              }
                            </Grid>
                          </div>
                        </>
                      ))}
                    </>
                  )}
              </Grid>
            </Box>
            {/* Dependency wrapper start */}
            {props.basicDetail.categoryId &&
              props.basicDetail.categoryId !== "PKG" &&
              props.parentTabValue !== 2 && (
                <>
                  <Box
                    className="borderOutline roundCorners"
                    style={{ marginBottom: ".5rem" }}
                  >
                    <Grid container spacing={2}>
                      <Grid
                        item
                        style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}
                        size={{
                          xs: 12,
                        }}
                      >
                        <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                          {t("DEPENDENCIES")}
                        </h3>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={1}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <div style={{ marginTop: 0, marginBottom: 0, color: "#717784", fontWeight: "bold", fontSize: '14px' }}>
                          {t("DEPENDS_ON")}
                        </div>
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                          error={!!dependencyError.dependerBucketName}
                        >
                          <InputLabel htmlFor={"dependOnBucketName"}>
                            {t("COMPONENT_TYPE")}
                          </InputLabel>
                          <Select
                            native
                            label={t("COMPONENT_TYPE")}
                            onChange={(event) => dependencies(event)}
                            labelId={"dependOnBucketNameLabel"}
                            inputProps={{
                              name: "dependOnBucketName",
                              id: "dependOnBucketName",
                            }}
                            value={
                              componentData.tempDependency.dependerBucketName
                            }
                            disabled={
                              (!isEdit && !showAddItem) ||
                              props.state.status === "P_PUBLISHED"
                            }
                          >
                            <option value=""></option>
                            <option value="PACKAGED_SOLUTION">All</option>
                            {showBucketsList() && (
                              <>
                                <optgroup label={t("COMPONENT_TYPES")}>
                                  {extractLeafCategories(props.bucketList)
                                    .sort((a, b) =>
                                      a && b
                                        ? a.sequenceNum - b.sequenceNum
                                        : 0,
                                    )
                                    .map(
                                      (bucket, index) =>
                                        bucket.sequenceNum !==
                                        props.bucketSeqNum && //the currect bucket shouldn't be displayed
                                        bucket.sequenceNum <
                                        props.bucketSeqNum && ( //only the bucket which are prior to the current ones should be displayed
                                          <option key={index} value={bucket.id}>
                                            {bucket.name}
                                          </option>
                                        ),
                                    )}
                                </optgroup>
                              </>
                            )}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                          error={!!dependencyError.depender}
                        >
                          <InputLabel htmlFor={"depender"}>
                            {t("CHOOSE_COMPONENT")}
                          </InputLabel>
                          <Select
                            native
                            label={t("CHOOSE_COMPONENT")}
                            onChange={(event) => dependencies(event)}
                            inputProps={{
                              name: "depender",
                              id: "depender",
                            }}
                            value={componentData.tempDependency.depender}
                            disabled={
                              (!isEdit && !showAddItem) ||
                              componentData.tempDependency
                                .dependerBucketName === "PACKAGED_SOLUTION" ||
                              props.state.status === "P_PUBLISHED"
                            }
                          >
                            <option value=""></option>
                            {componentData.selectedBucketComponents.map(
                              (bucketItem, i) => (
                                <option key={i} value={bucketItem.featureCode}>
                                  {bucketItem.name}
                                </option>
                              ),
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* depender- earlier bucket quantity */}
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                        >
                          <InputLabel htmlFor={"depender"}>
                            {t("DEPENDENCY_MODE")}
                          </InputLabel>
                          <Select
                            native
                            label={t("DEPENDENCY_MODE")}
                            onChange={(event) => dependencies(event)}
                            inputProps={{
                              name: "dependencyMode",
                              id: "dependencyMode",
                            }}
                            value={componentData.tempDependency.dependencyMode}
                            disabled={
                              (!isEdit && !showAddItem) ||
                              componentData.tempDependency
                                .dependerBucketName === "PACKAGED_SOLUTION" ||
                              props.state.status === "P_PUBLISHED"
                            }
                          >
                            <option value="forEach">{t("FOR_EACH")}</option>
                            <option value="conditional">{t("CONDITIONAL")}</option>
                          </Select>
                        </FormControl>
                      </Grid>
                      {componentData.tempDependency.dependencyMode === 'conditional' && (
                        <>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: "auto",
                            }}
                            style={{ display: "flex", alignItems: "center", marginLeft: '1.5rem', height: '32px' }}
                          >

                            {/* <div style={{ marginTop: 0, marginBottom: 0, fontSize: '14px', marginRight: '1rem' }}>
                {t("SELECT_QUANTITY")}:
              </div> */}
                            <RadioGroup
                              row
                              name="quantityType"
                              value={componentData.tempDependency.quantity.type}
                              onChange={(event) => dependencies(event)}
                            >
                              <FormControlLabel
                                value="Exact"
                                control={
                                  <Radio
                                    color="primary"
                                    disabled={
                                      (!isEdit && !showAddItem) ||
                                      props.state.status === "P_PUBLISHED"
                                    }
                                  />
                                }
                                label={props.t("EXACT")}
                              />
                              <FormControlLabel
                                value="Range"
                                control={
                                  <Radio
                                    color="primary"
                                    disabled={
                                      (!isEdit && !showAddItem) ||
                                      props.state.status === "P_PUBLISHED"
                                    }
                                  />
                                }
                                label={props.t("USE_RANGE")}
                              />
                            </RadioGroup>
                            {/* <FormControlLabel
                            style={{ paddingLeft: ".5rem" }}
                            control={
                              <Switch
                                color="primary"
                                // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                                disabled={
                                  (!isEdit && !showAddItem) ||
                                  props.state.status === "P_PUBLISHED"
                                }
                                checked={
                                  componentData.tempDependency.quantity.type === "Range"
                                }
                                inputProps={{
                                  "aria-label": "Dependency range type Checkbox",
                                }}
                                name="quantityType"
                                onChange={(event) => dependencies(event)}
                              />
                            }
                            label={props.t("USE_RANGE")}
                          /> */}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 6,
                              md: 3,
                            }}
                          >
                            {componentData.tempDependency.quantity.type ===
                              "Exact" ? (
                              <>
                                <Input
                                  label="Exact"
                                  name={"quantityMin"}
                                  style={{ width: "100px" }}
                                  className={classes.quantityInput}
                                  type={"number"}
                                  placeholder={t("QUANTITY")}
                                  variant={"outlined"}
                                  onChange={(event) => dependencies(event)}
                                  onKeyDown={(event) => {
                                    // Prevent decimal point, 'e', '+', and '-' keys
                                    if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    componentData.tempDependency.quantity
                                      .type === "Exact"
                                      ? componentData.tempDependency.quantity
                                        .range.min
                                      : ""
                                  }
                                  error={!!dependencyError.quantity?.range?.min}
                                  // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                                  disabled={
                                    (!isEdit && !showAddItem) ||
                                    props.state.status === "P_PUBLISHED"
                                  }
                                />
                              </>
                            ) : (
                              <>
                                <Input
                                  name={"quantityMin"}
                                  style={{ width: "100px", marginRight: 8 }}
                                  type={"number"}
                                  placeholder={t("MIN_QUANTITY")}
                                  className={classes.quantityInput}
                                  variant={"outlined"}
                                  onChange={(event) => dependencies(event)}
                                  onKeyDown={(event) => {
                                    // Prevent decimal point, 'e', '+', and '-' keys
                                    if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    componentData.tempDependency.quantity
                                      .type === "Range"
                                      ? componentData.tempDependency.quantity
                                        .range.min
                                      : ""
                                  }
                                  error={!!dependencyError.quantity?.range?.min}
                                  // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                                  disabled={
                                    (!isEdit && !showAddItem) ||
                                    props.state.status === "P_PUBLISHED"
                                  }
                                />
                                <Input
                                  name={"quantityMax"}
                                  style={{ width: "100px" }}
                                  type={"number"}
                                  placeholder={t("MAX_QUANTITY")}
                                  className={classes.quantityInput}
                                  variant={"outlined"}
                                  onChange={(event) => dependencies(event)}
                                  onKeyDown={(event) => {
                                    // Prevent decimal point, 'e', '+', and '-' keys
                                    if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    componentData.tempDependency.quantity.range
                                      .max
                                  }
                                  error={!!dependencyError.quantity?.range?.max}
                                  // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                                  disabled={
                                    (!isEdit && !showAddItem) ||
                                    props.state.status === "P_PUBLISHED"
                                  }
                                />
                              </>
                            )}

                          </Grid>
                        </>
                      )}


                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <div style={{ marginTop: 0, marginBottom: 0, color: "#717784", fontWeight: "bold", fontSize: '14px', marginTop: '1rem' }}>
                          {t("DEPENDEE")}
                          {/* ( {componentData.name} ) */}
                        </div>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                        >
                          <InputLabel htmlFor="dependencyType">
                            {t("DEPENDENCY_TYPE")}
                          </InputLabel>
                          <Select
                            native
                            label={t("DEPENDENCY_TYPE")}
                            onChange={(event) => dependencies(event)}
                            inputProps={{
                              name: "dependencyType",
                              id: "dependencyType",
                            }}
                            value={componentData.tempDependency.dependencyType}
                            disabled={
                              (!isEdit && !showAddItem) ||
                              props.state.status === "P_PUBLISHED"
                            }
                          >
                            <option value=""></option>
                            <option value="Mandatory">{t("MANDATORY")}</option>
                            <option value="Optional">{t("OPTIONAL")}</option>
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* dependee quantity */}
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: "auto",
                        }}
                        style={{ display: "flex", alignItems: "center", height: '32px' }}
                      >
                        {/* <div style={{ marginTop: 0, marginBottom: 0, fontSize: '14px', marginRight: '1rem' }}>
							{t("SELECT_QUANTITY")}:
						</div> */}
                        {/* commenting out the exact/range switch since we would only need exact for dependee quantity */}
                        <RadioGroup
                          row
                          name="type"
                          value={componentData.tempDependency.cardinality.type}
                          onChange={(event) => dependencies(event)}
                          style={{ paddingLeft: ".5rem" }}
                        >
                          <FormControlLabel
                            value="Exact"
                            control={
                              <Radio
                                color="primary"
                                disabled={
                                  (!isEdit && !showAddItem) ||
                                  props.state.status === "P_PUBLISHED"
                                }
                              />
                            }
                            label={props.t("EXACT")}
                          />
                          <FormControlLabel
                            value="Range"
                            control={
                              <Radio
                                color="primary"
                                disabled={
                                  (!isEdit && !showAddItem) ||
                                  props.state.status === "P_PUBLISHED"
                                }
                              />
                            }
                            label={props.t("USE_RANGE")}
                          />
                        </RadioGroup>

                        {/* <FormControlLabel
                          style={{ paddingLeft: ".5rem" }}
                          control={
                            <Switch
                              color="primary"
                              // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                              disabled={
                                (!isEdit && !showAddItem) ||
                                props.state.status === "P_PUBLISHED"
                              }
                              checked={
                                componentData.tempDependency.cardinality
                                  .type === "Range"
                              }
                              inputProps={{
                                "aria-label": "Dependency Type Checkbox",
                              }}
                              name="type"
                              onChange={(event) => dependencies(event)}
                            />
                          }
                          label={props.t("USE_RANGE")}
                        /> */}
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: "auto",
                        }}
                      >
                        {componentData.tempDependency.cardinality.type ===
                          "Exact" ? (
                          <>
                            <Input
                              label="ASDF"
                              name={"min"}
                              style={{ width: "100px" }}
                              className={classes.quantityInput}
                              type={"number"}
                              placeholder={t("QUANTITY")}
                              variant={"outlined"}
                              onChange={(event) => dependencies(event)}
                              onKeyDown={(event) => {
                                // Prevent decimal point, 'e', '+', and '-' keys
                                if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                  event.preventDefault();
                                }
                              }}
                              value={
                                componentData.tempDependency.cardinality
                                  .type === "Exact"
                                  ? componentData.tempDependency.cardinality
                                    .range.min
                                  : ""
                              }
                              error={!!dependencyError.cardinality?.range?.min}
                              // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                              disabled={
                                (!isEdit && !showAddItem) ||
                                props.state.status === "P_PUBLISHED"
                              }
                            />
                          </>
                        ) : (
                          <>
                            <Input
                              name={"min"}
                              style={{ width: "100px", marginRight: 8 }}
                              type={"number"}
                              placeholder={t("MIN_QUANTITY")}
                              className={classes.quantityInput}
                              variant={"outlined"}
                              onChange={(event) => dependencies(event)}
                              onKeyDown={(event) => {
                                // Prevent decimal point, 'e', '+', and '-' keys
                                if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                  event.preventDefault();
                                }
                              }}
                              value={
                                componentData.tempDependency.cardinality
                                  .type === "Range"
                                  ? componentData.tempDependency.cardinality
                                    .range.min
                                  : ""
                              }
                              error={!!dependencyError.cardinality?.range?.min}
                              // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                              disabled={
                                (!isEdit && !showAddItem) ||
                                props.state.status === "P_PUBLISHED"
                              }
                            />
                            <Input
                              name={"max"}
                              style={{ width: "100px" }}
                              type={"number"}
                              placeholder={t("MAX_QUANTITY")}
                              className={classes.quantityInput}
                              variant={"outlined"}
                              onChange={(event) => dependencies(event)}
                              onKeyDown={(event) => {
                                // Prevent decimal point, 'e', '+', and '-' keys
                                if (event.key === '.' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
                                  event.preventDefault();
                                }
                              }}
                              value={
                                componentData.tempDependency.cardinality.range
                                  .max
                              }
                              error={!!dependencyError.cardinality?.range?.max}
                              // disabled={(!isEdit && !showAddItem) || props.state.statusDisplayName === 'Published'}
                              disabled={
                                (!isEdit && !showAddItem) ||
                                props.state.status === "P_PUBLISHED"
                              }
                            />
                          </>
                        )}
                      </Grid>

                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: "auto",
                        }}
                        style={{ display: "flex", alignItems: "center" }}
                      >

                        {!isEdit && !showAddItem
                          ? (props.userPerms.includes("CATALOG_ADMIN") ||
                            props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                            props.userPerms.includes("CATALOG_CREATE") ||
                            props.userPerms.includes("CATALOG_UPDATE")) &&
                          props.state.status !== "P_PUBLISHED" && (
                            // <Tooltip title={t("ADD_DEPENDENCY")}>
                            //   <IconButton
                            //     className="buttonSecondary"
                            //     style={{ marginLeft: "1rem" }}
                            //   >
                            //     <PlusIcon />
                            //   </IconButton>
                            // </Tooltip>
                            <Button
                              style={{ marginLeft: "1rem" }}
                              onClick={() => {
                                addDependencies();
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <PlusIcon />
                                <span style={{ marginLeft: "0.5rem" }}>
                                  {t("ADD_DEPENDENCY")}
                                </span>
                              </div>
                            </Button>
                          )
                          : // <Tooltip title={t('ADD_DEPENDENCY')}>
                          // 	<AddCircleIcon style={{ width: 32, height: 32 }} />
                          // </Tooltip>
                          // <Button disabled={true} style={{ marginTop: 2 }}>
                          // 	{t('ADD')}
                          // </Button>
                          (props.userPerms.includes("CATALOG_ADMIN") ||
                            props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                            props.userPerms.includes("CATALOG_CREATE") ||
                            props.userPerms.includes("CATALOG_UPDATE")) &&
                          props.state.status !== "P_PUBLISHED" && (
                            // <Tooltip title={t("ADD_DEPENDENCY")}>
                            //   <IconButton
                            //     className="button"
                            //     style={{ marginLeft: "1rem" }}
                            //     onClick={() => {
                            //       addDependencies();
                            //     }}
                            //   >
                            //     <PlusIcon />
                            //   </IconButton>
                            // </Tooltip>
                            <Button
                              style={{ marginLeft: "1rem" }}
                              onClick={() => {
                                addDependencies();
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <PlusIcon />
                                <span style={{ marginLeft: "0.5rem" }}>
                                  {t("ADD_DEPENDENCY")}
                                </span>
                              </div>
                            </Button>
                          )
                          // <Tooltip title={t('ADD_DEPENDENCY')}>
                          // 	<AddCircleIcon style={{ width: 32, height: 32 }}
                          // 		onClick={() => {
                          // 			addDependencies();
                          // 		}}
                          // 	/>
                          // </Tooltip>
                          // <Button onClick={() => { addDependencies(); }} style={{ marginTop: 2 }}>
                          // 	{t('ADD')}
                          // </Button>
                        }
                      </Grid>
                    </Grid>
                    {componentData.chipData &&
                      componentData.chipData.length > 0 && (
                        <Grid
                          item
                          size={{
                            xs: 12,
                          }}
                          style={{ marginTop: "1rem" }}
                        >
                          <Divider />
                        </Grid>
                      )}
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      {componentData.chipData &&
                        componentData.chipData.length > 0 && (
                          <Grid
                            item
                            style={{ marginTop: "1rem" }}
                            size={{
                              xs: 12,
                            }}
                          >
                            {componentData.chipData &&
                              componentData.chipData.map((chipVal, chipIndex) => (
                                <React.Fragment key={chipIndex}>
                                  <Chip
                                    label={getDependencyLabel(chipVal, componentData.name)}
                                    // label={
                                    //   "Is " +
                                    //   chipVal.dependencyType +
                                    //   " with " +
                                    //   getBucketName(chipVal.dependerBucketName) +
                                    //   " " +
                                    //   chipVal.dependerName +
                                    //   (chipVal.dependencyType === "Mandatory"
                                    //     ? ". Quantity "
                                    //     : chipVal.cardinality.range.max
                                    //       ? ". Quantity "
                                    //       : "") +
                                    //   (chipVal.dependencyType === "Mandatory"
                                    //     ? chipVal.cardinality.type === "Exact"
                                    //       ? "Exact: " + chipVal.cardinality.range.min
                                    //       : "Min:" +
                                    //       chipVal.cardinality.range.min +
                                    //       " Max:" +
                                    //       chipVal.cardinality.range.max
                                    //     : chipVal.cardinality.type === "Range" &&
                                    //       chipVal.cardinality.range.max &&
                                    //       chipVal.cardinality.range.min
                                    //       ? "Min:" +
                                    //       chipVal.cardinality.range.min +
                                    //       " Max:" +
                                    //       chipVal.cardinality.range.max
                                    //       : chipVal.cardinality.range.max
                                    //         ? " Exact:" +
                                    //         chipVal.cardinality.range.max
                                    //         : "")
                                    // }
                                    color="primary"
                                    variant="outlined"
                                    onDelete={() => removeTempDependency(chipIndex)}
                                    style={{ marginRight: "15px", marginBottom: 5 }}
                                    // disabled={props.state.statusDisplayName === 'Published'}
                                    disabled={props.state.status === "P_PUBLISHED"}
                                  />
                                </React.Fragment>
                              ))}
                          </Grid>
                        )}

                    </Grid>
                  </Box>
                </>
              )}
            {/* Dependency wrapper end */}
            {/* Variants panel start */}
            {componentData.variants && componentData.variants.length > 0 && (
              <>
                <Box
                  className="borderOutline roundCorners"
                  style={{ marginBottom: ".5rem" }}
                >
                  <Grid container spacing={2}>
                    <Grid
                      item
                      style={{ display: "flex", alignItems: "center" }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                        {t("VARIANT_DETAILS")}
                      </h3>
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      {componentData.variants.map((opt, variantIndex) => (
                        <div
                          className="smallTableWithBorder"
                          key={variantIndex}
                        >
                          <Grid
                            item
                            style={{ paddingLeft: "1rem", paddingTop: "1rem" }}
                            size={{
                              xs: 12,
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              {props.t("VARIANT") + " #" + (variantIndex + 1)}
                            </span>
                          </Grid>
                          <Grid
                            item
                            container
                            spacing={2}
                            style={{ padding: "1rem" }}
                          >
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 5,
                              }}
                            >
                              <Input
                                // error={!!props.err.variantName}
                                // helperText={props.err.variantName}
                                name={"name"}
                                value={opt.name}
                                onChange={(event) =>
                                  onVariantChange(event, variantIndex)
                                }
                                disabled={
                                  props.readonlyMode ||
                                  props.state.status === "P_PUBLISHED"
                                }
                                placeholder={t("NAME") + " *"}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 3,
                              }}
                            >
                              <Input
                                // error={!!props.err.variantProductCodeError}
                                // helperText={props.err.variantProductCodeError}
                                name={"featureCode"}
                                value={opt.featureCode}
                                onChange={(event) =>
                                  onVariantChange(event, variantIndex)
                                }
                                disabled={true}
                                placeholder={t("FEATURE_CODE") + " *"}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 12,
                              }}
                            >
                              <Input
                                name={"description"}
                                value={opt.description}
                                // error={!!props.err.variantDescription}
                                // helperText={props.err.variantDescription}
                                inputProps={{ rows: 2, cols: 31 }}
                                onChange={(event) =>
                                  onVariantChange(event, variantIndex)
                                }
                                // disabled={props.readonlyMode || props.state.statusDisplayName === 'Published'}
                                disabled={
                                  props.readonlyMode ||
                                  props.state.status === "P_PUBLISHED"
                                }
                                multiline={true}
                                placeholder={t("DESCRIPTION") + " *"}
                              />
                            </Grid>
                            {/* </TableCell> */}
                            {/* <TableCell style={{ width: '14%', border: 'none' }}>
																		<Input
																			name={'price'}
																			type={'number'}
																			value={opt.price}
																			// error={!!props.err.variantPrice}
																			// helperText={props.err.variantPrice}
																			onChange={event => onVariantChange(event, variantIndex)}
																			onKeyDown={event => {
																				// Intercept the letter "e" (Key code 69) and prevent its default behavior
																				if (event.keyCode === 69) {
																					event.preventDefault();
																				}
																			}}
																			disabled={true}
																		/>
																	</TableCell> */}
                            {/* <TableCell style={{ border: 'none' }} align="right"> */}

                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 3,
                              }}
                            >
                              {props.tenantRoles.includes("CHILD_PROVIDER") ? (
                                <Input
                                  divClass={classes.customDiv}
                                  name={"partnerPrice"}
                                  min={1}
                                  variant={"outlined"}
                                  type={"number"}
                                  size={"small"}
                                  placeholder={
                                    t("RECOMMENDED_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  value={Number(opt.groupPrice).toFixed(2)}
                                  disabled={true}
                                />
                              ) : (
                                <Input
                                  // error={!!errorr.price}
                                  // helperText={errorr.price}
                                  divClass={classes.customDiv}
                                  name={"price"}
                                  min={1}
                                  variant={"outlined"}
                                  type={"number"}
                                  size={"small"}
                                  onChange={(event) => {
                                    onChange(event);
                                    setErrorr({
                                      ...errorr,
                                      price: "",
                                    });
                                  }}
                                  onKeyDown={(event) => {
                                    // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                    if (event.keyCode === 69) {
                                      event.preventDefault();
                                    }
                                  }}
                                  placeholder={
                                    t("RECOMMENDED_PRICE") +
                                    " * : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  value={Number(opt.price).toFixed(2)}
                                  // disabled={(!isEdit && !showAddItem) || isAuxiliary || componentData.hasVariant || props.selectedBucketId === "PROD_COMP_PACKAGE"}
                                  disabled={true}
                                />
                              )}
                            </Grid>
                            {
                              // (props.tenantInfo.tenantId === componentData.originalProviderId &&
                              // 	props.providerType === "SALES_CHNL_PROVIDER"
                              // ) ? '' : (
                              props.tenantRoles.includes("CHILD_PROVIDER") ? (
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <Input
                                    // error={!!errorr.price}
                                    // helperText={errorr.price}
                                    divClass={classes.customDiv}
                                    name={"price"}
                                    min={1}
                                    variant={"outlined"}
                                    type={"number"}
                                    size={"small"}
                                    placeholder={
                                      t("SALES_PRICE") +
                                      " : (" +
                                      currencyFormatter("", false) +
                                      ")" +
                                      " *"
                                    }
                                    value={Number(opt.price).toFixed(2)}
                                    onChange={(event) => {
                                      onChange(event);
                                      setErrorr({
                                        ...errorr,
                                        price: "",
                                      });
                                    }}
                                    onKeyDown={(event) => {
                                      // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                      if (event.keyCode === 69) {
                                        event.preventDefault();
                                      }
                                    }}
                                    disabled={true}
                                  />
                                </Grid>
                              ) : (
                                ""
                              )
                              // )
                            }
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 3,
                              }}
                            >
                              <Input
                                // error={!!errorr.minimumPrice}
                                // helperText={errorr.minimumPrice}
                                divClass={classes.customDiv}
                                name={"minimumPrice"}
                                min={1}
                                variant={"outlined"}
                                type={"number"}
                                size={"small"}
                                onChange={(event) => {
                                  onChange(event);
                                  setErrorr({
                                    ...errorr,
                                    price: "",
                                  });
                                }}
                                onKeyDown={(event) => {
                                  // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                  if (event.keyCode === 69) {
                                    event.preventDefault();
                                  }
                                }}
                                placeholder={
                                  t("MINIMUM_PRICE") +
                                  " : (" +
                                  currencyFormatter("", false) +
                                  ")"
                                }
                                value={Number(opt.minimumPrice).toFixed(2)}
                                // disabled={(!isEdit && !showAddItem) || isAuxiliary || componentData.hasVariant || props.selectedBucketId === "PROD_COMP_PACKAGE"}
                                disabled={true}
                              />
                            </Grid>
                            {props.tenantInfo.tenantId ===
                              componentData.originalProviderId &&
                              props.providerType === "SALES_CHNL_PROVIDER" ? (
                              ""
                            ) : props.tenantRoles.includes("CHILD_PROVIDER") ? (
                              ""
                            ) : (
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 3,
                                }}
                              >
                                <Input
                                  divClass={classes.customDiv}
                                  name={"partnerPrice"}
                                  min={1}
                                  variant={"outlined"}
                                  type={"number"}
                                  size={"small"}
                                  placeholder={
                                    t("PARTNER_PRICE") +
                                    " : (" +
                                    currencyFormatter("", false) +
                                    ")"
                                  }
                                  value={Number(opt.originalPrice).toFixed(2)}
                                  disabled={true}
                                />
                              </Grid>
                            )}
                          </Grid>

                          {opt.otherPrices && opt.otherPrices.length > 0 && (
                            <>
                              <div style={{ marginBottom: "1rem" }}>
                                <Grid
                                  item
                                  style={{
                                    marginBottom: ".5rem",
                                    paddingLeft: "1rem",
                                    paddingTop: ".5rem",
                                  }}
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                    {t("OTHER_PRICES")}
                                  </h3>
                                </Grid>
                                {opt.otherPrices.map((price, pIndex) => (
                                  <div key={pIndex}>
                                    <Grid
                                      item
                                      container
                                      spacing={2}
                                      style={{
                                        paddingLeft: "1rem",
                                        paddingTop: ".5rem",
                                        paddingRight: "1rem",
                                      }}
                                    >
                                      <Grid item container spacing={2}>
                                        {/* <Grid item xs={2}>
																										<Input
																											// divClass={classes.customDiv}
																											// error={!!props.err.price}
																											// helperText={props.err.price}
																											name={'price'}
																											value={price.price}
																											onChange={event => props.onChangeOtherPriceVariant(event, pIndex, variantIndex)}
																											onKeyDown={event => {
																												// Intercept the letter "e" (Key code 69) and prevent its default behavior
																												if (event.keyCode === 69) {
																													event.preventDefault();
																												}
																											}}
																											placeholder={t('PRICE') + ' : (' + currencyFormatter('', false) + ')'}
																											type={'number'} size={'small'}
																											min={1} variant={'outlined'}
																											disabled={true}
																										/>
																									</Grid> */}
                                        <Grid
                                          item
                                          size={{
                                            xs: 12,
                                            md: 3,
                                          }}
                                        >
                                          {props.tenantRoles.includes(
                                            "CHILD_PROVIDER",
                                          ) ? (
                                            <Input
                                              // divClass={classes.customDiv}
                                              // error={!!errorr[`otherPrice_${price.priceType}`]}
                                              // helperText={errorr[`otherPrice_${price.priceType}`]}
                                              name={"originalPrice"}
                                              value={Number(
                                                price.groupPrice,
                                              ).toFixed(2)}
                                              placeholder={
                                                t("RECOMMENDED_PRICE") +
                                                " : (" +
                                                currencyFormatter("", false) +
                                                ")"
                                              }
                                              type={"number"}
                                              size={"small"}
                                              min={1}
                                              variant={"outlined"}
                                              disabled={true}
                                            />
                                          ) : (
                                            <Input
                                              // divClass={classes.customDiv}
                                              error={
                                                !!errorr[
                                                `otherPrice_${price.priceType}`
                                                ]
                                              }
                                              helperText={
                                                errorr[
                                                `otherPrice_${price.priceType}`
                                                ]
                                              }
                                              name={"price"}
                                              value={Number(
                                                price.price,
                                              ).toFixed(2)}
                                              onChange={(event) =>
                                                onChangeOtherPrice(
                                                  event,
                                                  price.priceType,
                                                )
                                              }
                                              onKeyDown={(event) => {
                                                // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                                if (event.keyCode === 69) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              placeholder={
                                                t("RECOMMENDED_PRICE") +
                                                " : (" +
                                                currencyFormatter("", false) +
                                                ")"
                                              }
                                              type={"number"}
                                              size={"small"}
                                              min={1}
                                              variant={"outlined"}
                                              disabled={true}
                                            />
                                          )}
                                        </Grid>
                                        {
                                          // (props.tenantInfo.tenantId === componentData.originalProviderId &&
                                          // 	props.providerType === "SALES_CHNL_PROVIDER"
                                          // ) ? '' : (
                                          props.tenantRoles.includes(
                                            "CHILD_PROVIDER",
                                          ) ? (
                                            <Grid
                                              item
                                              size={{
                                                xs: 12,
                                                md: 3,
                                              }}
                                            >
                                              <Input
                                                // divClass={classes.customDiv}
                                                // error={!!errorr[`otherPrice_${price.priceType}`]}
                                                // helperText={errorr[`otherPrice_${price.priceType}`]}
                                                name={"price"}
                                                value={Number(
                                                  price.price,
                                                ).toFixed(2)}
                                                onChange={(event) =>
                                                  onChangeOtherPrice(
                                                    event,
                                                    price.priceType,
                                                  )
                                                }
                                                onKeyDown={(event) => {
                                                  // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                                  if (event.keyCode === 69) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                placeholder={
                                                  t("SALES_PRICE") +
                                                  " : (" +
                                                  currencyFormatter("", false) +
                                                  ")" +
                                                  " *"
                                                }
                                                type={"number"}
                                                size={"small"}
                                                min={1}
                                                variant={"outlined"}
                                                disabled={true}
                                              />
                                            </Grid>
                                          ) : (
                                            ""
                                          )
                                          // )
                                        }
                                        <Grid
                                          item
                                          size={{
                                            xs: 12,
                                            md: 3,
                                          }}
                                        >
                                          <Input
                                            // divClass={classes.customDiv}
                                            // error={!!props.err.price}
                                            // helperText={props.err.price}
                                            name={"minimumPrice"}
                                            value={Number(
                                              price.minimumPrice,
                                            ).toFixed(2)}
                                            onChange={(event) =>
                                              onChangeOtherPrice(
                                                event,
                                                price.priceType,
                                              )
                                            }
                                            onKeyDown={(event) => {
                                              // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                              if (event.keyCode === 69) {
                                                event.preventDefault();
                                              }
                                            }}
                                            placeholder={
                                              t("MINIMUM_PRICE") +
                                              " : (" +
                                              currencyFormatter("", false) +
                                              ")"
                                            }
                                            type={"number"}
                                            size={"small"}
                                            min={1}
                                            variant={"outlined"}
                                            disabled={true}
                                          />
                                        </Grid>
                                        {props.tenantInfo.tenantId ===
                                          componentData.originalProviderId &&
                                          props.providerType ===
                                          "SALES_CHNL_PROVIDER" ? (
                                          ""
                                        ) : props.tenantRoles.includes(
                                          "CHILD_PROVIDER",
                                        ) ? (
                                          ""
                                        ) : (
                                          <Grid
                                            item
                                            size={{
                                              xs: 12,
                                              md: 3,
                                            }}
                                          >
                                            <Input
                                              divClass={classes.customDiv}
                                              name={"partnerPrice"}
                                              min={1}
                                              variant={"outlined"}
                                              type={"number"}
                                              size={"small"}
                                              placeholder={
                                                t("PARTNER_PRICE") +
                                                " : (" +
                                                currencyFormatter("", false) +
                                                ")"
                                              }
                                              value={Number(
                                                price.originalPrice,
                                              ).toFixed(2)}
                                              disabled={true}
                                            />
                                          </Grid>
                                        )}
                                        <Grid
                                          item
                                          size={{
                                            xs: 12,
                                            md: 3,
                                          }}
                                        >
                                          <FormControl
                                            variant="outlined"
                                            size={"small"}
                                            className={
                                              classes.customeSelectLabel
                                            }
                                          >
                                            <InputLabel
                                              id={"priceTypeLabel" + pIndex}
                                            >
                                              {t("SELECT_PRICE_TYPE") + " *"}
                                            </InputLabel>
                                            <Select
                                              //disabled={props.mode === 'edit'}
                                              value={
                                                price.priceType
                                                  ? price.priceType
                                                  : ""
                                              }
                                              native
                                              labelId={
                                                "priceTypeLabel" + pIndex
                                              }
                                              label={
                                                t("SELECT_PRICE_TYPE") + " * "
                                              }
                                              onChange={(event) =>
                                                props.onChangeOtherPriceVariant(
                                                  event,
                                                  pIndex,
                                                  variantIndex,
                                                )
                                              }
                                              inputProps={{
                                                name: "priceType",
                                                id: "priceType" + pIndex,
                                              }}
                                              disabled={true}
                                            >
                                              {/* <option value=""></option> */}
                                              {/* {props.priceOptions.map(a => (
																														<option key={a.value} value={a.value} disabled={a.disabled}>{t(a.name)}</option>
																													))} */}
                                              <option
                                                value="DEPOSIT"
                                              // disabled={componentData.otherPrices.findIndex((x) => x.priceType === "DEPOSIT") > -1 ? true : false}
                                              >
                                                {t("DEPOSIT_PRICE")}
                                              </option>
                                              <option
                                                value="CANCELLATION_PRICE"
                                              // disabled={componentData.otherPrices.findIndex((x) => x.priceType === "CANCELLATION_PRICE") > -1 ? true : false}
                                              >
                                                {t("CANCELLATION_PRICE")}
                                              </option>
                                              <option
                                                value="SHIFT_PRICE"
                                              // disabled={componentData.otherPrices.findIndex((x) => x.priceType === "SHIFT_PRICE") > -1 ? true : false}
                                              >
                                                {t("SHIFT_PRICE")}
                                              </option>
                                              <option
                                                value="SUSPENSION_PRICE"
                                              // disabled={componentData.otherPrices.findIndex((x) => x.priceType === "SUSPENSION_PRICE") > -1 ? true : false}
                                              >
                                                {t("SUSPENSION_PRICE")}
                                              </option>
                                              <option
                                                value="REACTIVATION_PRICE"
                                              // disabled={componentData.otherPrices.findIndex((x) => x.priceType === "REACTIVATION_PRICE") > -1 ? true : false}
                                              >
                                                {t("REACTIVATION_PRICE")}
                                              </option>
                                              <option
                                                value="USAGE_CHARGE"
                                              // disabled={componentData.otherPrices.findIndex((x) => x.priceType === "USAGE_CHARGE") > -1 ? true : false}
                                              >
                                                {t("USAGE_CHARGE")}
                                              </option>
                                            </Select>
                                          </FormControl>
                                        </Grid>
                                        {price.priceType === "USAGE_CHARGE" ? (
                                          <Grid
                                            item
                                            size={{
                                              xs: 12,
                                              md: 3,
                                            }}
                                          >
                                            <FormControl
                                              variant="outlined"
                                              size={"small"}
                                              className={
                                                classes.customeSelectLabel
                                              }
                                            >
                                              <InputLabel
                                                id={
                                                  "priceTenureUOMLabel" + pIndex
                                                }
                                              >
                                                {t("USAGE_CHARGE_UOM")}
                                              </InputLabel>
                                              <Select
                                                //disabled={props.mode === 'edit'}
                                                value={
                                                  price.priceTenureUOM
                                                    ? price.priceTenureUOM
                                                    : ""
                                                }
                                                native
                                                label={t("USAGE_CHARGE_UOM")}
                                                labelId={
                                                  "priceTenureUOMLabel" + pIndex
                                                }
                                                onChange={(event) =>
                                                  props.onChangeOtherPriceVariant(
                                                    event,
                                                    pIndex,
                                                    variantIndex,
                                                  )
                                                }
                                                inputProps={{
                                                  name: "priceTenureUOM",
                                                  id: "priceTenureUOM" + pIndex,
                                                }}
                                                disabled={true}
                                              >
                                                <option value={"TF_hr"}>
                                                  {t("HOURLY")}
                                                </option>
                                                <option value={"TF_day"}>
                                                  {t("DAILY")}
                                                </option>
                                                <option value={"TF_wk"}>
                                                  {t("WEEKLY")}
                                                </option>
                                                <option value={"TF_mon"}>
                                                  {t("MONTHLY")}
                                                </option>
                                                <option value={"TF_yr"}>
                                                  {t("YEARLY")}
                                                </option>
                                                <option value={"DATA_MB"}>
                                                  {t("PER_MB")}
                                                </option>
                                                <option value={"DATA_GB"}>
                                                  {t("PER_GB")}
                                                </option>
                                              </Select>
                                            </FormControl>
                                          </Grid>
                                        ) : (
                                          ""
                                        )}
                                      </Grid>
                                    </Grid>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}
            {/* Variants panel end */}
            {/* Custom attributes panel start */}
            {componentData.customAttributes &&
              componentData.customAttributes.length > 0 && (
                <Box
                  className="borderOutline roundCorners"
                  style={{ marginBottom: ".5rem" }}
                >
                  <Grid container spacing={2}>
                    <Grid
                      item
                      style={{ paddingLeft: "1rem", paddingTop: "1rem" }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                        {t("CUSTOM_ATTRIBUTES")}
                      </h3>
                    </Grid>
                    <Grid
                      item
                      style={{ paddingTop: 0 }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <CustomAttributes
                        mode={"readonly"}
                        data={componentData.customAttributes}
                        onChangeAttribute={onChangeAttribute}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
            {/* Custom attributes panel end */}
            <Grid
              item
              style={{ marginTop: "1rem" }}
              size={{
                xs: 12,
              }}
            >
              <label style={mandatoryMessageSecond}>
                {t("MANDATORY_FIELDS_MESSAGE")}
              </label>
            </Grid>
          </React.Fragment>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Box style={{ width: '100%' }}>
            <Grid container spacing={2}>
              <Grid
                item
                align="left"
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                {/* Solution Provider : {showAddItem ? componentData.fromProviderName : ""} */}
                {showAddItem ? (
                  <>
                    {t("SOLUTION_PROVIDER")} : {componentData.fromProviderName}
                  </>
                ) : (
                  ""
                )}
              </Grid>
              <Grid
                item
                align="right"
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                {!isEdit ? (
                  <>
                    {showAddItem ? (
                      <>
                        <Button
                          className="buttonSecondary"
                          onClick={() => {
                            cancelUpdate();
                          }}
                        >
                          {t("CANCEL")}
                        </Button>
                        {(props.userPerms.includes("CATALOG_ADMIN") ||
                          props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                          props.userPerms.includes("CATALOG_CREATE") ||
                          props.userPerms.includes("CATALOG_UPDATE")) && (
                            <Button
                              style={{ marginLeft: "15px" }}
                              onClick={() => {
                                componentData.tempDependency.dependerBucketName ||
                                  componentData.tempDependency.depender
                                  ? setDependencyWarning(true)
                                  : addBucketItem();
                              }}
                            >
                              {t("ADD_ITEM")}
                            </Button>
                          )}
                      </>
                    ) : (
                      <>
                        {/* <Button
												onClick={() => {
													openTemplateDialog();
												}}
											>
												{t('CHOOSE_EXISTING')}
											</Button> */}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Button
                      className="buttonSecondary"
                      onClick={() => {
                        cancelUpdate();
                      }}
                    >
                      {t("CANCEL")}
                    </Button>
                    {(props.userPerms.includes("CATALOG_ADMIN") ||
                      props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                      props.userPerms.includes("CATALOG_CREATE") ||
                      props.userPerms.includes("CATALOG_UPDATE")) &&
                      props.state.status !== "P_PUBLISHED" && (
                        <Button
                          style={{ marginLeft: "15px" }}
                          onClick={() => {
                            componentData.tempDependency.dependerBucketName ||
                              componentData.tempDependency.depender
                              ? setDependencyWarning(true)
                              : updateBucketItem();
                          }}
                        >
                          {t("UPDATE_ITEM")}
                        </Button>
                      )}
                  </>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        disableScrollLock={true}
        maxWidth={"md"}
        PaperComponent={DraggableDialogPaper}
        fullWidth={true}
        open={stateChangeDialog}
        aria-labelledby="delete-dialog-title"
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "98%" }}>
              {t("STATE_CHANGE_HEADING")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => stateChangeDialogResponse(false)}
                onClick={() => stateChangeDialogResponse(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {(props.packageMode != "edit" ||
              (props.packageMode == "edit" &&
                props.status != "P_IN_REVIEW")) && (
                <>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      divClass={classes.customDiv}
                      placeholder={t("COMMENT")}
                      name={"comment"}
                      onChange={(event) => props.addPackageReviewComments(event)}
                      variant={"outlined"}
                      inputProps={{ rows: 3, cols: 50 }}
                      size={"small"}
                      multiline={true}
                    />
                  </Grid>

                  <>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <>
                        {stateChangeDialogAction === "P_RETIRED" ? (
                          <>{t("STATE_CHANGE_RETIRE")}</>
                        ) : stateChangeDialogAction === "P_OBSOLETE" ? (
                          <>{t("STATE_CHANGE_OBSOLETE")}</>
                        ) : (
                          <>{t("STATE_CHANGE_TO_PUBLISH")}</>
                        )}
                      </>

                      <FormControl className={classes.billingTriggerPhase}>
                        <RadioGroup
                          aria-label="activationTrigger"
                          name="stateChangeAction"
                          row
                          onChange={selectStateChangeRadioResponse}
                          style={{ paddingLeft: "8px" }}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio color="primary" />}
                            label={t("YES")}
                            labelPlacement="right"
                            style={{ paddingRight: "14px" }}
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio color="primary" />}
                            label={t("NO")}
                            labelPlacement="right"
                            style={{ paddingRight: "14px" }}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </>
                </>
              )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <>
            {/* <Button onClick={event => stateChangeDialogResponse(false)} color="primary">{t('NO')}</Button> */}
            <Button
              onClick={(event) =>
                stateChangeDialogResponse(stateChangeRadioResponse)
              }
              color="primary"
            >
              {t("SUBMIT")}
            </Button>
          </>
        </DialogActions>
      </Dialog>
      {/* Select package templates : Starts*/}
      {packageTemplateDialog && (
        <PackageTemplate
          open={packageTemplateDialog}
          components={props.currentBucketItems}
          //solutionPlansCopy={this.state.solutionPlans}
          close={closePackageTemplateDialog}
          component={props.selectedBucketId}
          name={props.bucketName}
          addComponent={openComponentDialog}
          provisioningResources={provisioningResourceList}
          activationResources={activationResourceList}
          suspendResources={suspendResourceList}
          resumeResources={resumeResourceList}
          categoryId={props.basicDetail.categoryId}
          selectedCustomer={props.selectedCustomer}
          bulkAddBucketItem={bulkAddBucketItem}
        ></PackageTemplate>
      )}
      {/* Select package templates : Ends*/}
      {/* Add Component Dialog */}
      {showAddComponent && (
        <ComponentDialog
          open={showAddComponent}
          mode={"add"}
          componentType={props.selectedBucketId}
          closeDialog={closeComponentDialog}
          tabName={props.bucketName}
          provisioningResources={provisioningResourceList}
          activationResources={activationResourceList}
          suspendResources={suspendResourceList}
          resumeResources={resumeResourceList}
          // editData={state.objectToEdit}
          addComponentType={addComponentType}
          preQualResourcesList={preQualResourcesList}
          productErrorMessage={productErrorMessage}
          // sellable product
          categoryList={props.categoryList}
          originalBucketsData={props.originalBucketsData}
          channelList={props.channelList}
          resetErrorMessage={resetErrorMessage}
          disableOtherPriceOption={disableOtherPriceOption}
          priceOptions={componentData.priceOptions}
          selectedCustomer={props.selectedCustomer}
        />
      )}
      {showProductDetails && (
        <ViewProductDetails
          showProductDetails={showProductDetails}
          closeProductDetailsDialog={setViewPorductDetails}
          setProductDetails={setProductDetails}
          provisioningResources={provisioningResourceList}
          activationResources={activationResourceList}
          suspendResources={suspendResourceList}
          resumeResources={resumeResourceList}
          product={productDetails}
        />
      )}
      {/* save as new offering dialog */}
      {saveAsOfferingDialog && (
        <Dialog
          disableScrollLock={true}
          maxWidth={"sm"}
          PaperComponent={DraggableDialogPaper}
          fullWidth={true}
          open={saveAsOfferingDialog}
          aria-labelledby="delete-dialog-title"
        // PaperProps={{
        // 	className: classess.resizablePaper
        // }}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {t("SAVE_AS_NEW_SOLUTION")}
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <Grid container spacing={3} justifyContent="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <Input
                    size={"small"}
                    name={"productName"}
                    variant={"outlined"}
                    placeholder={t("NAME") + " *"}
                    value={props.state.basicDetail.productName}
                    onChange={(event) => props.saveAsChange(event)}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <Input
                    size={"small"}
                    name={"featureCode"}
                    variant={"outlined"}
                    placeholder={t("FEATURE_CODE") + " *"}
                    value={props.state.basicDetail.featureCode}
                    onChange={(event) => props.saveAsChange(event)}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="buttonSecondary"
              onClick={(event) => setSaveAsOfferingDialog(false)}
              color="primary"
            >
              {t("CLOSE")}
            </Button>
            <Button
              onClick={(event) => {
                props.submitPackageJSON(
                  "NEW_SOLUTION",
                  showAssemblyInstructions,
                );
                setSaveAsOfferingDialog(false);
              }}
              color="primary"
            >
              {t("SAVE")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* delete component confirmation */}
      <Dialog
        maxWidth={"sm"}
        PaperComponent={DraggableDialogPaper}
        fullWidth={true}
        open={openRemoveComponentConfirmation}
        aria-labelledby="delete-dialog-title"
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("REMOVE_COMPONENT")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => removeComponent(false)}
                onClick={() => removeComponent(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {t("REMOVE_COMPONENT_CONFIRMATION", { selectedToRemove })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => removeComponent(false)} color="primary">
            {t("NO")}
          </Button>
          <Button onClick={(event) => removeComponent(true)} color="primary">
            {t("YES")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Unapplied markup found */}
      <Dialog
        maxWidth={"sm"}
        PaperComponent={DraggableDialogPaper}
        fullWidth={true}
        open={markupWarning}
        aria-labelledby="delete-dialog-title"
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("UNAPPLIED_MARKUP")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => closeMarkupWarning(false)}
                onClick={() => closeMarkupWarning(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>{t("UNAPPLIED_MARKUP_MESSAGE")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(event) => closeMarkupWarning(false)}
            color="primary"
          >
            {t("NO")}
          </Button>
          <Button onClick={(event) => closeMarkupWarning(true)} color="primary">
            {t("YES")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Unsaved changes warning modal */}
      <UnsavedChangesWarning
        open={openUnsavedChangesModal}
        close={closeUnsavedChangesDialog}
      ></UnsavedChangesWarning>
      <UnsavedDependencyWarning
        open={openDependencyWarning}
        close={closeDependencyWarning}
      />
      {tempEditRow &&
        tempEditRow.productSpec &&
        Object.keys(tempEditRow.productSpec).length > 0 ? (
        <OfferingProductSpecCharacteristicsExistingDialog
          t={props.t}
          open={openTreeDialog}
          productId={selectedProductId}
          productName={selectedProductName}
          onClose={handleCloseTreeDialog}
          componentProductCharacteristics={
            tempEditRow.productSpec ? tempEditRow.productSpec : {}
          }
          onCharacteristicsChange={handleCharacteristicsUpdate}
          changedCharacteristics={selectedCharacteristics || []}
        />
      ) : (
        <OfferingProductSpecCharacteristicsDialog
          t={props.t}
          open={openTreeDialog}
          productId={selectedProductId}
          productName={selectedProductName}
          onClose={handleCloseTreeDialog}
          onCharacteristicsChange={handleCharacteristicsUpdate}
          changedCharacteristics={selectedCharacteristics || []}
        />
      )}
    </div>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    roles: state.auth.roles,
    userPerms: state.auth.userPerms,
    tenantInfo: state.auth.tenantInfo,
    tenantRoles: state.auth.tenantRoles,
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    tenantData: state.auth.tenantData,
    menuPaths: state.auth.menuPaths,
    enabledFeatures: state.auth.enabledFeatures,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AssociatedBucket));
